export const maharashtra = {
  type: 'FeatureCollection',
  features: [
    {
      id: '0',
      type: 'Feature',
      properties: {
        Name: 'AHAMADNAGAR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'AHAMADNAGAR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '466',
        Shape_Leng: 1367400,
        Shape_Area: 16550800000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.46807032466522, 19.99498524334628],
            [74.4453881222077, 19.97469339369822],
            [74.38242325932279, 19.98135535714523],
            [74.36277192959324, 19.96510865501364],
            [74.34727231572606, 19.98454806440848],
            [74.31607893565854, 19.98547623251018],
            [74.30308178119698, 19.96667224914138],
            [74.2853749836875, 19.98619095274901],
            [74.28108496130129, 19.95726921412616],
            [74.24783848914052, 19.9629781319958],
            [74.2477123951768, 19.93549339704309],
            [74.27274132644055, 19.93272023743426],
            [74.2745562369984, 19.9064362553904],
            [74.36314594142546, 19.87143740486745],
            [74.37424699039256, 19.80216047419504],
            [74.32683022000253, 19.79569830444098],
            [74.31684878799682, 19.76514043078019],
            [74.27468557711677, 19.77733047310199],
            [74.2465191624063, 19.74443990670156],
            [74.16638749313692, 19.72991379232132],
            [74.11972428216069, 19.64260746243178],
            [74.02105295611229, 19.67383968447897],
            [73.92551487012098, 19.67219221519234],
            [73.89515277737816, 19.71608874309162],
            [73.89848176940176, 19.74725301554227],
            [73.85486531502752, 19.74698172219496],
            [73.83675672987259, 19.74045681007531],
            [73.80969579055798, 19.68209078105671],
            [73.7940445163095, 19.68823940484947],
            [73.80576641326043, 19.67696276031971],
            [73.77761900335149, 19.65219940026223],
            [73.7923767095913, 19.64116897869069],
            [73.71255811012072, 19.61655533432342],
            [73.69640658748175, 19.59148876964337],
            [73.63056655278255, 19.59460412927315],
            [73.61560598178269, 19.58452872910222],
            [73.614375452677, 19.57674048383128],
            [73.62772275553596, 19.57166948324068],
            [73.62260878398264, 19.54207897425602],
            [73.65692716630893, 19.53683673822368],
            [73.66456673909863, 19.51211551846784],
            [73.67962101320785, 19.51875738674885],
            [73.68628628898807, 19.50014619693977],
            [73.70798859265736, 19.49605415055542],
            [73.68460197152693, 19.44480228098449],
            [73.73071695765813, 19.4302312656583],
            [73.7359210454597, 19.40754271902648],
            [73.77144056425, 19.3864752491218],
            [73.80752284067962, 19.39309882276492],
            [73.85347731675857, 19.35555161216421],
            [73.89112043329312, 19.37220972359075],
            [73.92686729947457, 19.3387126047456],
            [73.99941876966663, 19.35943714245696],
            [74.02528000734145, 19.31200898138689],
            [74.00564752786366, 19.29359673071953],
            [74.02981988254027, 19.28290760588287],
            [74.03090705311035, 19.24966402416761],
            [74.0449479905148, 19.26192306718893],
            [74.04963910328395, 19.24355330081213],
            [74.08925779263731, 19.22820876988381],
            [74.08372222622319, 19.23906909563947],
            [74.15129641174731, 19.22572960599731],
            [74.15712014012422, 19.20422931998475],
            [74.16847451241324, 19.22415041037004],
            [74.21986144548556, 19.20286519451305],
            [74.26034872585387, 19.22646319385724],
            [74.31616295458907, 19.20783705884189],
            [74.26438792452102, 19.17941776077428],
            [74.23466607312429, 19.12274130210211],
            [74.21159448990606, 19.12878179739423],
            [74.17394094646046, 19.03142677489344],
            [74.21273085848325, 19.00877052156046],
            [74.22223972543078, 18.97055144288273],
            [74.29475851340139, 18.90351196696564],
            [74.30849810697246, 18.85296277398162],
            [74.3278992509009, 18.83696052366958],
            [74.34709128600845, 18.84565060478532],
            [74.3972882278279, 18.82834848745933],
            [74.38438726332362, 18.80494830739222],
            [74.39802396220749, 18.74215481826197],
            [74.42514404550589, 18.74664534358428],
            [74.44008858723453, 18.72217225863319],
            [74.4759038316507, 18.7224958771136],
            [74.47597793488, 18.68687039576126],
            [74.50962393772664, 18.66879505784148],
            [74.47136445578825, 18.64173120606759],
            [74.50910191293997, 18.61342199070865],
            [74.55236822667207, 18.60899053925102],
            [74.54086281570852, 18.58226004469617],
            [74.57759324323422, 18.54741611459674],
            [74.54726556058533, 18.50767455770991],
            [74.58113988944278, 18.47252023101066],
            [74.64702621642321, 18.45016854262446],
            [74.67469476948973, 18.46277608077533],
            [74.65604156007078, 18.47332269086946],
            [74.65977445240578, 18.4900965369993],
            [74.70762170596971, 18.50428069587155],
            [74.72767558060472, 18.48215139612749],
            [74.71608708545959, 18.43209969658208],
            [74.73075724454064, 18.40131149874093],
            [74.7933946048987, 18.40198189614192],
            [74.8095811418954, 18.38369950251668],
            [74.79918874654489, 18.35165910120589],
            [74.85169456099328, 18.32994369799352],
            [74.86734647029168, 18.35271557127696],
            [74.90805217433207, 18.3567776244304],
            [74.9146828034844, 18.37862510833958],
            [75.00538723297598, 18.4033396808617],
            [75.01544428103243, 18.43671426496065],
            [75.0794427168165, 18.42341407712182],
            [75.13458945547129, 18.52649628577226],
            [75.20162734719213, 18.53131846115227],
            [75.21349938879568, 18.55407124019983],
            [75.2664565817783, 18.50825760551498],
            [75.32972792179481, 18.52364472252969],
            [75.34267739993916, 18.56090256170254],
            [75.41483147432855, 18.53058982856101],
            [75.4616434006145, 18.60568693431821],
            [75.54599065747531, 18.64440302728514],
            [75.54441369538178, 18.68152642923816],
            [75.58128481540228, 18.68386805264798],
            [75.58245833796677, 18.69846025199998],
            [75.55322006964434, 18.70804194093682],
            [75.55551727622422, 18.73659813015717],
            [75.52496256575834, 18.75263950867436],
            [75.5266878839547, 18.73320929096102],
            [75.50738484310703, 18.72332534468739],
            [75.45055903661141, 18.75114917182739],
            [75.43863653909192, 18.79892293985419],
            [75.39944728628348, 18.83157697082362],
            [75.37970946644505, 18.76921841256405],
            [75.3274615960826, 18.80124886993673],
            [75.2549501642763, 18.72021243432339],
            [75.1716264625622, 18.73647769318709],
            [75.15616598344751, 18.64214341822308],
            [75.01265703565166, 18.77517196401796],
            [75.00905384309334, 18.80445566568899],
            [74.98606821635525, 18.79756565521503],
            [74.9737090641295, 18.82828714217144],
            [74.92739215230853, 18.8260294853197],
            [74.91834616630662, 18.85320752707921],
            [74.89468898997372, 18.84671835823706],
            [74.88404150715452, 18.91410957931255],
            [74.8647611370691, 18.89761108916425],
            [74.84583096587171, 18.91053688484508],
            [74.82503580442629, 18.93226031258909],
            [74.83580367106339, 18.95344412484492],
            [74.8082301419218, 18.97692552686976],
            [74.82480335940657, 18.9904835375147],
            [74.83607739082173, 18.96993872526285],
            [74.87136652942453, 18.98502989194931],
            [74.89948096862712, 18.98007377604763],
            [74.91359132739201, 18.95889533843577],
            [74.95256171296056, 18.97151374399461],
            [74.94960938842944, 19.03283295538377],
            [74.91441343296036, 19.03750631809826],
            [74.94246355190897, 19.13323979976789],
            [74.9738023107996, 19.11098575816771],
            [75.02355348467266, 19.11493730646276],
            [75.02437912078373, 19.10272554532018],
            [75.05854597883369, 19.09838379140279],
            [75.07375130269979, 19.10169444219223],
            [75.06898102925501, 19.1213519108565],
            [75.10935584238945, 19.12486062826564],
            [75.09735704021004, 19.07793297282803],
            [75.0784362377883, 19.07872838978805],
            [75.09197029501823, 19.06810300251338],
            [75.07079894180994, 19.05537738325386],
            [75.16781682565538, 19.03580850489611],
            [75.18290541593952, 19.01166969440817],
            [75.2098104847607, 19.02927464282916],
            [75.18611956163399, 19.05161766109977],
            [75.19714807628537, 19.06699324121184],
            [75.18738827046361, 19.09256063046135],
            [75.21999129420674, 19.11167222442043],
            [75.22449193029306, 19.06578442520551],
            [75.26146763873334, 19.06994605394293],
            [75.25613902922271, 19.02574116691166],
            [75.27428941601265, 18.99193933424266],
            [75.31576530340361, 18.98047879959137],
            [75.34063056491568, 18.99004265278961],
            [75.33900994916105, 19.0293548402529],
            [75.28318079698941, 19.03443543548774],
            [75.2929208445057, 19.07616862198621],
            [75.28087579151912, 19.08498164682375],
            [75.30689689986991, 19.09861359551753],
            [75.36450733621248, 19.08130876491306],
            [75.36079685091762, 19.10862931631454],
            [75.33113664565222, 19.13217546146236],
            [75.33978767205139, 19.15590407459278],
            [75.35146760065531, 19.1269854775576],
            [75.40752341609011, 19.14101196228938],
            [75.36874124061272, 19.08174043822991],
            [75.44475969913348, 19.0931811943798],
            [75.44945279556748, 19.08323550460373],
            [75.48516541137343, 19.10586545354657],
            [75.4837075160831, 19.12792775985407],
            [75.43097971405959, 19.11781911203334],
            [75.42329908498341, 19.13862373161048],
            [75.45365751354407, 19.14462749843245],
            [75.4493247396606, 19.16396238933886],
            [75.40158796863254, 19.19745575762522],
            [75.42190286374773, 19.2214953002474],
            [75.444918684944, 19.21940314515934],
            [75.45870199258088, 19.25022667524519],
            [75.51978680797974, 19.27777305174936],
            [75.54301398701273, 19.32319178209813],
            [75.51720605222305, 19.33081625763961],
            [75.53206877560343, 19.37691757892372],
            [75.48530140163992, 19.38136927728874],
            [75.48821065213463, 19.4166529137345],
            [75.47543630958235, 19.42333794943566],
            [75.44262452113236, 19.41404210286776],
            [75.44113706983187, 19.4270157354462],
            [75.36515281709531, 19.39690231741004],
            [75.336933558346, 19.40704062872862],
            [75.35703170708267, 19.4319586026228],
            [75.34690288942811, 19.44900173997168],
            [75.32703335485671, 19.43856103897213],
            [75.32319971449091, 19.46572832662831],
            [75.35810856824324, 19.48266157595367],
            [75.35654511084465, 19.50174133962726],
            [75.32744340499676, 19.48377300618428],
            [75.32888432341302, 19.50842714295715],
            [75.3117996076021, 19.49575392301352],
            [75.27365835804488, 19.51525615866119],
            [75.27411477657266, 19.55435254236846],
            [75.25681952723689, 19.52325261442126],
            [75.20633230884616, 19.56215817483029],
            [75.19405038543023, 19.59485370420176],
            [75.05916456832433, 19.60570224207047],
            [75.03776367031948, 19.62584397304141],
            [74.99866593727585, 19.62401967357355],
            [74.96277445152195, 19.64713666630229],
            [74.93118004818716, 19.63690511140341],
            [74.91377089503314, 19.64820438631197],
            [74.88796614390272, 19.63904473000974],
            [74.88304149672543, 19.65447018718589],
            [74.84879031958951, 19.64636631918319],
            [74.78427359167111, 19.73433651187123],
            [74.7353185300293, 19.76490896089074],
            [74.72147138719302, 19.75465853987039],
            [74.7144287546231, 19.78014811905435],
            [74.69527342019178, 19.75500579857586],
            [74.63678354955435, 19.79304416269535],
            [74.61189155089362, 19.76994577697503],
            [74.59232286427617, 19.77582518975218],
            [74.60289633656761, 19.84696250791641],
            [74.65688042378683, 19.83487196613929],
            [74.64598793987439, 19.90928727174125],
            [74.67706563223278, 19.9241384606423],
            [74.67100414950052, 19.94697441270318],
            [74.56864715878866, 19.95429833484949],
            [74.52289692542901, 19.97658159161904],
            [74.47922204510279, 19.96401634759929],
            [74.48175598820345, 19.99478121797624],
            [74.46807032466522, 19.99498524334628]
          ]
        ]
      }
    },
    {
      id: '1',
      type: 'Feature',
      properties: {
        Name: 'AKOLA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'AKOLA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '467',
        Shape_Leng: 611947,
        Shape_Area: 5247080000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [77.04814058824205, 21.23906310776846],
            [77.01364670076008, 21.23745848310424],
            [76.9982133650571, 21.19581035943604],
            [76.77291162130156, 21.18494472863577],
            [76.77177192017797, 21.1491773463613],
            [76.79068288467955, 21.12089182331635],
            [76.77328648454385, 21.08453417921298],
            [76.78133907714789, 21.05127820959122],
            [76.76357071943865, 21.03737639939062],
            [76.79390286900697, 21.02711547002688],
            [76.79618428036288, 21.0040365063901],
            [76.77585137512325, 20.9901149475953],
            [76.81135066264905, 20.96018019064543],
            [76.78913023453163, 20.96253459444107],
            [76.77579619246869, 20.93143677655952],
            [76.78811523258793, 20.92791762905355],
            [76.78413543562614, 20.90805591204476],
            [76.74448370158883, 20.9286179703579],
            [76.6911173307736, 20.91783761711257],
            [76.72670897377766, 20.88360785968366],
            [76.74458489758605, 20.88727592710611],
            [76.76439405179333, 20.85710004055571],
            [76.74446416249073, 20.80295450529591],
            [76.77294074506791, 20.77656833723061],
            [76.75401373272348, 20.73864649282832],
            [76.76337206800746, 20.72034070637816],
            [76.73583034246677, 20.71630437703516],
            [76.72283150837654, 20.68996239930873],
            [76.73937978030845, 20.68720771138748],
            [76.73231493898267, 20.65570184893871],
            [76.75911927781429, 20.65169590954655],
            [76.74994484671028, 20.63013892272546],
            [76.77058851343092, 20.62631383364426],
            [76.76065248627629, 20.60281480555754],
            [76.78887968368679, 20.59522815902023],
            [76.7687601117314, 20.57571754921439],
            [76.78313625884863, 20.57251786627974],
            [76.77043986087034, 20.51786266287469],
            [76.7352624282827, 20.49308061589772],
            [76.73543091908549, 20.51138337529183],
            [76.71567813125057, 20.5154382450733],
            [76.71137702137331, 20.47326013815688],
            [76.69307251083944, 20.45912873965531],
            [76.72653160322285, 20.40706762595679],
            [76.69994457293454, 20.35195670576996],
            [76.79234563314914, 20.31416528727322],
            [76.78604874679924, 20.28944214630071],
            [76.81166947265588, 20.27796522694036],
            [76.85218395282094, 20.30021491153211],
            [76.88020888441487, 20.27970471574604],
            [76.90883310245151, 20.31311142843162],
            [76.8915487909073, 20.31702096621313],
            [76.90477787315895, 20.3444825476736],
            [76.93617240460259, 20.37061206621399],
            [76.97798508573963, 20.37034845777727],
            [76.99357978833183, 20.40904138428825],
            [77.014481175431, 20.41271495094612],
            [77.02231423285365, 20.44991912054898],
            [77.05902415461702, 20.44537180108073],
            [77.04533422308623, 20.38655067429498],
            [77.06245792940138, 20.38135734288455],
            [77.0811526326567, 20.38894528949407],
            [77.07961146024344, 20.423857964134],
            [77.12021150329291, 20.41110111425395],
            [77.14205681330496, 20.38015195253921],
            [77.15151996687452, 20.39913853967116],
            [77.18506664355458, 20.39840851373158],
            [77.19724420754096, 20.42222002434836],
            [77.18555062828814, 20.44738454654691],
            [77.22517184375378, 20.4474121286802],
            [77.22957177059938, 20.4733945911866],
            [77.26630209886275, 20.45860359261634],
            [77.27770751650245, 20.42363412872067],
            [77.29379042435102, 20.42070929973591],
            [77.29803433624669, 20.44586694740168],
            [77.34342695142635, 20.47163592444888],
            [77.32747645441135, 20.49797421149171],
            [77.36805266068711, 20.49652987356852],
            [77.36792845410065, 20.48002513817434],
            [77.38898102200926, 20.50169668946033],
            [77.39566618102306, 20.52544052483838],
            [77.33633718638335, 20.525784021623],
            [77.33944297287165, 20.57526447498373],
            [77.36208347565848, 20.56763557386966],
            [77.36567017272927, 20.58338308254987],
            [77.40925933484785, 20.58707381410257],
            [77.41086833496263, 20.60691994050108],
            [77.46707129687012, 20.61091101280033],
            [77.43088686476857, 20.66225770503426],
            [77.47859125536776, 20.65515441295469],
            [77.48101205242914, 20.68204503201484],
            [77.51084220971696, 20.66441169855881],
            [77.51385314328559, 20.68169151924858],
            [77.54324386397406, 20.67827624918406],
            [77.52623823241812, 20.70118423048559],
            [77.57304488021403, 20.70537242355159],
            [77.57788594336414, 20.72691567576134],
            [77.61046910171164, 20.71756033726494],
            [77.61923698148202, 20.75306493064325],
            [77.61019499945223, 20.7996588429504],
            [77.56915785271268, 20.80845144119377],
            [77.55066005141134, 20.85459663925525],
            [77.47608486620128, 20.86062682279911],
            [77.47967652978578, 20.87895677787885],
            [77.43368853237484, 20.84248960620299],
            [77.12954778523819, 20.86322254805253],
            [77.15985060821107, 20.97133891207402],
            [77.1329270724139, 20.97621391822542],
            [77.13354834777859, 20.98888799246673],
            [77.16767582992053, 20.98870837235962],
            [77.17284230675432, 21.02383714148481],
            [77.14956764902581, 21.03397307314388],
            [77.15007890249497, 21.0721752808346],
            [77.17656209273544, 21.07239108523651],
            [77.17172678126566, 21.1186261447053],
            [77.1961484614555, 21.12052747844627],
            [77.19625365879087, 21.13894157962018],
            [77.15953507500211, 21.14548165827402],
            [77.18364508329063, 21.20133584945989],
            [77.17411263276585, 21.22346690181836],
            [77.19373174912113, 21.23650249904345],
            [77.16477309706816, 21.24322388467288],
            [77.13030850114065, 21.22038224750026],
            [77.08065286636766, 21.21644320035436],
            [77.04814058824205, 21.23906310776846]
          ]
        ]
      }
    },
    {
      id: '2',
      type: 'Feature',
      properties: {
        Name: 'AMARAVATI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'AMARAVATI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '468',
        Shape_Leng: 932435,
        Shape_Area: 11762400000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [77.48259198395338, 21.76418113486868],
            [77.28046720528319, 21.75857960919446],
            [77.2872169828471, 21.72192179972852],
            [77.22691086367354, 21.71679261796193],
            [77.2104243779293, 21.68964514264643],
            [77.1760337453133, 21.72575471442859],
            [77.16512276521996, 21.71073782390268],
            [77.07321867704007, 21.71945403482578],
            [76.90161701371947, 21.59684393735803],
            [76.85448658116086, 21.61331502614907],
            [76.83290586403393, 21.58895426891267],
            [76.79576284680259, 21.59422303457866],
            [76.78141248526568, 21.56472093168473],
            [76.78932647326633, 21.53637853258076],
            [76.76344368179491, 21.520767421908],
            [76.79560916190074, 21.48958282319504],
            [76.7840199479076, 21.46237353085233],
            [76.74442806486265, 21.43986527241216],
            [76.73950877102857, 21.41055720159096],
            [76.62174730209153, 21.3322913604123],
            [76.66267922957694, 21.28069391155218],
            [76.72365939413588, 21.28923330137992],
            [76.74853190239776, 21.25081483367622],
            [76.74595764440187, 21.2232268834515],
            [76.78990400556135, 21.1829355217322],
            [76.90955113140261, 21.20042905370952],
            [76.99849305108164, 21.19588401447798],
            [77.00612691928933, 21.22906017068858],
            [77.0331166841371, 21.24803132568903],
            [77.08065286636766, 21.21644320035436],
            [77.19248624860005, 21.24135934376105],
            [77.17411263276585, 21.22346690181836],
            [77.18364508329063, 21.20133584945989],
            [77.15953507500211, 21.14548165827402],
            [77.19625365879087, 21.13894157962018],
            [77.1961484614555, 21.12052747844627],
            [77.17172678126566, 21.1186261447053],
            [77.17656209273544, 21.07239108523651],
            [77.15007890249497, 21.0721752808346],
            [77.14956764902581, 21.03397307314388],
            [77.17284230675432, 21.02383714148481],
            [77.16767582992053, 20.98870837235962],
            [77.13354834777859, 20.98888799246673],
            [77.1329270724139, 20.97621391822542],
            [77.15985060821107, 20.97133891207402],
            [77.12954778523819, 20.86322254805253],
            [77.43368853237484, 20.84248960620299],
            [77.46578279897362, 20.88000494437892],
            [77.47967652978578, 20.87895677787885],
            [77.47608486620128, 20.86062682279911],
            [77.55066005141134, 20.85459663925525],
            [77.55349885233436, 20.82474043202091],
            [77.61019499945223, 20.7996588429504],
            [77.61423498434846, 20.75938546783028],
            [77.63390960199257, 20.75571530925219],
            [77.61051797639566, 20.71781513701184],
            [77.63512777175914, 20.71137094462469],
            [77.63466580279267, 20.65822896943785],
            [77.65399173951236, 20.66187088241533],
            [77.65971581378689, 20.64619184594873],
            [77.62904260529238, 20.56622026947266],
            [77.69100301018136, 20.57758160302465],
            [77.78009868894566, 20.53812566680598],
            [77.81071807454147, 20.58475116397734],
            [77.83960242321785, 20.56493584566515],
            [77.84620202596527, 20.58800975539915],
            [77.89480286295874, 20.62582896310311],
            [77.91753958039806, 20.60749995761338],
            [77.91158912839693, 20.56735529689455],
            [77.92470183953759, 20.55913477061534],
            [77.93315304212861, 20.57769182983869],
            [77.97449635384874, 20.58906471683344],
            [77.9954314360708, 20.62460526416277],
            [78.02111239787291, 20.62675552812961],
            [78.03658214053837, 20.66590050470005],
            [78.08866775489912, 20.67205073477971],
            [78.09330664311615, 20.64150407329859],
            [78.11067496127447, 20.64020467092521],
            [78.12938864206666, 20.64744940358176],
            [78.12718318923298, 20.66309251257304],
            [78.15689816192737, 20.65676840416481],
            [78.18220813684867, 20.67799933603801],
            [78.20590108556775, 20.67446092643617],
            [78.21167333773747, 20.6923223089886],
            [78.25521700663114, 20.68359855897279],
            [78.25889566203011, 20.69799089638668],
            [78.29295782965112, 20.70987053624111],
            [78.2973991297381, 20.69934882552622],
            [78.3116875519628, 20.73802407610863],
            [78.29349594322757, 20.79997531022087],
            [78.3167626955402, 20.81820760422874],
            [78.31269596921699, 20.83280186282484],
            [78.29238019078677, 20.82791666126764],
            [78.2570924825348, 20.88706833779201],
            [78.21320082761918, 20.90859830530522],
            [78.1814712958959, 20.90458712479823],
            [78.16823732585124, 20.94187471007255],
            [78.14300684416446, 20.95264107294766],
            [78.136203523432, 21.03817979554139],
            [78.1504899861733, 21.07555740365005],
            [78.12834453793646, 21.11444666143159],
            [78.14350091768144, 21.13987646466724],
            [78.09156363918089, 21.17951413077805],
            [78.09677726515963, 21.19887159913013],
            [78.05224081260916, 21.25723650536027],
            [78.08046364575443, 21.28158568582728],
            [78.06871955355167, 21.30082285333508],
            [78.08035346705788, 21.35766475656554],
            [78.15583346310531, 21.33161996292809],
            [78.23313079064972, 21.32737982981843],
            [78.37131121738905, 21.39569840486266],
            [78.4069137588723, 21.38170459145481],
            [78.4475901673412, 21.402832909121],
            [78.42821689595824, 21.4758417051993],
            [78.43846069058668, 21.51784705566085],
            [78.41868060519846, 21.57090011092162],
            [78.42711509892503, 21.59933783326402],
            [78.37263732590118, 21.61344506595008],
            [78.38161544597553, 21.59203751546642],
            [78.36306166716396, 21.57520380970301],
            [78.34274980403723, 21.58905550019835],
            [78.30705045666734, 21.56957343011505],
            [78.30297156834048, 21.58374189125546],
            [78.26647537776422, 21.59173257653283],
            [78.27385585969274, 21.56925483537566],
            [78.18188671168758, 21.55734307860326],
            [78.17621417449749, 21.499754949796],
            [77.94118880936516, 21.38577162120862],
            [77.88327401810409, 21.37603832692019],
            [77.80115485408074, 21.40959506361999],
            [77.79676753445706, 21.389010645991],
            [77.75004117177927, 21.38282745964795],
            [77.73710764537897, 21.3622023477407],
            [77.70998854623014, 21.35744715110301],
            [77.69199148928605, 21.39756499682837],
            [77.66990847545402, 21.36892347446],
            [77.6531270915389, 21.39145650606112],
            [77.60496558173462, 21.39073455586394],
            [77.607848206038, 21.36493732755816],
            [77.58711110748703, 21.36283955735454],
            [77.56349647017315, 21.36930955112963],
            [77.56146127466938, 21.39645658800237],
            [77.53171921123698, 21.41914605106671],
            [77.51452376838313, 21.37593962585839],
            [77.48805752036372, 21.37435870960048],
            [77.47359805711073, 21.45444653937106],
            [77.44218725974461, 21.4699107906571],
            [77.4255574170388, 21.5377403664715],
            [77.45488619350084, 21.55384258105927],
            [77.57522762664316, 21.52645846068803],
            [77.61148163643783, 21.53882062609093],
            [77.59529227621886, 21.55943145164532],
            [77.57711479260162, 21.55517063220217],
            [77.5755170077257, 21.62063918105204],
            [77.54249012500726, 21.70558353812129],
            [77.48259198395338, 21.76418113486868]
          ]
        ]
      }
    },
    {
      id: '3',
      type: 'Feature',
      properties: {
        Name: 'AURANGABAD',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'AURANGABAD',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '469',
        Shape_Leng: 863384,
        Shape_Area: 9778300000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [74.73121105202567, 20.0874161372209],
              [74.72853731982734, 20.08779748469794],
              [74.72854618066944, 20.08550876945317],
              [74.73124716353612, 20.08526994662674],
              [74.73121105202567, 20.0874161372209]
            ]
          ],
          [
            [
              [76.00624284507866, 20.64516451623639],
              [75.98759594758064, 20.61607979815785],
              [75.95477127328299, 20.62058433850518],
              [75.95328649175359, 20.60070550239693],
              [75.97462800222138, 20.58661428463357],
              [75.9639186234567, 20.56959172636869],
              [75.94895094841512, 20.56897891768373],
              [75.94964397703717, 20.58069917594499],
              [75.93584725518888, 20.58766415624522],
              [75.93068874827617, 20.58445202234707],
              [75.9405763862009, 20.53554048132837],
              [76.01807020419174, 20.53022457360224],
              [76.0158052927942, 20.5509249722552],
              [76.03629102860363, 20.55474891544226],
              [76.03212422148356, 20.63670073858909],
              [76.00624284507866, 20.64516451623639]
            ]
          ],
          [
            [
              [75.68118873559858, 20.66522877299088],
              [75.65587106541574, 20.6594395851359],
              [75.65981013487388, 20.62431630352311],
              [75.60534649699612, 20.62165728175454],
              [75.61272003637575, 20.60276028212901],
              [75.53498451642095, 20.60604389743275],
              [75.52059236982302, 20.59008588180794],
              [75.52848635447245, 20.55599502246879],
              [75.50429585813667, 20.55102112868195],
              [75.49299463282091, 20.52364216299953],
              [75.45579859972986, 20.55076483614699],
              [75.45446848646549, 20.5135677258226],
              [75.44671019968028, 20.53733870338595],
              [75.42319498475449, 20.53037633544097],
              [75.42867676292964, 20.51161093364227],
              [75.39567773543901, 20.52060881208265],
              [75.3886789696212, 20.57780951881014],
              [75.36460437976284, 20.57502347416083],
              [75.35844752634982, 20.59607085150522],
              [75.31847981844167, 20.59162392952605],
              [75.31642220084113, 20.5745998327472],
              [75.2911681407745, 20.5664263167304],
              [75.25885955203218, 20.57650262858282],
              [75.22646109765675, 20.49441422127201],
              [75.20505370309525, 20.49896782507476],
              [75.19723590845959, 20.47543171655483],
              [75.15979832008537, 20.47648186709683],
              [75.17418545010982, 20.44242152965593],
              [75.12465737381457, 20.4319738399203],
              [75.10583111524329, 20.41191181741827],
              [75.12240953907059, 20.36329290688917],
              [75.11088903983944, 20.3101898200707],
              [75.08182332117103, 20.31557161087467],
              [75.08975878047364, 20.33217976294516],
              [75.0747368346526, 20.33855199182543],
              [75.05599563166268, 20.33333939119498],
              [75.05488887241684, 20.30575529550447],
              [74.99951995109359, 20.33596421330269],
              [75.00532117454676, 20.29369341314192],
              [74.96632143514245, 20.3069732408361],
              [74.94493013830267, 20.28783192482024],
              [74.95418809860573, 20.27183179710218],
              [74.90522827897772, 20.24718721644158],
              [74.90779337495714, 20.21909695529756],
              [74.9285041593243, 20.21738299559767],
              [74.92798118167208, 20.15453537014124],
              [74.90677788392479, 20.15500114573477],
              [74.89567259448903, 20.18025938398392],
              [74.85462689577886, 20.17968416780987],
              [74.85537632256953, 20.23036214028296],
              [74.81838570575792, 20.25040506268004],
              [74.78179177371705, 20.2344810892278],
              [74.80000364241975, 20.23266903959046],
              [74.78287996964465, 20.20615938534984],
              [74.75862907885976, 20.20098997267068],
              [74.76010254128921, 20.18448847221485],
              [74.71912494194648, 20.19279175072349],
              [74.70378411334444, 20.11475596721155],
              [74.7303428431956, 20.11457601309921],
              [74.73646191785949, 20.08079082905897],
              [74.70954011650407, 20.07992455876184],
              [74.7179004420159, 20.01813239272363],
              [74.68932443769368, 20.01076706019164],
              [74.68515189584825, 19.96865774918452],
              [74.67088964564388, 19.95934484892727],
              [74.67706563223278, 19.9241384606423],
              [74.6493116507673, 19.92012303304356],
              [74.64443899608537, 19.86014331924768],
              [74.65981739233295, 19.85771226106812],
              [74.65688042378683, 19.83487196613929],
              [74.60289633656761, 19.84696250791641],
              [74.59232286427617, 19.77582518975218],
              [74.61189155089362, 19.76994577697503],
              [74.63678354955435, 19.79304416269535],
              [74.69527342019178, 19.75500579857586],
              [74.7144287546231, 19.78014811905435],
              [74.72147138719302, 19.75465853987039],
              [74.7353185300293, 19.76490896089074],
              [74.78427359167111, 19.73433651187123],
              [74.84879031958951, 19.64636631918319],
              [74.88304149672543, 19.65447018718589],
              [74.88796614390272, 19.63904473000974],
              [74.91377089503314, 19.64820438631197],
              [74.93118004818716, 19.63690511140341],
              [74.96277445152195, 19.64713666630229],
              [74.99866593727585, 19.62401967357355],
              [75.03776367031948, 19.62584397304141],
              [75.05916456832433, 19.60570224207047],
              [75.19405038543023, 19.59485370420176],
              [75.20633230884616, 19.56215817483029],
              [75.25681952723689, 19.52325261442126],
              [75.27411477657266, 19.55435254236846],
              [75.27365835804488, 19.51525615866119],
              [75.3117996076021, 19.49575392301352],
              [75.32888432341302, 19.50842714295715],
              [75.32744340499676, 19.48377300618428],
              [75.35654511084465, 19.50174133962726],
              [75.35810856824324, 19.48266157595367],
              [75.32319971449091, 19.46572832662831],
              [75.32703335485671, 19.43856103897213],
              [75.34690288942811, 19.44900173997168],
              [75.35703170708267, 19.4319586026228],
              [75.33942299233004, 19.40601271203654],
              [75.36515281709531, 19.39690231741004],
              [75.44113706983187, 19.4270157354462],
              [75.44262452113236, 19.41404210286776],
              [75.46637112466495, 19.4143494769005],
              [75.48589821552736, 19.44239496967384],
              [75.54768766674327, 19.38809424852094],
              [75.60612819451806, 19.38353834668208],
              [75.6046750408609, 19.45217545602485],
              [75.61390049647567, 19.4676485860043],
              [75.63154130350769, 19.46463606311099],
              [75.65604199717706, 19.5681506430678],
              [75.64920888565815, 19.59543579021471],
              [75.59798571639624, 19.60011654891986],
              [75.5851458118074, 19.6383009103233],
              [75.62923819307808, 19.66032199399057],
              [75.62358698363424, 19.77200001783225],
              [75.64442292235641, 19.78005653880804],
              [75.6336024192176, 19.81168353510397],
              [75.6584986777328, 19.82251846516201],
              [75.64489266887325, 19.84210118805395],
              [75.65677977933393, 19.9125095840135],
              [75.68059760004208, 19.92452491989742],
              [75.6511039195426, 19.94972683953963],
              [75.64447442104456, 20.00697880657764],
              [75.59244685444845, 20.00638260483083],
              [75.60432440056094, 20.05337662319938],
              [75.5886704995119, 20.06358155214274],
              [75.58635874148501, 20.09789879400699],
              [75.6241580205657, 20.10027457079848],
              [75.64600635648706, 20.18813736878899],
              [75.67866504843306, 20.19079104130264],
              [75.67420482646794, 20.23324752806718],
              [75.6950977537473, 20.28233561729154],
              [75.68177966885372, 20.30632779790907],
              [75.71643094581442, 20.330408669113],
              [75.77054540661486, 20.33638551885653],
              [75.74560098258836, 20.37058142348071],
              [75.74917707166281, 20.40222782046742],
              [75.73262618024614, 20.4071313644476],
              [75.7639761325124, 20.45198430511826],
              [75.7945668448137, 20.45023523207406],
              [75.81969623955847, 20.47208876899326],
              [75.85512272835945, 20.46021801976331],
              [75.86266139250367, 20.43989808306608],
              [75.8940556704468, 20.44537947456586],
              [75.8474566158089, 20.48828322001405],
              [75.86059217774537, 20.52379943812042],
              [75.88400849765547, 20.52832025812353],
              [75.86035822748852, 20.55983463954811],
              [75.87657386410147, 20.55254382878599],
              [75.88744833126707, 20.57279073698281],
              [75.86750207552741, 20.619535827791],
              [75.83678250229745, 20.61424973708512],
              [75.82814247339824, 20.57120240890946],
              [75.84398513352853, 20.56257419508125],
              [75.78611729516543, 20.56188843601488],
              [75.79206460909307, 20.58146251092314],
              [75.75697802638801, 20.57383251872948],
              [75.75424316001488, 20.61340747141692],
              [75.69941223955293, 20.61400980668222],
              [75.70358340475809, 20.6588280575447],
              [75.68118873559858, 20.66522877299088]
            ],
            [
              [75.56276095331278, 19.95453958752453],
              [75.56783662944217, 19.96706411471841],
              [75.59624502538206, 19.96019927138226],
              [75.57286553182537, 19.93554213847058],
              [75.56276095331278, 19.95453958752453]
            ]
          ]
        ]
      }
    },
    {
      id: '4',
      type: 'Feature',
      properties: {
        Name: 'BHANDARA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'BHANDARA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '471',
        Shape_Leng: 500712,
        Shape_Area: 3987880000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [79.76717833486754, 21.59282467621808],
            [79.73485666028591, 21.60376790707185],
            [79.66093595704899, 21.57689544701308],
            [79.65205337797823, 21.5559847290133],
            [79.52466553352009, 21.5395332264413],
            [79.4483220524694, 21.45676411048624],
            [79.44840602047098, 21.43464976678551],
            [79.48203571271075, 21.42716552201766],
            [79.48376016547458, 21.39884154827904],
            [79.49953394187598, 21.39846300995607],
            [79.55517917200251, 21.32855994591579],
            [79.553550654716, 21.3057254650297],
            [79.57611921228897, 21.2763550814001],
            [79.54971181904399, 21.20836530273471],
            [79.55709596481059, 21.15611611276347],
            [79.49828151123994, 21.18369239780514],
            [79.50807215056126, 21.16292973457512],
            [79.49372237596863, 21.13776525342681],
            [79.52474709967264, 21.11988315402074],
            [79.52642360578182, 21.07891693476351],
            [79.55068780582405, 21.08867526117763],
            [79.57207199576646, 21.06608818344199],
            [79.59664445761734, 21.07393752205571],
            [79.65696874779655, 20.96277333706626],
            [79.64627928398517, 20.92475410222221],
            [79.61234511839315, 20.90362195043976],
            [79.61299607039393, 20.8660086426741],
            [79.57963721204544, 20.84335567341078],
            [79.53726653499484, 20.852200716623],
            [79.55956843025506, 20.80265581779466],
            [79.53151469731229, 20.77483035541947],
            [79.51798470555457, 20.71421076877277],
            [79.60819792468702, 20.69646998077743],
            [79.61964958582023, 20.67622483110733],
            [79.69327336642591, 20.64139766336173],
            [79.69309605190737, 20.67328137006763],
            [79.75113168416213, 20.68813658235367],
            [79.7582199797356, 20.73488032719612],
            [79.83601133724027, 20.68315414311108],
            [79.88798020079946, 20.68869808529409],
            [79.93108124674347, 20.66848432670185],
            [79.96476059957924, 20.69424312872016],
            [79.96925902906499, 20.71531853161634],
            [79.94429024381805, 20.72095735789265],
            [79.9714341051532, 20.74507080145819],
            [79.95534901368457, 20.76597462776048],
            [79.9797042413353, 20.77303319022361],
            [79.94728948957476, 20.7799365578153],
            [79.94054417090825, 20.80137204954423],
            [79.95914362358252, 20.8129317402283],
            [79.95112844742825, 20.82611734701497],
            [79.98783441451592, 20.82696558696673],
            [79.9991707449446, 20.85047637906234],
            [79.98256702781877, 20.86210595582514],
            [79.9797706556352, 20.83595387409396],
            [79.96548028223594, 20.85488355330193],
            [79.96466250854859, 20.88728919457031],
            [79.97720890699115, 20.89013587903195],
            [79.96181594046833, 20.9173632605766],
            [79.96896008735884, 20.93997467710839],
            [79.95338769385135, 20.943939049436],
            [80.03242044667684, 20.9576143345253],
            [80.03037409265808, 20.94517832467967],
            [80.04548630570855, 20.95713972716201],
            [80.03718035921872, 20.96503807531987],
            [80.06206811064584, 20.94894138305669],
            [80.07636678578456, 20.98966589808053],
            [80.10211359213396, 20.99051243832147],
            [80.09587350692173, 21.03284267861614],
            [80.06303950722878, 21.03070651969903],
            [80.08428113842204, 21.07369920852988],
            [80.06969726804982, 21.0815902927662],
            [80.07536843804077, 21.09842363189941],
            [80.06101443692013, 21.09917970020109],
            [80.08211757141082, 21.11859552761824],
            [80.06875242005555, 21.19595064274705],
            [80.02475875677816, 21.21281384738392],
            [80.02311564951579, 21.22864529328079],
            [80.00278338148057, 21.21812577111987],
            [79.93899124690319, 21.25493954685283],
            [79.85572167524201, 21.24485283576121],
            [79.84034711381052, 21.25579847768005],
            [79.86392940065382, 21.25186349696826],
            [79.85934192026873, 21.26156011113811],
            [79.83130070772269, 21.26340760951215],
            [79.8336311439861, 21.30954075877367],
            [79.81296224053949, 21.32127214531323],
            [79.81322395387757, 21.35583474687136],
            [79.79612447058861, 21.3744682049621],
            [79.87948779788265, 21.42518880975242],
            [79.92641100568356, 21.51265963146058],
            [79.86313236810345, 21.53079513538405],
            [79.76717833486754, 21.59282467621808]
          ]
        ]
      }
    },
    {
      id: '5',
      type: 'Feature',
      properties: {
        Name: 'B|D',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'B|D',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '470',
        Shape_Leng: 931334,
        Shape_Area: 10276600000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [75.48865164085485, 19.4413458416057],
            [75.47324435099, 19.42357113378869],
            [75.48821065213463, 19.4166529137345],
            [75.48225067877935, 19.38423033859873],
            [75.53206877560343, 19.37691757892372],
            [75.51720605222305, 19.33081625763961],
            [75.5413739895841, 19.32759435982631],
            [75.53911232099718, 19.30828471306636],
            [75.51953074040904, 19.27750794945329],
            [75.45870199258088, 19.25022667524519],
            [75.444918684944, 19.21940314515934],
            [75.42190286374773, 19.2214953002474],
            [75.40143990398951, 19.19654853120328],
            [75.4493247396606, 19.16396238933886],
            [75.45365751354407, 19.14462749843245],
            [75.42329908498341, 19.13862373161048],
            [75.43097971405959, 19.11781911203334],
            [75.4837075160831, 19.12792775985407],
            [75.48516541137343, 19.10586545354657],
            [75.44945279556748, 19.08323550460373],
            [75.44475969913348, 19.0931811943798],
            [75.36874124061272, 19.08174043822991],
            [75.40752341609011, 19.14101196228938],
            [75.35146760065531, 19.1269854775576],
            [75.35215452864328, 19.14724920353642],
            [75.33053390555007, 19.15288494844345],
            [75.36467859810143, 19.08165232717026],
            [75.30689689986991, 19.09861359551753],
            [75.28087579151912, 19.08498164682375],
            [75.2929208445057, 19.07616862198621],
            [75.28318079698941, 19.03443543548774],
            [75.33900994916105, 19.0293548402529],
            [75.34063056491568, 18.99004265278961],
            [75.31576530340361, 18.98047879959137],
            [75.27428941601265, 18.99193933424266],
            [75.25613902922271, 19.02574116691166],
            [75.26146763873334, 19.06994605394293],
            [75.22449193029306, 19.06578442520551],
            [75.21999129420674, 19.11167222442043],
            [75.18738827046361, 19.09256063046135],
            [75.19714807628537, 19.06699324121184],
            [75.18611956163399, 19.05161766109977],
            [75.2098104847607, 19.02927464282916],
            [75.18290541593952, 19.01166969440817],
            [75.16781682565538, 19.03580850489611],
            [75.07079894180994, 19.05537738325386],
            [75.09197029501823, 19.06810300251338],
            [75.0784362377883, 19.07872838978805],
            [75.09735704021004, 19.07793297282803],
            [75.10935584238945, 19.12486062826564],
            [75.06898102925501, 19.1213519108565],
            [75.07375130269979, 19.10169444219223],
            [75.05854597883369, 19.09838379140279],
            [75.02437912078373, 19.10272554532018],
            [75.02355348467266, 19.11493730646276],
            [74.9738023107996, 19.11098575816771],
            [74.94246355190897, 19.13323979976789],
            [74.91441343296036, 19.03750631809826],
            [74.94960938842944, 19.03283295538377],
            [74.95256171296056, 18.97151374399461],
            [74.91359132739201, 18.95889533843577],
            [74.89948096862712, 18.98007377604763],
            [74.87136652942453, 18.98502989194931],
            [74.83607739082173, 18.96993872526285],
            [74.82480335940657, 18.9904835375147],
            [74.8082301419218, 18.97692552686976],
            [74.83580367106339, 18.95344412484492],
            [74.82503580442629, 18.93226031258909],
            [74.84583096587171, 18.91053688484508],
            [74.8647611370691, 18.89761108916425],
            [74.88404150715452, 18.91410957931255],
            [74.89468898997372, 18.84671835823706],
            [74.91834616630662, 18.85320752707921],
            [74.92739215230853, 18.8260294853197],
            [74.9737090641295, 18.82828714217144],
            [74.98606821635525, 18.79756565521503],
            [75.00905384309334, 18.80445566568899],
            [75.01265703565166, 18.77517196401796],
            [75.15616598344751, 18.64214341822308],
            [75.1716264625622, 18.73647769318709],
            [75.2549501642763, 18.72021243432339],
            [75.3274615960826, 18.80124886993673],
            [75.37970946644505, 18.76921841256405],
            [75.39944728628348, 18.83157697082362],
            [75.43863653909192, 18.79892293985419],
            [75.45055903661141, 18.75114917182739],
            [75.50738484310703, 18.72332534468739],
            [75.5266878839547, 18.73320929096102],
            [75.52496256575834, 18.75263950867436],
            [75.54160473386395, 18.74511953518086],
            [75.55551727622422, 18.73659813015717],
            [75.55322006964434, 18.70804194093682],
            [75.60380957768801, 18.68880803549688],
            [75.64546419526323, 18.64832155174082],
            [75.66657353043485, 18.65143857045627],
            [75.66970601692057, 18.6912582207379],
            [75.75603041274893, 18.68055912392579],
            [75.79340278351464, 18.65423368452268],
            [75.80236631179929, 18.67275816905304],
            [75.85748250233588, 18.65973772761921],
            [75.85564073982341, 18.64938306329424],
            [75.93895412688443, 18.64073226940205],
            [75.94808640514839, 18.60505945198072],
            [75.9909500321293, 18.61893354875265],
            [75.98257240494473, 18.59083405350171],
            [75.99374185169764, 18.58323107288926],
            [76.01224787920648, 18.60776845733336],
            [76.05737165569508, 18.57390095069734],
            [76.13476421475157, 18.58765930014614],
            [76.1559607046495, 18.57809736435171],
            [76.16033953478762, 18.55495116889442],
            [76.17741345185851, 18.5845016695772],
            [76.25467123128011, 18.57540193064587],
            [76.27350691909362, 18.55797503623078],
            [76.29086998130418, 18.57629317379891],
            [76.34921529239689, 18.5653662625078],
            [76.39065185971913, 18.542266971149],
            [76.39202585318138, 18.59606613089452],
            [76.4654697372185, 18.63509848776984],
            [76.49962410989384, 18.60403223942914],
            [76.54102762120569, 18.65103982111125],
            [76.57834886145332, 18.61947988471628],
            [76.59488020201006, 18.67251129440639],
            [76.62730427691746, 18.67567878341432],
            [76.63629440121895, 18.64836532439828],
            [76.67870748473418, 18.63447879822776],
            [76.68131421267812, 18.65003091317082],
            [76.66161297236346, 18.65783084197406],
            [76.6820848712609, 18.69199310371489],
            [76.73378176699951, 18.70009619061312],
            [76.72331440550238, 18.7504579478124],
            [76.67436849340966, 18.756344077131],
            [76.67119925535883, 18.8135070619939],
            [76.64286778176923, 18.82190916620992],
            [76.64217696403057, 18.84795869987425],
            [76.62845385234966, 18.84679129487743],
            [76.62071703807327, 18.86793021172379],
            [76.58183422526537, 18.87248389731251],
            [76.5832188768012, 18.94277865487077],
            [76.53685646325836, 18.94902871374238],
            [76.5356312556376, 18.91790149025296],
            [76.52052565587452, 18.91821875220543],
            [76.50259931235884, 18.9493804086021],
            [76.47799250467519, 18.95333763245986],
            [76.4686550427653, 18.98331493690034],
            [76.47975170110152, 19.00117177487614],
            [76.45602929825861, 19.00832136298801],
            [76.43830495796084, 19.0423695510156],
            [76.4516949150324, 19.0508647968587],
            [76.43521097266428, 19.09304826593955],
            [76.41159587190992, 19.09133679185373],
            [76.37869856549982, 19.13080444204796],
            [76.34848394525513, 19.09979087760091],
            [76.32204189938317, 19.10731544185503],
            [76.36062742768034, 19.15598629956857],
            [76.35707290792617, 19.24229521910676],
            [76.2845641671366, 19.26589940679823],
            [76.25012209182906, 19.24119126575571],
            [76.22465229544106, 19.24307599494103],
            [76.19530655326287, 19.28590352170557],
            [76.16267782610312, 19.28342651837612],
            [76.16036168355969, 19.29539101559149],
            [76.10270086016186, 19.3080673789845],
            [76.08793413047827, 19.28093527290641],
            [76.03966819780139, 19.28363982010133],
            [76.02020091603539, 19.33764346920854],
            [75.93515784502324, 19.29337962839118],
            [75.9064945306913, 19.31833118439129],
            [75.92502757897682, 19.38270040028077],
            [75.91203246429457, 19.39216853341169],
            [75.83529092404366, 19.37181763490231],
            [75.78896751500281, 19.40017812808164],
            [75.75780854252211, 19.38933163286066],
            [75.75093231556109, 19.35608319182222],
            [75.67966456056213, 19.35565192191983],
            [75.64010832883663, 19.38144790706803],
            [75.54768766674327, 19.38809424852094],
            [75.48865164085485, 19.4413458416057]
          ]
        ]
      }
    },
    {
      id: '6',
      type: 'Feature',
      properties: {
        Name: 'BULDHANA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'BULDHANA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '472',
        Shape_Leng: 748817,
        Shape_Area: 9401300000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [76.71977574595768, 21.28868650036381],
            [76.66267922957694, 21.28069391155218],
            [76.661642567734, 21.24070726753432],
            [76.64183032638358, 21.23713380179009],
            [76.62348868382391, 21.18503885764988],
            [76.56585142679326, 21.19947039877117],
            [76.53025674557328, 21.18193240892714],
            [76.49059351836928, 21.19215142943254],
            [76.45608935053644, 21.10839530803706],
            [76.41069574245826, 21.10243629823557],
            [76.41319441681937, 21.08842242229576],
            [76.38514666255536, 21.08194213532881],
            [76.39617643909814, 21.02393792204954],
            [76.38037562189841, 20.9770224475715],
            [76.34551370041383, 20.95140734379174],
            [76.27934333001906, 20.95739591961514],
            [76.26619074207709, 20.98014875779428],
            [76.16482835201055, 21.03641088024903],
            [76.15824208792803, 21.0027906043536],
            [76.0799784371304, 20.92819177310353],
            [76.07783722424269, 20.90865122209921],
            [76.11264790885343, 20.88667043022751],
            [76.04864729919497, 20.81586300629442],
            [76.05043246924963, 20.79002732387919],
            [75.99519878582038, 20.7779989862354],
            [75.98533364649255, 20.76098896182203],
            [76.0157847948891, 20.73017478269183],
            [75.99755608740251, 20.71378382595774],
            [75.99499563377135, 20.6629616799469],
            [76.03212422148356, 20.63670073858909],
            [76.04285429045662, 20.57911042054439],
            [76.03629102860363, 20.55474891544226],
            [76.0158052927942, 20.5509249722552],
            [76.01807020419174, 20.53022457360224],
            [75.97266940844598, 20.53182007410963],
            [75.94089892855605, 20.50214863126472],
            [75.9570258156549, 20.46454331465276],
            [75.94143142725986, 20.42480235226206],
            [75.96683324648257, 20.37295145243121],
            [75.94164309852685, 20.36890840498554],
            [75.92616680707788, 20.30768873553571],
            [75.9494331754915, 20.29852700461723],
            [75.97000768515325, 20.3158309999301],
            [76.02836524866639, 20.28905528030656],
            [76.04682663910025, 20.33712431195635],
            [76.08577174970195, 20.36523724618446],
            [76.09426010974653, 20.34723339859598],
            [76.1261274254137, 20.34492951842589],
            [76.14091390448517, 20.30052518662141],
            [76.19382177404809, 20.30015373566094],
            [76.16638514743904, 20.23843421688406],
            [76.13292664408554, 20.22244479403231],
            [76.14985421788602, 20.20594915381933],
            [76.10881283964743, 20.16243332067929],
            [76.09472639341824, 20.09629495696281],
            [76.05576881000275, 20.09739161845059],
            [76.06953061497326, 20.07280162262152],
            [76.01879780518868, 20.05840119124501],
            [76.02331934745041, 20.02429831323688],
            [75.96249923036949, 19.99490544255846],
            [76.01145787014364, 19.97371350038293],
            [76.01126379885444, 19.95375647106581],
            [76.04814073486473, 19.94596792628333],
            [76.0585780819011, 19.91867618501669],
            [76.08111677126675, 19.91253688080089],
            [76.09754971337479, 19.85695851290307],
            [76.12933136456996, 19.86501978597922],
            [76.14760488897956, 19.84364018194763],
            [76.14839256698538, 19.85594897373469],
            [76.18175269534085, 19.84807184026443],
            [76.19682551139738, 19.86539941932042],
            [76.29307020886421, 19.87079525927691],
            [76.35484162879483, 19.89686749128985],
            [76.36602249479624, 19.92850075656175],
            [76.3928168551007, 19.9049176445058],
            [76.40528529796228, 19.91979770883914],
            [76.49356938327357, 19.92015920817681],
            [76.49276158399822, 19.89379502745738],
            [76.53450828203485, 19.86552951236188],
            [76.53663062633615, 19.84676205641829],
            [76.61409431608654, 19.83833653268926],
            [76.65964330699364, 19.8922026366233],
            [76.61098102492747, 19.89309373561178],
            [76.60567246174254, 19.92212697720545],
            [76.62838952411265, 19.92548900165744],
            [76.63663160375263, 19.95946399653162],
            [76.65927976529518, 19.96560303659124],
            [76.6455003778169, 19.98466053431547],
            [76.66309972060213, 20.04755912050505],
            [76.62402883392222, 20.05125249488526],
            [76.6304610836785, 20.0822080833676],
            [76.64845809541038, 20.06956368148763],
            [76.66892833372476, 20.1261085115011],
            [76.7574201445942, 20.13111174051671],
            [76.74678205497696, 20.20672403981466],
            [76.78470331128072, 20.20321692618631],
            [76.82131220857978, 20.23470906712508],
            [76.82588692358875, 20.27143437848465],
            [76.78604874679924, 20.28944214630071],
            [76.79234563314914, 20.31416528727322],
            [76.69994457293454, 20.35195670576996],
            [76.72653160322285, 20.40706762595679],
            [76.69307251083944, 20.45912873965531],
            [76.71137702137331, 20.47326013815688],
            [76.71567813125057, 20.5154382450733],
            [76.73543091908549, 20.51138337529183],
            [76.7352624282827, 20.49308061589772],
            [76.77043986087034, 20.51786266287469],
            [76.78313625884863, 20.57251786627974],
            [76.7687601117314, 20.57571754921439],
            [76.78887968368679, 20.59522815902023],
            [76.76065248627629, 20.60281480555754],
            [76.77058851343092, 20.62631383364426],
            [76.74994484671028, 20.63013892272546],
            [76.75911927781429, 20.65169590954655],
            [76.73231493898267, 20.65570184893871],
            [76.73937978030845, 20.68720771138748],
            [76.72283150837654, 20.68996239930873],
            [76.73583034246677, 20.71630437703516],
            [76.76337206800746, 20.72034070637816],
            [76.75401373272348, 20.73864649282832],
            [76.77294074506791, 20.77656833723061],
            [76.74446416249073, 20.80295450529591],
            [76.76439405179333, 20.85710004055571],
            [76.74458489758605, 20.88727592710611],
            [76.72670897377766, 20.88360785968366],
            [76.6911173307736, 20.91783761711257],
            [76.74448370158883, 20.9286179703579],
            [76.78413543562614, 20.90805591204476],
            [76.78811523258793, 20.92791762905355],
            [76.77579619246869, 20.93143677655952],
            [76.78913023453163, 20.96253459444107],
            [76.80916128876027, 20.9565779890973],
            [76.81189967185993, 20.9687744282773],
            [76.78394555971506, 20.97275771028666],
            [76.77573399109531, 20.99601745730326],
            [76.7984993141511, 21.01899781241666],
            [76.76357071943865, 21.03737639939062],
            [76.78133907714789, 21.05127820959122],
            [76.77328648454385, 21.08453417921298],
            [76.78896406764466, 21.10513974060706],
            [76.77173664149483, 21.14939081029211],
            [76.78204192780396, 21.19427780829425],
            [76.76768920881602, 21.19123078159637],
            [76.76074356779833, 21.22034302325501],
            [76.74595764440187, 21.2232268834515],
            [76.74853190239776, 21.25081483367622],
            [76.71977574595768, 21.28868650036381]
          ]
        ]
      }
    },
    {
      id: '7',
      type: 'Feature',
      properties: {
        Name: 'CHANDRAPUR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'CHANDRAPUR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '473',
        Shape_Leng: 678345,
        Shape_Area: 10976000000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [79.79212269364216, 20.71454492406772],
            [79.75811906227513, 20.73486047726702],
            [79.75113168416213, 20.68813658235367],
            [79.69309605190737, 20.67328137006763],
            [79.69348998394564, 20.64140532613023],
            [79.61964958582023, 20.67622483110733],
            [79.60819792468702, 20.69646998077743],
            [79.51798470555457, 20.71421076877277],
            [79.48986749132825, 20.70890431951608],
            [79.43613570239705, 20.66186509251633],
            [79.39758869034551, 20.66025511984371],
            [79.37950620782986, 20.68433185785177],
            [79.34870908098749, 20.67604989689158],
            [79.35464006106615, 20.65480413042398],
            [79.3222233643602, 20.58443486511639],
            [79.2223753475778, 20.58488860931805],
            [79.21763802972727, 20.55261135349993],
            [79.16978893577338, 20.51430173405044],
            [79.15774845288418, 20.47811818895756],
            [79.13978571141037, 20.48219250906082],
            [79.13250163492451, 20.45706718728954],
            [79.02295049774226, 20.4833396499718],
            [79.00039650431442, 20.45083949451554],
            [78.98734605431555, 20.46575077951326],
            [78.96686838876599, 20.46049631235867],
            [78.95318959638189, 20.42878989687081],
            [78.83409363682125, 20.42722139810506],
            [78.852042044592, 20.41540212742821],
            [78.81714533990167, 20.39744798259123],
            [78.83148261402287, 20.32372103072117],
            [78.7987735772905, 20.29956198372457],
            [78.81944123687457, 20.27847963570754],
            [78.81347507881786, 20.25450650238882],
            [78.91997549355528, 20.2542915634208],
            [78.96231491021977, 20.20786214506586],
            [78.95369424699406, 20.17223089539418],
            [78.98120304231368, 20.14997223526836],
            [78.97020273302434, 20.12755174734545],
            [78.99980421488436, 20.12660390753921],
            [79.04749561221358, 20.08702423021429],
            [79.04521446985609, 20.06859405841531],
            [79.06790271284295, 20.07023996961373],
            [79.0820450439352, 20.02484773943122],
            [79.10761963958178, 20.0086806558519],
            [79.11175110595376, 19.99093104824876],
            [79.0920307994139, 19.98231060561316],
            [79.10897830034732, 19.97060478562555],
            [79.08902488341523, 19.94824313329257],
            [79.09111313991663, 19.91764451296842],
            [79.14919604287991, 19.8968211398777],
            [79.07194387380997, 19.81793270944157],
            [78.95291328566778, 19.79943091661336],
            [78.93764377351329, 19.77873133951242],
            [78.94681647467092, 19.74892818119934],
            [78.90067734587662, 19.73734012535369],
            [78.87984799742377, 19.7482636918155],
            [78.8792339453788, 19.76691114006571],
            [78.84088673784002, 19.76166528521156],
            [78.85992308609559, 19.68949128111328],
            [78.85192030391194, 19.65836082066188],
            [78.88672681447997, 19.655071367772],
            [78.90353571532502, 19.67000907672538],
            [78.95555844309364, 19.65579100085612],
            [78.95562022051568, 19.60017119659413],
            [78.9728349165671, 19.58238765912431],
            [78.94044360064083, 19.55186830141212],
            [78.98125194182883, 19.56083938124795],
            [78.99803139159447, 19.54008433923535],
            [79.04601146037491, 19.54832571282803],
            [79.0980345138863, 19.53202677056275],
            [79.19086933637169, 19.45890234812124],
            [79.22358933629334, 19.46907490377599],
            [79.20385114222658, 19.49408347403865],
            [79.24002309179137, 19.53524020667263],
            [79.2531242627444, 19.59328715879616],
            [79.24355707047555, 19.61668894373983],
            [79.30684049358662, 19.59655601663369],
            [79.31393055191381, 19.56642080597998],
            [79.36573002849128, 19.57633139478293],
            [79.47142489033297, 19.50019172476384],
            [79.5185885976798, 19.52018282718753],
            [79.51861081963318, 19.54310924896948],
            [79.53992721349296, 19.55466126245228],
            [79.55293237396705, 19.52416859913134],
            [79.59615396936677, 19.50727732242396],
            [79.62791950263262, 19.5731708223912],
            [79.70899970440138, 19.58447829208474],
            [79.74308000888267, 19.6086262514208],
            [79.80807709377622, 19.57987222999348],
            [79.78592452883703, 19.64299723950843],
            [79.78363308804512, 19.72058556616753],
            [79.75335220080545, 19.75823579648444],
            [79.74142067058534, 19.81157731462967],
            [79.74599267797542, 19.83737632367196],
            [79.80367230929893, 19.89572179484462],
            [79.77170692176901, 19.97571945183783],
            [79.78790675711564, 20.01008323245301],
            [79.82780292672936, 20.03000145328686],
            [79.85798047047147, 20.0264186638325],
            [79.87491633819754, 19.98361531748314],
            [79.89974361485747, 19.96858018584657],
            [79.95221957372236, 19.98989601468694],
            [79.98907048254853, 20.04258316398059],
            [79.98073030402496, 20.08544489002627],
            [79.96418628622257, 20.1217376591851],
            [79.9122919463721, 20.15118505999005],
            [79.93441093246393, 20.1922128374632],
            [79.99214000930478, 20.22312005950869],
            [79.9437068589342, 20.28793351078049],
            [79.9721009527393, 20.35370360952233],
            [79.95823439182011, 20.38158503769751],
            [79.96515610179733, 20.41074828885925],
            [79.94012916462133, 20.44118765627118],
            [79.9519390968584, 20.52959920906824],
            [79.92581755119812, 20.55328866797096],
            [79.9350692034461, 20.66435409871895],
            [79.88798020079946, 20.68869808529409],
            [79.83468345179115, 20.68361433735931],
            [79.79212269364216, 20.71454492406772]
          ]
        ]
      }
    },
    {
      id: '8',
      type: 'Feature',
      properties: {
        Name: 'DHULE',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'DHULE',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '474',
        Shape_Leng: 615313,
        Shape_Area: 6928960000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.86505373942596, 21.62862088742468],
            [74.82885826494952, 21.60979332390081],
            [74.76883115513705, 21.61604408779226],
            [74.75521697364945, 21.47756188978132],
            [74.69977066047068, 21.46899954899025],
            [74.68602636911405, 21.40355447385312],
            [74.59960926783728, 21.41542489609863],
            [74.5719277017272, 21.40257598060094],
            [74.5361873700861, 21.42606598710486],
            [74.49656909271538, 21.42557617699399],
            [74.49301240076954, 21.39129171991723],
            [74.50843476430906, 21.38900869483329],
            [74.47847334093144, 21.34923523509482],
            [74.47381520425934, 21.30566161604623],
            [74.50188868984074, 21.28000624750036],
            [74.48998898573973, 21.24249187695352],
            [74.43467207983693, 21.23711286326218],
            [74.43746952526651, 21.25492179139449],
            [74.40931870999306, 21.26662386784929],
            [74.355665683196, 21.25220047748627],
            [74.35669987683268, 21.2322781682197],
            [74.33786512737585, 21.2286168207172],
            [74.31716430486628, 21.2301452194471],
            [74.31779154521719, 21.24839733283654],
            [74.29906178426161, 21.23800704859927],
            [74.24601237832911, 21.24817166717646],
            [74.17918085557278, 21.20978570533033],
            [74.15788802767152, 21.23078445993856],
            [74.14603050521565, 21.20689820894158],
            [74.12070022073492, 21.21335689616011],
            [74.05718130681647, 21.1699773626799],
            [74.09724804632721, 21.11044262650454],
            [74.02009575484948, 21.14163517356663],
            [73.95634510710994, 21.10253965636939],
            [73.94818315545936, 21.03151813582138],
            [73.90718106257474, 21.04359743002885],
            [73.8821878424556, 21.02623053115546],
            [73.85449364445385, 21.0326501467156],
            [73.8512049018052, 20.99763493673601],
            [73.90129759322264, 20.98230457353944],
            [73.90837226363985, 20.96719251193398],
            [73.88819919241956, 20.93359128830676],
            [73.91753820300735, 20.90778124223706],
            [73.92935156005966, 20.84235730241147],
            [73.96263549532473, 20.84251431913001],
            [73.96663691994738, 20.85443387967232],
            [74.00661946103504, 20.83621210123459],
            [74.01524353482802, 20.85381221908195],
            [74.0438840685804, 20.83471447304493],
            [74.06314956765921, 20.84893896628437],
            [74.09715014843489, 20.84102460056091],
            [74.12891043599532, 20.8647717043393],
            [74.14956525846819, 20.85033780507753],
            [74.15931074445183, 20.8621122736498],
            [74.29244381011962, 20.85543139180002],
            [74.333028741683, 20.83652181888203],
            [74.34901260858109, 20.85887277719383],
            [74.3826444361102, 20.84033290530796],
            [74.39624598235066, 20.86097280284281],
            [74.40290431197775, 20.83758265897956],
            [74.38942685735563, 20.8400295725307],
            [74.38826100354322, 20.83580567372278],
            [74.43982512901368, 20.79849802165668],
            [74.47885530559442, 20.83416209704542],
            [74.51186650440611, 20.80844330277387],
            [74.53627184566132, 20.83507154576523],
            [74.57261640691036, 20.83091312676929],
            [74.57284172974583, 20.8187799298926],
            [74.66449018192434, 20.7741585624935],
            [74.6497887324577, 20.69401577892752],
            [74.80135593679363, 20.66024889437261],
            [74.80000818785426, 20.63806442264389],
            [74.8229446846621, 20.62772913547851],
            [74.93045917411972, 20.65618335675721],
            [74.9563534456085, 20.69042245558465],
            [74.94806102987711, 20.72163363709741],
            [74.98940758416148, 20.73870386736728],
            [74.98838324334008, 20.76715176836779],
            [74.95884985232198, 20.8021370608431],
            [74.98470013527555, 20.82754478563267],
            [74.96363955879765, 20.85898467617515],
            [74.96106037986918, 20.90189593377221],
            [74.91210665823328, 20.92750444914798],
            [74.91098412377498, 20.96369081965477],
            [74.93123431084832, 20.96915091136209],
            [74.91055384338914, 21.03049726047935],
            [74.85787392983629, 21.06089661990912],
            [74.86936806171582, 21.10120990015272],
            [74.89333322814763, 21.14829792605157],
            [74.9639151615374, 21.1945428959852],
            [74.94429189666717, 21.22499316966566],
            [74.97413724855029, 21.22000988087281],
            [75.00343920833882, 21.18608098567303],
            [75.03775394798997, 21.19160464990968],
            [75.04428308336361, 21.21035798407225],
            [75.09987819603676, 21.23332410009046],
            [75.1529873890299, 21.32517373031639],
            [75.12042299542956, 21.34111740150843],
            [75.14817235410453, 21.34939467444202],
            [75.13809556255623, 21.38272208951737],
            [75.15852985391815, 21.40288111073933],
            [75.20655768483935, 21.41309940122333],
            [75.10716478146715, 21.46269494341961],
            [75.05331544558949, 21.56482449183731],
            [75.01502122633241, 21.56967738410247],
            [74.90168331540822, 21.62923801370779],
            [74.86505373942596, 21.62862088742468]
          ]
        ]
      }
    },
    {
      id: '9',
      type: 'Feature',
      properties: {
        Name: 'GADCHIROLI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'GADCHIROLI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '475',
        Shape_Leng: 920123,
        Shape_Area: 14017700000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [80.52159975377333, 20.83468095904978],
            [80.41420056359289, 20.8246940392287],
            [80.39158636067434, 20.80620688030154],
            [80.33164108816037, 20.81954634420086],
            [80.30906574624782, 20.72823697285296],
            [80.28114764799794, 20.7091902360835],
            [80.2735357553754, 20.6809779308791],
            [80.25080828347255, 20.67896968309939],
            [80.24261504351881, 20.65465676266611],
            [80.1626301591291, 20.69383827205252],
            [80.09324874791771, 20.69103350338433],
            [80.05877638271465, 20.71210560234471],
            [80.03224783816675, 20.70005942215488],
            [80.01641807224009, 20.66714056266777],
            [79.96476059957924, 20.69424312872016],
            [79.93472575079619, 20.6785272648671],
            [79.93924500117743, 20.60037469075608],
            [79.92581755119812, 20.55328866797096],
            [79.9519390968584, 20.52959920906832],
            [79.94012916462133, 20.44118765627118],
            [79.96515610179733, 20.41074828885929],
            [79.95823439182016, 20.38158503769751],
            [79.9721009527393, 20.35370360952233],
            [79.94370685893425, 20.28793351078053],
            [79.99214000930478, 20.22312005950873],
            [79.93441093246402, 20.19221283746328],
            [79.9118068559061, 20.14804994935851],
            [79.96802349061996, 20.11784551094088],
            [79.98907048254853, 20.04258316398059],
            [79.95221957372236, 19.98989601468694],
            [79.91258054837272, 19.96738445262413],
            [79.87713152419792, 19.98131764161186],
            [79.85243116681704, 20.02964733845652],
            [79.78790675711564, 20.01008323245296],
            [79.77038499506556, 19.96370157677556],
            [79.80315241474925, 19.89292625539388],
            [79.74092385308693, 19.82229324599221],
            [79.75335220080545, 19.75823579648444],
            [79.78363308804512, 19.72058556616757],
            [79.80453349409089, 19.57990343152268],
            [79.86458394968643, 19.51051365107803],
            [79.94481948357827, 19.46981440343878],
            [79.97793712760752, 19.40035740803864],
            [79.95908049470826, 19.33594022579851],
            [79.96587244023418, 19.30303874174201],
            [79.92450569438815, 19.22571788148978],
            [79.94589510505739, 19.16949262426822],
            [79.85842957213013, 19.10241622734731],
            [79.87110277654978, 19.04101693690684],
            [79.92891706481713, 19.04919432389243],
            [79.94037874397259, 19.0320130891649],
            [79.9616050312149, 18.86662660296353],
            [79.91403057006347, 18.82380669569597],
            [79.96415409972502, 18.77382500234033],
            [80.01854428419655, 18.77038297703387],
            [80.0527969519028, 18.72505881753293],
            [80.11812187011269, 18.6805167926585],
            [80.15770799598766, 18.70097975784206],
            [80.19656901852869, 18.68079545182788],
            [80.21277170585807, 18.70571773985367],
            [80.25223249850613, 18.70680667552806],
            [80.27241795900115, 18.72350522783652],
            [80.24769667984543, 18.76419675039984],
            [80.27592046225574, 18.76610876444125],
            [80.29993654083695, 18.79444716562655],
            [80.3514136290794, 18.81629220686751],
            [80.34926007314083, 18.84779912093967],
            [80.27025056188997, 18.93987589415214],
            [80.27320479021385, 18.99237072400737],
            [80.3031268117411, 19.02216332119625],
            [80.29733916399312, 19.04900589608144],
            [80.32966769499217, 19.0701067069808],
            [80.33307893589739, 19.14552382713643],
            [80.39384487509534, 19.18779757844381],
            [80.3890286056191, 19.2379681174174],
            [80.44840968056997, 19.26663171621941],
            [80.48249795577021, 19.3381358323199],
            [80.52033094080149, 19.34776955147383],
            [80.57592511916272, 19.40235696656879],
            [80.61254345357519, 19.30951802666828],
            [80.67989685189296, 19.33033204982941],
            [80.68969921079497, 19.28697519023713],
            [80.75529229051345, 19.28908171470687],
            [80.85285265170398, 19.36389994669488],
            [80.81733060236148, 19.38390679360021],
            [80.795849833927, 19.43226482396592],
            [80.87363088757473, 19.4449879588128],
            [80.89768431780949, 19.48044872061974],
            [80.89496487541079, 19.51962478972405],
            [80.85620742875926, 19.523002786241],
            [80.83559325819984, 19.56635683454564],
            [80.77510887803203, 19.56251191679713],
            [80.76942828401968, 19.5866697073326],
            [80.74084593419002, 19.60623087388883],
            [80.66533209762615, 19.61187916926505],
            [80.67221626208288, 19.70071594061987],
            [80.5526070053739, 19.76556051103142],
            [80.54630216415215, 19.81826573197188],
            [80.48058128277718, 19.82750578829896],
            [80.46887768027244, 19.81044672062318],
            [80.48496794074221, 19.8024772274057],
            [80.48902896917741, 19.7704103880311],
            [80.46425832745342, 19.79577505097474],
            [80.40169821632969, 19.79620072388946],
            [80.40162425721279, 19.81703798054508],
            [80.44072110154731, 19.81033379989093],
            [80.50582450939187, 19.87064975705827],
            [80.49142656835078, 19.90201332790674],
            [80.41388306566398, 19.90745113084908],
            [80.41125275860645, 19.93849386308975],
            [80.45215558922342, 19.95760401584191],
            [80.48874716895786, 19.93060735112159],
            [80.52989443581016, 19.93946732425398],
            [80.54960050252123, 19.98597146181638],
            [80.55681165986876, 20.07187671711234],
            [80.54400295547906, 20.09563739299126],
            [80.55207247494127, 20.11796153891395],
            [80.50559450426908, 20.1444391851783],
            [80.46014674568585, 20.15093819540216],
            [80.4333784808375, 20.13533031539153],
            [80.40181765192882, 20.14724431581751],
            [80.38853832404628, 20.16519898021835],
            [80.42205125630709, 20.20679901962706],
            [80.39525946613668, 20.24500900366079],
            [80.47913201765279, 20.27829662831386],
            [80.51881702577215, 20.26616689765829],
            [80.54957593028541, 20.30895788823312],
            [80.62635210645936, 20.33262641578027],
            [80.59148151013288, 20.3930707556799],
            [80.61364196352747, 20.43498095119229],
            [80.60217419130733, 20.44996060719742],
            [80.62658501194191, 20.56381239199422],
            [80.61734825864085, 20.58575241044763],
            [80.6318615506243, 20.5984024205367],
            [80.58076740500542, 20.60836446189206],
            [80.52092818149879, 20.58047810752702],
            [80.5044138358369, 20.58335338264014],
            [80.4941494610901, 20.6125041660092],
            [80.49565009105851, 20.63684840290838],
            [80.517926792715, 20.65506227156629],
            [80.58765166346687, 20.68406746971579],
            [80.55166346252649, 20.7640345161408],
            [80.56173579041707, 20.82346363317997],
            [80.52159975377333, 20.83468095904978]
          ]
        ]
      }
    },
    {
      id: '10',
      type: 'Feature',
      properties: {
        Name: 'GONDIA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'GONDIA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '476',
        Shape_Leng: 527556,
        Shape_Area: 4995330000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [80.20653776662573, 21.63562879431239],
            [80.15461698749306, 21.60647102802792],
            [80.12133339814771, 21.61087639821197],
            [80.07221333084897, 21.55678926424865],
            [80.03286540282345, 21.55621399188938],
            [80.00052640964331, 21.53373222903798],
            [79.96964415972288, 21.55834644244688],
            [79.9328394341643, 21.55503970876496],
            [79.91780210015854, 21.52441014028309],
            [79.92767520045606, 21.49543446327465],
            [79.88034960064088, 21.42610311133966],
            [79.79595644371553, 21.37367340779282],
            [79.81322395387757, 21.35583474687136],
            [79.81296224053949, 21.32127214531323],
            [79.8334544127339, 21.31009363780671],
            [79.83130070772269, 21.26340760951215],
            [79.86392940065382, 21.25186349696826],
            [79.84101546188572, 21.25689394071202],
            [79.84010654832196, 21.25383739332211],
            [79.90592634042754, 21.24472278469902],
            [79.93899124690319, 21.25493954685283],
            [80.00278338148057, 21.21812577111987],
            [80.02311564951579, 21.22864529328079],
            [80.02448957578974, 21.21301533141011],
            [80.07288256626913, 21.18698453209727],
            [80.08211757141082, 21.11859552761824],
            [80.06101443692013, 21.09917970020109],
            [80.07536843804077, 21.09842363189941],
            [80.06969726804982, 21.0815902927662],
            [80.08428113842204, 21.07369920852988],
            [80.06303950722878, 21.03070651969903],
            [80.09587350692173, 21.03284267861614],
            [80.10209680840217, 20.99042517643564],
            [80.07636678578456, 20.98966589808053],
            [80.06206811064584, 20.94894138305669],
            [80.03718035921872, 20.96503807531987],
            [80.04548630570855, 20.95713972716201],
            [80.03037409265808, 20.94517832467967],
            [80.03242044667684, 20.9576143345253],
            [79.95279051076797, 20.94111978569818],
            [79.96896008735884, 20.93997467710839],
            [79.96181594046833, 20.9173632605766],
            [79.97720890699115, 20.89013587903195],
            [79.96466250854859, 20.88728919457031],
            [79.96548028223594, 20.85488355330193],
            [79.9797706556352, 20.83595387409396],
            [79.98256702781877, 20.86210595582514],
            [79.9991707449446, 20.85047637906234],
            [79.98783441451592, 20.82696558696673],
            [79.95112844742825, 20.82611734701497],
            [79.95914362358252, 20.8129317402283],
            [79.94054417090825, 20.80137204954423],
            [79.94728948957476, 20.7799365578153],
            [79.9797042413353, 20.77303319022361],
            [79.95534901368457, 20.76597462776048],
            [79.9714341051532, 20.74507080145819],
            [79.94429432489228, 20.72090405831394],
            [79.96925902906499, 20.71531853161634],
            [79.96654938101629, 20.69192609557257],
            [80.00625191167744, 20.66902393504514],
            [80.05877638271454, 20.71210560234466],
            [80.09324874791771, 20.69103350338433],
            [80.16263015912905, 20.69383827205245],
            [80.24261504351865, 20.65465676266607],
            [80.2508082834724, 20.67896968309935],
            [80.27353575537529, 20.6809779308791],
            [80.28114764799783, 20.7091902360835],
            [80.30906574624771, 20.72823697285296],
            [80.33230261599799, 20.81990891859281],
            [80.39158636067434, 20.80620688030154],
            [80.41420056359284, 20.8246940392287],
            [80.52159975377333, 20.83468095904978],
            [80.56173579041707, 20.82346363317989],
            [80.54605784156139, 20.93501308224007],
            [80.4636958705327, 20.92919856119958],
            [80.44377248216182, 20.99404069691325],
            [80.42426268267371, 21.00850269538398],
            [80.45264425358049, 21.03883077777783],
            [80.43914724698176, 21.09656030410455],
            [80.45811761817072, 21.11486895375918],
            [80.44471246150142, 21.12196057430494],
            [80.46426127153437, 21.17502764760512],
            [80.61378246066867, 21.22656624789922],
            [80.6795678398406, 21.29883696359103],
            [80.66314032163773, 21.3343725841405],
            [80.59988540077858, 21.32679752565402],
            [80.52762243832457, 21.39487045655998],
            [80.45755687642388, 21.40268427088012],
            [80.44863171108689, 21.37205386231501],
            [80.41223597947634, 21.37671749950668],
            [80.39603515283255, 21.40810715607437],
            [80.42215511593078, 21.44053950368318],
            [80.37650014375775, 21.52327846180725],
            [80.33131199734301, 21.54754218397311],
            [80.33930780101402, 21.55507730646292],
            [80.32136853061536, 21.57587059590738],
            [80.29806167453806, 21.57581014780565],
            [80.26672531884384, 21.61854368346035],
            [80.22147856110523, 21.62096991859643],
            [80.20653776662573, 21.63562879431239]
          ]
        ]
      }
    },
    {
      id: '11',
      type: 'Feature',
      properties: {
        Name: 'HINGOLI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'HINGOLI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '477',
        Shape_Leng: 498581,
        Shape_Area: 4555530000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [77.01044567398706, 20.00347520443819],
            [76.99216843259394, 20.01710460805274],
            [76.98834823992378, 19.99806629984777],
            [76.92234719969177, 19.97586668504514],
            [76.89538096399734, 19.94913345526356],
            [76.83728473131686, 19.96390865124513],
            [76.82135870950366, 19.92919911305107],
            [76.7722891200375, 19.93577546331059],
            [76.76540139121194, 19.90440575895941],
            [76.74714844205259, 19.91230625835822],
            [76.74026621017852, 19.87331115622772],
            [76.69294865597196, 19.8740006273452],
            [76.6812030667556, 19.84699121563253],
            [76.63321301357122, 19.86898819912076],
            [76.61082751252287, 19.83749353590029],
            [76.51902241375626, 19.8499974268594],
            [76.5127704659331, 19.82413252155842],
            [76.56326321347319, 19.81532940797046],
            [76.59413012055903, 19.83036920741345],
            [76.6099833975404, 19.79181612312668],
            [76.59631500634201, 19.77715467441434],
            [76.62731162972803, 19.78401238962839],
            [76.62737439992958, 19.80405713103487],
            [76.64199110653749, 19.77369763968858],
            [76.66931719473375, 19.77548455245181],
            [76.69118194841332, 19.75504371476949],
            [76.71687820130079, 19.76888004341107],
            [76.71992626165877, 19.74110231255246],
            [76.7388960660072, 19.72944306559996],
            [76.73234964533869, 19.71424130773613],
            [76.76069115253348, 19.68541665520688],
            [76.78394377822976, 19.73131322467588],
            [76.79104781030219, 19.6704410302763],
            [76.80716133227496, 19.68302230827548],
            [76.823195838272, 19.67263098597029],
            [76.81922208941376, 19.70685046691533],
            [76.84963659948694, 19.70673216398484],
            [76.86357369173743, 19.67614011404034],
            [76.85032652269298, 19.65106824224973],
            [76.87031623834258, 19.64658963518089],
            [76.86713539652165, 19.62404247208811],
            [76.90797392695352, 19.64527191018489],
            [76.93003234397065, 19.61107207867345],
            [76.89269200932718, 19.58252897927917],
            [76.8826318147153, 19.53374833710999],
            [76.85699293956571, 19.53549309764959],
            [76.85608637788378, 19.49151058808924],
            [76.86606495937532, 19.46823409466721],
            [76.88759887910334, 19.46205973303288],
            [76.865055328072, 19.43901390122038],
            [76.92524538655918, 19.43739580191608],
            [76.89214505361313, 19.37912698652671],
            [76.88950826943585, 19.3501947030141],
            [76.9160567183402, 19.33858704099896],
            [76.88929490398232, 19.32273027806638],
            [76.89116108213788, 19.30802975001944],
            [76.9227058916298, 19.29830407221585],
            [76.9229049031055, 19.31024948725094],
            [76.98022237087815, 19.31970192701793],
            [76.995226437656, 19.27510302414647],
            [77.02208861447623, 19.28518677838504],
            [77.00975191937914, 19.2698629278687],
            [77.02462842479581, 19.24766386940748],
            [77.07835435574323, 19.25730263040999],
            [77.09830703568537, 19.23579495193751],
            [77.1788837645733, 19.22626596966375],
            [77.22018106106447, 19.27573968134575],
            [77.23545151145896, 19.27520079200672],
            [77.24134968981285, 19.32286091389929],
            [77.28072519810712, 19.3160222557134],
            [77.31074388095647, 19.33076502693865],
            [77.31167505068875, 19.35503379761265],
            [77.38531783205792, 19.3398775570308],
            [77.41652874822178, 19.38061862513922],
            [77.44727990803017, 19.3863416640524],
            [77.4359582670128, 19.40711239508628],
            [77.44815157411972, 19.44051153368886],
            [77.4701769265933, 19.43799302940446],
            [77.47372903386507, 19.45880659742359],
            [77.48654201806306, 19.4581562979697],
            [77.48958060893558, 19.49323889905538],
            [77.47002511799622, 19.49089780029617],
            [77.46625360415845, 19.56407231087628],
            [77.45089599957554, 19.56905289870828],
            [77.47936677167083, 19.59957712266204],
            [77.46260412459971, 19.61144656707602],
            [77.46651897728681, 19.66424443644569],
            [77.44959750904955, 19.67372144471348],
            [77.45903379602315, 19.68235617507808],
            [77.43185016441782, 19.73046874020749],
            [77.40910318913592, 19.74561621719677],
            [77.3804424431688, 19.7294109463196],
            [77.38318383398774, 19.76609302855186],
            [77.40451203731904, 19.77298565151252],
            [77.37764674612981, 19.78684922647734],
            [77.38946425566559, 19.81855994612097],
            [77.34403047830563, 19.82536154708169],
            [77.36403328637948, 19.858893589792],
            [77.34548944934556, 19.87711045301965],
            [77.29528156421425, 19.88432812732464],
            [77.31267528587267, 19.91457624696771],
            [77.29223302485697, 19.90335688746735],
            [77.27115676949917, 19.91957834948698],
            [77.26628918004498, 19.89763879261494],
            [77.23652444777424, 19.88943456539827],
            [77.23822152329831, 19.93453085036052],
            [77.20549206079538, 19.94211400601701],
            [77.21488698535597, 19.97331946943102],
            [77.20209133528215, 19.99062698750242],
            [77.10260847238472, 19.93142898023577],
            [77.06162820042869, 19.99388755311353],
            [77.03413523505274, 20.00932713302813],
            [77.01044567398706, 20.00347520443819]
          ]
        ]
      }
    },
    {
      id: '12',
      type: 'Feature',
      properties: {
        Name: 'JALGAON',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'JALGAON',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '478',
        Shape_Leng: 824988,
        Shape_Area: 11369800000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [75.24245030289593, 21.41056448540891],
            [75.15852985391815, 21.40288111073933],
            [75.13788373480652, 21.38207211902154],
            [75.14800156319835, 21.34904885692972],
            [75.12030227405383, 21.3430021673699],
            [75.15294510903747, 21.32501166082152],
            [75.13610117447118, 21.31552574336368],
            [75.13838857897063, 21.29026147420308],
            [75.10623070635577, 21.2395610366609],
            [75.04428308336361, 21.21035798407225],
            [75.03775394798997, 21.19160464990968],
            [75.00343920833882, 21.18608098567303],
            [74.97413724855029, 21.22000988087281],
            [74.94429189666717, 21.22499316966566],
            [74.9639151615374, 21.1945428959852],
            [74.89333322814763, 21.14829792605157],
            [74.86936806171582, 21.10120990015272],
            [74.85772252506062, 21.06126921956832],
            [74.88944725745891, 21.05146738657078],
            [74.91854955263688, 21.01404863074796],
            [74.93123431084832, 20.96915091136209],
            [74.91098412377498, 20.96369081965477],
            [74.91210665823328, 20.92750444914798],
            [74.96106037986918, 20.90189593377221],
            [74.96363955879765, 20.85898467617515],
            [74.98470013527555, 20.82754478563267],
            [74.95884985232198, 20.8021370608431],
            [74.9913749898954, 20.7547678949232],
            [74.98594480459303, 20.73346991916236],
            [74.94806102987711, 20.72163363709741],
            [74.9563534456085, 20.69042245558465],
            [74.93045917411972, 20.65618335675721],
            [74.81270681786577, 20.63198031345824],
            [74.79547883280803, 20.539659338474],
            [74.76112263607898, 20.53742610101916],
            [74.78388210604432, 20.49736909287645],
            [74.77071550438636, 20.47242690781025],
            [74.7983626571434, 20.47231296091756],
            [74.80227021570137, 20.44564643086832],
            [74.83778856848114, 20.41428606943702],
            [74.82421820350221, 20.39823031793726],
            [74.85154271992424, 20.38093564599398],
            [74.86495603367239, 20.32028443253851],
            [74.85170726672654, 20.28614722879476],
            [74.86358063520055, 20.27644775546736],
            [74.95418809860573, 20.27183179710218],
            [74.94493013830267, 20.28783192482024],
            [74.96632143514245, 20.3069732408361],
            [75.00532117454676, 20.29369341314192],
            [74.99951995109359, 20.33596421330269],
            [75.05488887241684, 20.30575529550447],
            [75.05599563166268, 20.33333939119498],
            [75.0747368346526, 20.33855199182543],
            [75.08975878047364, 20.33217976294516],
            [75.08182332117103, 20.31557161087467],
            [75.11088903983944, 20.3101898200707],
            [75.12240953907059, 20.36329290688917],
            [75.10583111524329, 20.41191181741827],
            [75.12465737381457, 20.4319738399203],
            [75.17418545010982, 20.44242152965593],
            [75.15979832008537, 20.47648186709683],
            [75.19723590845959, 20.47543171655483],
            [75.20505370309525, 20.49896782507476],
            [75.22646109765675, 20.49441422127201],
            [75.2567921440574, 20.57479757669342],
            [75.2911681407745, 20.5664263167304],
            [75.31642220084113, 20.5745998327472],
            [75.31847981844167, 20.59162392952605],
            [75.35844752634982, 20.59607085150522],
            [75.36460437976284, 20.57502347416083],
            [75.3886789696212, 20.57780951881014],
            [75.39567773543901, 20.52060881208265],
            [75.42867676292964, 20.51161093364227],
            [75.42319498475449, 20.53037633544097],
            [75.44671019968028, 20.53733870338595],
            [75.45446848646549, 20.5135677258226],
            [75.45579859972986, 20.55076483614699],
            [75.49299463282091, 20.52364216299953],
            [75.50429585813667, 20.55102112868195],
            [75.52848635447245, 20.55599502246879],
            [75.52059236982302, 20.59008588180794],
            [75.53498451642095, 20.60604389743275],
            [75.59295824918054, 20.59956332569663],
            [75.61272003637575, 20.60276028212901],
            [75.60534649699612, 20.62165728175454],
            [75.65981013487388, 20.62431630352311],
            [75.66702659947688, 20.66831449899787],
            [75.70358340475809, 20.6588280575447],
            [75.69941223955293, 20.61400980668222],
            [75.75873563335277, 20.61050050126141],
            [75.75697802638801, 20.57383251872948],
            [75.78487722511015, 20.58350033248811],
            [75.78611729516543, 20.56188843601488],
            [75.83124803795532, 20.55559181771001],
            [75.84726916338566, 20.56632366235612],
            [75.82814247339824, 20.57120240890946],
            [75.83678250229745, 20.61424973708512],
            [75.86358189950238, 20.6218076270476],
            [75.86872738842496, 20.59782869700434],
            [75.88709855570134, 20.5916698768707],
            [75.88292316632874, 20.56074358053171],
            [75.92659549446158, 20.54578738625078],
            [75.93233999108153, 20.58664635417271],
            [75.9492348613337, 20.56888781342631],
            [75.97282275096666, 20.58041497537044],
            [75.95477127328299, 20.62058433850518],
            [75.98759594758064, 20.61607979815785],
            [76.00842187372518, 20.63610934543616],
            [75.99430798545039, 20.69987196350355],
            [76.0157847948891, 20.73017478269183],
            [75.98533364649255, 20.76098896182203],
            [75.99519878582038, 20.7779989862354],
            [76.05043246924963, 20.79002732387919],
            [76.04864729919497, 20.81586300629442],
            [76.11264790885343, 20.88667043022751],
            [76.07783722424269, 20.90865122209921],
            [76.0799784371304, 20.92819177310353],
            [76.15824208792803, 21.0027906043536],
            [76.16482835201055, 21.03641088024903],
            [76.26619074207709, 20.98014875779428],
            [76.27934333001906, 20.95739591961514],
            [76.34495655225227, 20.95125967605474],
            [76.38037562189841, 20.9770224475715],
            [76.3986560568348, 21.0331341129299],
            [76.38514666255536, 21.08194213532881],
            [76.2801316302784, 21.07068852541902],
            [76.27263266937304, 21.08873926266914],
            [76.2449733177748, 21.09043926212811],
            [76.16740076469762, 21.07948439606194],
            [76.17088709958183, 21.10393306075338],
            [76.13441966653772, 21.12414802183672],
            [76.14246842352539, 21.13515284797097],
            [76.1115825278576, 21.16676948321732],
            [76.17168618630762, 21.1665603962734],
            [76.17639598828293, 21.18399521241189],
            [76.16565907548112, 21.22161589176624],
            [76.14203615369162, 21.22816347739204],
            [76.15936112497538, 21.25597499637395],
            [76.12974038088053, 21.28670463308744],
            [76.0965993125587, 21.37176948557002],
            [76.04858570507572, 21.34973371872783],
            [75.96305971707557, 21.38970987738399],
            [75.91065814783057, 21.38257449808006],
            [75.88561357653523, 21.39470910152545],
            [75.83336373232821, 21.37663652937972],
            [75.72847084957108, 21.38868364789541],
            [75.67009030901207, 21.37457934003692],
            [75.6230254677176, 21.37502348045365],
            [75.60693955587065, 21.39184408642181],
            [75.54372432653149, 21.36852798188467],
            [75.52005437232727, 21.38701642849271],
            [75.38243838150917, 21.37954243224425],
            [75.35716192214369, 21.40086532025548],
            [75.29874023803804, 21.38556727092348],
            [75.29572627555864, 21.41339738743555],
            [75.24245030289593, 21.41056448540891]
          ]
        ]
      }
    },
    {
      id: '13',
      type: 'Feature',
      properties: {
        Name: 'JALNA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'JALNA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '479',
        Shape_Leng: 700657,
        Shape_Area: 7419970000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [75.58366609168097, 19.96451248429453],
              [75.56162518629934, 19.9648538726526],
              [75.56207121288453, 19.93980280078518],
              [75.59214666998473, 19.94270636935412],
              [75.59624502538206, 19.96019927138226],
              [75.58366609168097, 19.96451248429453]
            ]
          ],
          [
            [
              [75.87403011679709, 20.5541552944734],
              [75.8604706378101, 20.56074692077935],
              [75.88367520586603, 20.52702431019324],
              [75.86059217774537, 20.52379943812042],
              [75.8474566158089, 20.48828322001405],
              [75.89405538879639, 20.44537886249051],
              [75.86266139250367, 20.43989808306608],
              [75.85512272835945, 20.46021801976331],
              [75.81969623955847, 20.47208876899326],
              [75.7945668448137, 20.45023523207406],
              [75.7639761325124, 20.45198430511826],
              [75.73262618024614, 20.4071313644476],
              [75.74917707166281, 20.40222782046742],
              [75.74560098258836, 20.37058142348071],
              [75.77054540661486, 20.33638551885653],
              [75.71643094581442, 20.330408669113],
              [75.68177966885372, 20.30632779790907],
              [75.6950977537473, 20.28233561729154],
              [75.67420482646794, 20.23324752806718],
              [75.67866504843306, 20.19079104130264],
              [75.64600635648706, 20.18813736878899],
              [75.6241580205657, 20.10027457079848],
              [75.58635874148501, 20.09789879400699],
              [75.5886704995119, 20.06358155214274],
              [75.60432440056094, 20.05337662319938],
              [75.59244685444845, 20.00638260483083],
              [75.64447442104456, 20.00697880657764],
              [75.6511039195426, 19.94972683953963],
              [75.68059760004208, 19.92452491989742],
              [75.65677977933393, 19.9125095840135],
              [75.64489266887325, 19.84210118805395],
              [75.6584986777328, 19.82251846516201],
              [75.6336024192176, 19.81168353510397],
              [75.64442292235641, 19.78005653880804],
              [75.62358698363424, 19.77200001783225],
              [75.62923819307808, 19.66032199399057],
              [75.5851458118074, 19.6383009103233],
              [75.59798571639624, 19.60011654891986],
              [75.64920888565815, 19.59543579021471],
              [75.65604199717706, 19.5681506430678],
              [75.63154130350769, 19.46463606311099],
              [75.61390049647567, 19.4676485860043],
              [75.6046750408609, 19.45217545602485],
              [75.60612819451806, 19.38353834668208],
              [75.71424438688518, 19.3542199310828],
              [75.75093231556109, 19.35608319182222],
              [75.75641156817476, 19.38765507367753],
              [75.78540004056623, 19.39954160388037],
              [75.84048077319794, 19.37148486723453],
              [75.91203246429457, 19.39216853341169],
              [75.92502757897682, 19.38270040028077],
              [75.9064945306913, 19.31833118439129],
              [75.93515784502324, 19.29337962839118],
              [76.02020091603539, 19.33764346920854],
              [76.03966819780139, 19.28363982010133],
              [76.08793413047827, 19.28093527290641],
              [76.10270086016186, 19.3080673789845],
              [76.20760104089362, 19.27698896851467],
              [76.21117835151391, 19.31899738402706],
              [76.23020854094091, 19.31346906443032],
              [76.23948189411647, 19.336554524725],
              [76.27548508008987, 19.34437981359324],
              [76.25742141898492, 19.35664448613177],
              [76.28279940056056, 19.36561781317111],
              [76.28883532751193, 19.43307415165167],
              [76.30140125489122, 19.43178150937409],
              [76.31322988860121, 19.46670010358489],
              [76.33593020609392, 19.45365163564926],
              [76.34282695523291, 19.47285427834197],
              [76.36421727247745, 19.47080028473582],
              [76.37572311649991, 19.53695266878771],
              [76.4421423804764, 19.54156433506728],
              [76.44793727757269, 19.58474079658859],
              [76.43236935146501, 19.60215515403634],
              [76.45087527343105, 19.61428401094664],
              [76.44940222757936, 19.65967808642226],
              [76.48793823279438, 19.68418473787925],
              [76.48390041506276, 19.72143587966346],
              [76.45938861362741, 19.72519158014867],
              [76.45954337950377, 19.74725334486883],
              [76.51014730820839, 19.76082310437249],
              [76.48345041198964, 19.79763485765149],
              [76.5114465212527, 19.79896971027812],
              [76.53450828203485, 19.86552951236188],
              [76.49276158399822, 19.89379502745738],
              [76.49356938327357, 19.92015920817681],
              [76.40528529796228, 19.91979770883914],
              [76.3928168551007, 19.9049176445058],
              [76.36602249479624, 19.92850075656175],
              [76.33645899352224, 19.88367859647298],
              [76.13993186021156, 19.84406623490734],
              [76.12933136456996, 19.86501978597922],
              [76.09754971337479, 19.85695851290307],
              [76.08111677126675, 19.91253688080089],
              [76.0585780819011, 19.91867618501669],
              [76.04814073486473, 19.94596792628333],
              [75.96762758766319, 19.9863085843366],
              [75.96564836664943, 20.00278988002789],
              [76.02331934745041, 20.02429831323688],
              [76.01879780518868, 20.05840119124501],
              [76.06953061497326, 20.07280162262152],
              [76.05446150749674, 20.09634881248154],
              [76.09472639341824, 20.09629495696281],
              [76.10881283964743, 20.16243332067929],
              [76.14985421788602, 20.20594915381933],
              [76.13292664408554, 20.22244479403231],
              [76.16638514743904, 20.23843421688406],
              [76.19382177404809, 20.30015373566094],
              [76.14091390448517, 20.30052518662141],
              [76.1261274254137, 20.34492951842589],
              [76.09426010974653, 20.34723339859598],
              [76.08577174970195, 20.36523724618446],
              [76.04682663910025, 20.33712431195635],
              [76.02836524866639, 20.28905528030656],
              [75.97000768515325, 20.3158309999301],
              [75.92887477514925, 20.30221383410997],
              [75.94164309852685, 20.36890840498554],
              [75.96683324648257, 20.37295145243121],
              [75.94143142725986, 20.42480235226206],
              [75.9570258156549, 20.46454331465276],
              [75.94065330743138, 20.49866406448987],
              [75.96955393557882, 20.52309850432589],
              [75.97147000178383, 20.53805058584041],
              [75.95574763281813, 20.53009102005873],
              [75.91830637819616, 20.55431603213542],
              [75.87403011679709, 20.5541552944734]
            ]
          ]
        ]
      }
    },
    {
      id: '14',
      type: 'Feature',
      properties: {
        Name: 'KOLHAPUR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'KOLHAPUR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '480',
        Shape_Leng: 945182,
        Shape_Area: 7506210000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.78046600718949, 17.18091938036867],
            [73.76780584951744, 17.1743288080647],
            [73.77318791972874, 17.14962895185048],
            [73.74723572647834, 17.15508547686131],
            [73.742571736979, 17.17647975270649],
            [73.71317698837005, 17.17368771554942],
            [73.68931498061737, 17.14180941049849],
            [73.73648608225737, 17.12143898490112],
            [73.74980593226142, 17.12949278263049],
            [73.80711046873243, 17.08622185188357],
            [73.80360231741231, 17.0625217865978],
            [73.8325489497311, 17.05822903548981],
            [73.83414473232581, 17.00029350467099],
            [73.8218204142037, 16.98798995371574],
            [73.78596211259976, 16.99306556398945],
            [73.76514123903083, 16.96826824101929],
            [73.79515996351667, 16.92991727945818],
            [73.78829121946298, 16.90679513339185],
            [73.73652507054074, 16.91472358087983],
            [73.76714252037, 16.86592900716669],
            [73.76492528056991, 16.8290245312923],
            [73.73782324455362, 16.8450938177186],
            [73.71141988209742, 16.82791973688522],
            [73.76045040185686, 16.80253800561138],
            [73.76083977253012, 16.77001340447664],
            [73.81271553757821, 16.76888428500824],
            [73.8375655920125, 16.73803098257837],
            [73.81087639693904, 16.70823062495867],
            [73.85958179408452, 16.68117613863852],
            [73.84793319298738, 16.64288396644995],
            [73.86237922102505, 16.61403644624839],
            [73.83096267394335, 16.5496649982682],
            [73.82145229777188, 16.55109937352928],
            [73.81481516607695, 16.54424011657058],
            [73.84717750890479, 16.52623175539239],
            [73.8516145717014, 16.48763025394609],
            [73.88754316532383, 16.46339493186911],
            [73.83404462019475, 16.40148375243968],
            [73.86327624205647, 16.3727861457508],
            [73.83213055921316, 16.34500255112328],
            [73.84589115448013, 16.30037240888292],
            [73.85640433338145, 16.31727163418073],
            [73.86381290555052, 16.30853670901036],
            [73.902195529114, 16.32863114421191],
            [73.88180175127121, 16.278831884509],
            [73.91749987368739, 16.2456537705602],
            [73.89272293559422, 16.23385567458562],
            [73.88937527219512, 16.22904543669313],
            [73.94286387826372, 16.24378821803574],
            [73.91779543581362, 16.21819845379401],
            [73.9226348330926, 16.20211515329792],
            [73.95649952735401, 16.20327149320611],
            [73.94272875196584, 16.17450893918848],
            [73.91465334667761, 16.17184109858373],
            [73.90605994404225, 16.13578436950202],
            [73.84486828645053, 16.15309643524186],
            [73.85363098769064, 16.13471596674423],
            [73.83393684382555, 16.09395587163748],
            [73.85995211382571, 16.06994479030483],
            [73.84377668795082, 16.09390868773437],
            [73.86291817832317, 16.10716957800312],
            [73.89590251480494, 16.08894861389787],
            [73.90524809622195, 16.10090048923298],
            [73.9959524271763, 16.09273402560193],
            [73.99101034347235, 16.07942244801383],
            [74.01137425286687, 16.0666321763518],
            [73.99706260978287, 16.05963124704313],
            [74.00072703203152, 16.04128380022325],
            [74.04401473230723, 16.03116386731399],
            [74.06004476259176, 16.05107681687342],
            [74.09103622416157, 16.01473627286375],
            [74.0455815516649, 15.95711541215805],
            [74.05965966206766, 15.94182441257157],
            [74.07306047666754, 15.94877925013442],
            [74.0929691077376, 15.87307603442387],
            [74.03036704591295, 15.83464082899336],
            [74.03453380202937, 15.80269906153139],
            [74.08416576480805, 15.83839933558128],
            [74.10288149538474, 15.84086121260169],
            [74.10894653716453, 15.82268357057912],
            [74.14572189400178, 15.83288416560305],
            [74.1409558443265, 15.82338864048749],
            [74.15881716583141, 15.82182578108428],
            [74.15362507417883, 15.78682019298695],
            [74.17249527729129, 15.77381013923132],
            [74.22833979165068, 15.78833841688275],
            [74.23821989217545, 15.74406115087994],
            [74.3078987827887, 15.74848066588483],
            [74.32306971934428, 15.77267659439416],
            [74.34568444799396, 15.76455506400827],
            [74.36907400518106, 15.78819737357388],
            [74.3603475826116, 15.81685986283999],
            [74.3830853643099, 15.84910493704329],
            [74.3382090127758, 15.85491874246857],
            [74.36469511464736, 15.89386178989465],
            [74.38814029486285, 15.85425256999566],
            [74.40617067997027, 15.85537646634565],
            [74.38686531560684, 15.90498126830652],
            [74.4308304243295, 15.95658243403038],
            [74.46322295637445, 16.03919173770336],
            [74.42969441247602, 16.05915145610123],
            [74.37340109820155, 16.03644348376869],
            [74.37733522557483, 16.05512048681699],
            [74.36132818925475, 16.0538358945346],
            [74.37221852401206, 16.07821030421506],
            [74.42761928501932, 16.11196505135238],
            [74.4843049008034, 16.09146824866066],
            [74.47983240336742, 16.14712507139643],
            [74.5079952240535, 16.20225830686421],
            [74.48047951346398, 16.25012565744795],
            [74.46862055008148, 16.24018543093105],
            [74.4176107229779, 16.25800065265836],
            [74.41439483521533, 16.28265109126114],
            [74.37300880593789, 16.26163570210581],
            [74.3455969155802, 16.29376251286032],
            [74.35046026515981, 16.2753667353617],
            [74.32493375931114, 16.27175626083208],
            [74.32082574272003, 16.28447545276045],
            [74.34254818772196, 16.2980273381478],
            [74.31660662995536, 16.32656154663515],
            [74.32703463266897, 16.34250946901364],
            [74.31719263492727, 16.38100374452026],
            [74.3358693799161, 16.39374156813482],
            [74.35340990742401, 16.36641874303803],
            [74.36369430974649, 16.4050913212733],
            [74.33505434408369, 16.40140737900998],
            [74.3325915586248, 16.45475876028149],
            [74.28927516797071, 16.462970503776],
            [74.29089500729987, 16.5049020755103],
            [74.26077014758339, 16.48009659559841],
            [74.24737277532068, 16.49691320076061],
            [74.27821623293, 16.50491450766828],
            [74.26413107609257, 16.53983047847023],
            [74.30137135169834, 16.52926953404933],
            [74.30614265031743, 16.50369289862975],
            [74.31571340709229, 16.55445467765187],
            [74.35624656084481, 16.55974732668279],
            [74.35792549078353, 16.53834202410775],
            [74.37983255979672, 16.52859226501927],
            [74.39662592659637, 16.5832675181954],
            [74.46671146006054, 16.60682236271744],
            [74.45478238469134, 16.64729547929354],
            [74.4717122019404, 16.66405476557237],
            [74.4890338278503, 16.63014483538816],
            [74.5444889955936, 16.63546867532741],
            [74.54349270234275, 16.59531858294555],
            [74.5668942475342, 16.58538858896754],
            [74.5557814606729, 16.56297828653025],
            [74.57238069660241, 16.55349240237353],
            [74.60102181415836, 16.56489799005648],
            [74.63565208369921, 16.5836124243998],
            [74.63930599583256, 16.6101217255539],
            [74.68843417763065, 16.60847146980177],
            [74.65347815143222, 16.6388294511096],
            [74.68955034601989, 16.67702566116737],
            [74.68082499820851, 16.68589174372813],
            [74.69992940802075, 16.73502029002866],
            [74.64583311569884, 16.75236300135309],
            [74.62943318240225, 16.78795126735199],
            [74.56059510324417, 16.8062186433126],
            [74.51694370210926, 16.85813793388628],
            [74.50057313306654, 16.82963054118188],
            [74.49503355935519, 16.85781431955235],
            [74.47255667985529, 16.86847744986068],
            [74.41464015496497, 16.84395120454688],
            [74.40405545827535, 16.85138455303326],
            [74.41567646379436, 16.87767462531039],
            [74.4015289708148, 16.88300721276184],
            [74.36202953901606, 16.85344226167614],
            [74.35419965320523, 16.8727763357051],
            [74.29554820813924, 16.89464114236001],
            [74.28181621767578, 16.9185158406458],
            [74.24695325383574, 16.88641952941644],
            [74.22316543869114, 16.91368654726109],
            [74.20973385708253, 16.89301942103942],
            [74.17519633362843, 16.90253657411699],
            [74.14558992181749, 16.88273144165689],
            [74.12073139211468, 16.91317732790037],
            [74.09147443164478, 16.91826092596784],
            [74.06570684437675, 16.90237983371757],
            [74.02296192158099, 16.94230437726907],
            [74.0233538706637, 16.98515173546376],
            [73.97348639257585, 16.99014923967185],
            [73.97925353944063, 17.03450879393331],
            [73.95791765411771, 17.05749597044874],
            [73.91381549452791, 17.07143328931983],
            [73.84650450023783, 17.15422550456801],
            [73.78046600718949, 17.18091938036867]
          ],
          [
            [74.28746038017483, 15.83131467052411],
            [74.31290609052684, 15.79820093445294],
            [74.3023399967115, 15.78745980006453],
            [74.26647480081078, 15.79779548679461],
            [74.26166133790669, 15.8295910493064],
            [74.28746038017483, 15.83131467052411]
          ]
        ]
      }
    },
    {
      id: '15',
      type: 'Feature',
      properties: {
        Name: 'LATUR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'LATUR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '481',
        Shape_Leng: 549558,
        Shape_Area: 6991880000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [76.90727560869179, 18.83898525033095],
            [76.86694149112547, 18.83019257078981],
            [76.85351731445076, 18.80697210020595],
            [76.79025477668654, 18.80014912333426],
            [76.77734687838245, 18.77608201714362],
            [76.74282094967883, 18.77569590882322],
            [76.72328649316965, 18.7501282410406],
            [76.73378176699951, 18.70009619061312],
            [76.6820848712609, 18.69199310371489],
            [76.66243884572775, 18.65972115871496],
            [76.68131421267812, 18.65003091317082],
            [76.67870748473418, 18.63447879822776],
            [76.63629440121895, 18.64836532439828],
            [76.63501258477599, 18.67435064140914],
            [76.59488020201006, 18.67251129440639],
            [76.57834886145332, 18.61947988471628],
            [76.54102762120569, 18.65103982111125],
            [76.49962410989384, 18.60403223942914],
            [76.4654697372185, 18.63509848776984],
            [76.39202585318138, 18.59606613089452],
            [76.39065185971913, 18.542266971149],
            [76.34921529239689, 18.5653662625078],
            [76.27849599325555, 18.57417225497706],
            [76.27448627922729, 18.53790717690394],
            [76.25296562991117, 18.52202357916066],
            [76.26695137927648, 18.42267735925095],
            [76.22569020391747, 18.43402404362719],
            [76.20348803162142, 18.39470865812542],
            [76.25768763419124, 18.36401990797783],
            [76.28851428581116, 18.38943900347474],
            [76.28415290178522, 18.34001230740226],
            [76.31683513299197, 18.32997148841157],
            [76.31453764778796, 18.28246355468195],
            [76.28381843228242, 18.24928049499056],
            [76.28578796019077, 18.23215172294838],
            [76.30139262256876, 18.23180946141163],
            [76.28004504069402, 18.18386837553917],
            [76.27943829156983, 18.1109431546217],
            [76.3271692041564, 18.09675461127103],
            [76.34050940530678, 18.06128015819566],
            [76.37879215262478, 18.08874085471477],
            [76.39858554394726, 18.06604498626097],
            [76.38366120390032, 18.04507671964423],
            [76.4275781731443, 18.03378774907904],
            [76.4886065491069, 18.02442602767076],
            [76.49928638616551, 18.05185288084506],
            [76.51215610539494, 18.05022443634058],
            [76.5103453021314, 18.0232192945538],
            [76.57592294624034, 18.02256625013882],
            [76.57890169154128, 18.03788975404022],
            [76.61092940823566, 18.03894194041325],
            [76.6037066386855, 18.00729132802964],
            [76.67841267198584, 17.99629861484796],
            [76.68923728523419, 17.9701955806684],
            [76.67306567404158, 17.96712045995389],
            [76.67346838602619, 17.91886924268083],
            [76.72386709021758, 17.91833961677126],
            [76.80436696264547, 17.87060606486682],
            [76.83972490898583, 17.89937423112157],
            [76.88426795423932, 17.89429289712927],
            [76.90126471671691, 17.91724229070893],
            [76.91910009970285, 17.91620026298055],
            [76.90564382134654, 18.00970960028357],
            [76.91431527847465, 18.03536115802861],
            [76.95230517436431, 18.04021926079947],
            [76.94521382755839, 18.08320077689443],
            [76.96634972639994, 18.09820117601502],
            [76.92049956199078, 18.11818282374377],
            [76.95193446854312, 18.18809933880379],
            [76.99060911452784, 18.18998779363726],
            [77.00111405570085, 18.16089945372809],
            [77.02330396271111, 18.15850952305468],
            [77.03317774404087, 18.18199278512975],
            [77.06395800255258, 18.15065208352681],
            [77.11060102443344, 18.15533954601086],
            [77.11679624291848, 18.16961474941042],
            [77.09759872993148, 18.19672357026005],
            [77.15152194723419, 18.21704488264196],
            [77.17481189253554, 18.2848617887454],
            [77.21301332640219, 18.28032030382951],
            [77.19911031401743, 18.31676517482211],
            [77.2190671884373, 18.32573049804744],
            [77.22583090869828, 18.36521996582676],
            [77.24628436380344, 18.37053757579964],
            [77.23472880943494, 18.39665259132863],
            [77.26579834384641, 18.42234872993699],
            [77.25467447171228, 18.4546663216317],
            [77.27503035432734, 18.47772646632312],
            [77.2458615304203, 18.49965569881657],
            [77.28170586858879, 18.52157841778406],
            [77.29435826551627, 18.54904628228914],
            [77.26151874965579, 18.56586273651795],
            [77.26815625605154, 18.61146476312065],
            [77.21089856036893, 18.62420663195509],
            [77.19708720850947, 18.64724491013991],
            [77.15388770661235, 18.64723150103676],
            [77.15824870144108, 18.6822393553167],
            [77.19331630201201, 18.68859833271518],
            [77.1834204478947, 18.70102657549274],
            [77.14121578853921, 18.71331443729218],
            [77.13842139225028, 18.69727290557692],
            [77.04594772670465, 18.68377169412158],
            [77.05413010345217, 18.77362984441987],
            [77.00753123937726, 18.76621736113673],
            [76.9905107274734, 18.82891373817397],
            [76.90727560869179, 18.83898525033095]
          ]
        ]
      }
    },
    {
      id: '16',
      type: 'Feature',
      properties: {
        Name: 'MUMBAI CITY',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'MUMBAI CITY',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '482',
        Shape_Leng: 61423,
        Shape_Area: 62033900
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [72.8668715397671, 19.05300422326282],
            [72.84188508818652, 19.05022685291899],
            [72.83433204557117, 19.02539483448568],
            [72.81693930001946, 19.02427307963411],
            [72.79249653705705, 18.9499064513965],
            [72.79331517999553, 18.93940825129622],
            [72.81217937798533, 18.95527100173501],
            [72.82360580795802, 18.94124944406751],
            [72.80874090371015, 18.89340521601529],
            [72.843372313328, 18.93029465774232],
            [72.85432057803303, 18.99720342725439],
            [72.87824291965957, 19.02193644287755],
            [72.8668715397671, 19.05300422326282]
          ]
        ]
      }
    },
    {
      id: '17',
      type: 'Feature',
      properties: {
        Name: 'NAGPUR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'NAGPUR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '484',
        Shape_Leng: 650986,
        Shape_Area: 9538670000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [79.23118579770913, 21.72228400603447],
            [79.22402043682602, 21.64880378942759],
            [79.14831286667889, 21.66117490942113],
            [79.14330039601792, 21.63696405432814],
            [79.1005273095426, 21.61760342461944],
            [79.1072063779197, 21.60502673014503],
            [79.09395815803676, 21.59811215076768],
            [79.0123689710466, 21.59944618015608],
            [78.99801229398214, 21.61857353406558],
            [78.97552187763758, 21.61763785821918],
            [78.9143521061942, 21.58898616365052],
            [78.91375072106906, 21.57098536899694],
            [78.93186327615626, 21.5617601033346],
            [78.90679754336189, 21.55325906644824],
            [78.9443927219934, 21.51587518743398],
            [78.93669236387034, 21.4857666550129],
            [78.8992585714866, 21.50046160623432],
            [78.8908365873255, 21.48526247815432],
            [78.80025692068762, 21.49015518174799],
            [78.77612971784299, 21.46458330292681],
            [78.75084851798812, 21.4929839182292],
            [78.72846587025043, 21.46229299619234],
            [78.68891015475435, 21.48197081771993],
            [78.58533516755212, 21.48672166436825],
            [78.57014515638322, 21.51425544292763],
            [78.51164494226555, 21.52869011329949],
            [78.47522496827332, 21.50096804444892],
            [78.43026938904002, 21.49720254341331],
            [78.4475901673412, 21.402832909121],
            [78.4069137588723, 21.38170459145481],
            [78.37131121738905, 21.39569840486266],
            [78.249598176218, 21.3312374057707],
            [78.29416173514988, 21.29313133621147],
            [78.31264580187407, 21.2945772552941],
            [78.30344994694558, 21.27549500629225],
            [78.32778508735807, 21.27126687212482],
            [78.33139521118615, 21.25000768220192],
            [78.4772865618358, 21.21962758684573],
            [78.55495195397589, 21.11677270648588],
            [78.59932673361753, 21.10806854785179],
            [78.60704343488688, 21.06961697560294],
            [78.72657313490485, 21.00416861654288],
            [78.7332085377189, 20.9463042829158],
            [78.78228723533029, 20.91124076993673],
            [78.77302433716999, 20.90409006972074],
            [78.78563431320435, 20.89010128390862],
            [78.81719304172884, 20.8807253551239],
            [78.83995682593142, 20.89293938061783],
            [78.86003825996528, 20.87452020023683],
            [78.8683176721703, 20.8328951689908],
            [78.91285250470469, 20.83599187267911],
            [78.91186129588347, 20.80849550191796],
            [78.94538549451072, 20.79373746823281],
            [78.9424316526188, 20.76665752156015],
            [79.1033236447639, 20.71571484379014],
            [79.10521423671973, 20.68794028008459],
            [79.14276243320178, 20.6790487539708],
            [79.18889830609174, 20.59915677051926],
            [79.22065844128893, 20.58313433003856],
            [79.32117993207527, 20.58380612699251],
            [79.35464006106615, 20.65480413042398],
            [79.34870908098749, 20.67604989689158],
            [79.37950620782986, 20.68433185785177],
            [79.39758869034551, 20.66025511984371],
            [79.43613570239705, 20.66186509251633],
            [79.48986749132825, 20.70890431951608],
            [79.51715148024597, 20.71017482565406],
            [79.53151469731229, 20.77483035541947],
            [79.55956843025506, 20.80265581779466],
            [79.53726653499484, 20.852200716623],
            [79.57963721204544, 20.84335567341078],
            [79.61299607039393, 20.8660086426741],
            [79.61234511839315, 20.90362195043976],
            [79.64627928398517, 20.92475410222221],
            [79.65696874779655, 20.96277333706626],
            [79.59664445761734, 21.07393752205571],
            [79.57207199576646, 21.06608818344199],
            [79.55068780582405, 21.08867526117763],
            [79.52642360578182, 21.07891693476351],
            [79.52474709967264, 21.11988315402074],
            [79.49372237596863, 21.13776525342681],
            [79.50807215056126, 21.16292973457512],
            [79.49828151123994, 21.18369239780514],
            [79.55709596481059, 21.15611611276347],
            [79.54971181904399, 21.20836530273471],
            [79.57612893604833, 21.27613652148541],
            [79.55517917200251, 21.32855994591579],
            [79.49953394187598, 21.39846300995607],
            [79.48376016547458, 21.39884154827904],
            [79.48215739351718, 21.42703936445986],
            [79.44840602047098, 21.43464976678551],
            [79.4490673206052, 21.45937575582879],
            [79.48029186004932, 21.50148488913685],
            [79.51389058721786, 21.5342339932556],
            [79.53761934411999, 21.53605953802231],
            [79.54392703415137, 21.55952108523467],
            [79.51202842494187, 21.58397336937385],
            [79.50371304883004, 21.61459319595343],
            [79.51723102764636, 21.62574716365185],
            [79.4963269510564, 21.67401461133353],
            [79.42219784010298, 21.69182232909735],
            [79.39248710502989, 21.67411968878998],
            [79.3523680667015, 21.67805737020268],
            [79.23118579770913, 21.72228400603447]
          ]
        ]
      }
    },
    {
      id: '18',
      type: 'Feature',
      properties: {
        Name: 'NANDED',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'NANDED',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '485',
        Shape_Leng: 1053020,
        Shape_Area: 10199300000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [78.06126024857245, 19.90967965765109],
            [78.05175227482381, 19.92370198793349],
            [78.01457931977764, 19.90770504741873],
            [77.95238418426477, 19.90887756542857],
            [77.89617186549548, 19.87528741082837],
            [77.84825729086039, 19.79806301500054],
            [77.86042044534106, 19.7451839339068],
            [77.88984682156975, 19.72591452171664],
            [77.94728090154024, 19.73001866923088],
            [77.98984911179252, 19.67316631757154],
            [78.03570894089334, 19.69288159449076],
            [78.08733841025007, 19.63699129759084],
            [78.13031090285212, 19.66450672899841],
            [78.17974893029452, 19.64916328904224],
            [78.19649480530573, 19.61573114699423],
            [78.18816789297124, 19.55834655087363],
            [78.12041022430184, 19.5477372899869],
            [78.13469989119109, 19.5193212915985],
            [78.11092366245369, 19.4818611739149],
            [78.06668221641984, 19.4585227545485],
            [78.02223949811832, 19.48959240249052],
            [78.01501852700635, 19.45578327220293],
            [77.9936780202163, 19.45419720160224],
            [77.97260987110036, 19.50738759559843],
            [77.93897422075122, 19.49743831749173],
            [77.90643279501893, 19.5342844668918],
            [77.88066171268878, 19.50207809006608],
            [77.85936003114954, 19.52242858319837],
            [77.8424653991675, 19.51095838679628],
            [77.84200943085627, 19.48785578058844],
            [77.82484088820492, 19.47759577120099],
            [77.84638812744377, 19.45310464968126],
            [77.83121821014481, 19.43904122430034],
            [77.80680093215905, 19.46453834922913],
            [77.75084192470895, 19.43089705665071],
            [77.70545811637011, 19.43663720358437],
            [77.69538773319444, 19.45726185559961],
            [77.73838896324413, 19.48261730415273],
            [77.74513814812347, 19.52570681244666],
            [77.70576250359373, 19.52214247377366],
            [77.69777476342942, 19.53895387318134],
            [77.63117405839228, 19.55365015217893],
            [77.6487065296231, 19.55817708075501],
            [77.6438354125478, 19.60765414995739],
            [77.62747960301114, 19.60644590953576],
            [77.60639842447686, 19.64861930494339],
            [77.45903379602315, 19.68235617507808],
            [77.46260412459971, 19.61144656707602],
            [77.47936677167083, 19.59957712266204],
            [77.45089599957554, 19.56905289870828],
            [77.46625360415845, 19.56407231087628],
            [77.47002511799622, 19.49089780029617],
            [77.48958060893558, 19.49323889905538],
            [77.48654201806306, 19.4581562979697],
            [77.47372903386507, 19.45880659742359],
            [77.4701769265933, 19.43799302940446],
            [77.44815157411972, 19.44051153368886],
            [77.4359582670128, 19.40711239508628],
            [77.44727990803017, 19.3863416640524],
            [77.41652874822178, 19.38061862513922],
            [77.38531783205792, 19.3398775570308],
            [77.31167505068875, 19.35503379761265],
            [77.31074388095647, 19.33076502693865],
            [77.28072519810712, 19.3160222557134],
            [77.24134968981285, 19.32286091389929],
            [77.23545151145896, 19.27520079200672],
            [77.22018106106447, 19.27573968134575],
            [77.17905150717287, 19.22891600238569],
            [77.17703816896017, 19.16756398816508],
            [77.19177660492811, 19.16387297512323],
            [77.192533215933, 19.14185107102023],
            [77.1641498503692, 19.12048653493506],
            [77.15548495352944, 19.08277730378537],
            [77.09385639822256, 19.0663575432371],
            [77.08638065383383, 19.08597428491999],
            [77.1037306336742, 19.09977616068547],
            [77.08397825331615, 19.1095068328662],
            [77.06218378624608, 19.06928049411044],
            [77.064373931935, 19.03175631425784],
            [77.04325806602812, 19.03129401913641],
            [77.05644275471595, 18.98849906350829],
            [77.02277926289149, 18.93247106575613],
            [76.98867260695901, 18.93576879995141],
            [76.97797878276945, 18.91243059457991],
            [76.95581496498984, 18.93377708205084],
            [76.92964709648845, 18.90138722679551],
            [76.95435839669283, 18.89202793394982],
            [76.95243975705455, 18.87393728011098],
            [77.01494202283875, 18.87982618952857],
            [77.01953555807513, 18.84367134689154],
            [76.9907731031821, 18.82424192461424],
            [77.00753123937726, 18.76621736113673],
            [77.0557455023919, 18.77069289668797],
            [77.04580610063654, 18.68385922915796],
            [77.13842139225028, 18.69727290557692],
            [77.14121578853921, 18.71331443729218],
            [77.17658239649951, 18.70389925001064],
            [77.19331630201201, 18.68859833271518],
            [77.15824870144108, 18.6822393553167],
            [77.15388770661235, 18.64723150103676],
            [77.19708720850947, 18.64724491013991],
            [77.21089856036893, 18.62420663195509],
            [77.26815625605154, 18.61146476312065],
            [77.26151874965579, 18.56586273651795],
            [77.29435826551627, 18.54904628228914],
            [77.24568088381419, 18.49518872906124],
            [77.30043360703729, 18.47138868180924],
            [77.28879574200835, 18.45525213349532],
            [77.25467447171228, 18.4546663216317],
            [77.26579834384641, 18.42234872993699],
            [77.31685160665451, 18.4422530284101],
            [77.3198850938926, 18.45802721570955],
            [77.34521831838792, 18.43361107657831],
            [77.36563593089419, 18.45156409041184],
            [77.37283283513607, 18.40110270865854],
            [77.41415564938798, 18.39225149717659],
            [77.39486983063091, 18.36845465803009],
            [77.40014855979062, 18.34744644312912],
            [77.35782854578629, 18.31690932701006],
            [77.4089951911727, 18.30146867888773],
            [77.4376647620884, 18.31031382214348],
            [77.4536481369355, 18.26631550200041],
            [77.49268830733932, 18.26721487113421],
            [77.5115575242321, 18.28204933921933],
            [77.51263137636407, 18.30959849483933],
            [77.55126227286877, 18.29169318000668],
            [77.57139614369703, 18.30882914541944],
            [77.52234118428305, 18.34646711014101],
            [77.55675606398466, 18.41714334005493],
            [77.52751602175819, 18.44211124105904],
            [77.58529734099555, 18.44679230495318],
            [77.54856340533898, 18.46858131114167],
            [77.5728610193196, 18.46981492619562],
            [77.57636930143417, 18.48678464673731],
            [77.60312605506226, 18.47684752440719],
            [77.6047068534457, 18.4963668092783],
            [77.5859069007531, 18.50399613188397],
            [77.59636942211533, 18.54894138065715],
            [77.6479131478722, 18.55493135604809],
            [77.6558604002904, 18.53089895132911],
            [77.73849960730969, 18.55678870935365],
            [77.75034273783639, 18.58921547154109],
            [77.72997424724694, 18.66693690843801],
            [77.7535037656586, 18.70099198210231],
            [77.76815202528992, 18.70585935774936],
            [77.78728825198249, 18.68263997555208],
            [77.8399548026477, 18.80482151193373],
            [77.9482753520025, 18.82909712454394],
            [77.94890092944235, 18.8432891649564],
            [77.90323203949458, 18.86662551947707],
            [77.88538444878066, 18.90420015793833],
            [77.84325423222452, 18.90869337543064],
            [77.858591644031, 18.94911097679207],
            [77.81924931764318, 18.94585994068879],
            [77.82175777593498, 18.97850776703549],
            [77.77149715594315, 18.97915906636975],
            [77.7617902084296, 19.03300176132799],
            [77.76481199057815, 19.06265528641167],
            [77.8003494331161, 19.05112157171696],
            [77.80993425831298, 19.10473397409971],
            [77.85039502620201, 19.08855689509727],
            [77.83406293140412, 19.13430824971648],
            [77.86049421300596, 19.18035425460676],
            [77.84772102291913, 19.18959495367833],
            [77.87140505514242, 19.25502036914482],
            [77.90756357478176, 19.2682283790741],
            [77.86557552014642, 19.28382154978671],
            [77.86345878365593, 19.30419634820894],
            [77.94512189803447, 19.34245296943674],
            [78.04250627410603, 19.27060376711525],
            [78.04161357724125, 19.24342814220961],
            [78.0556752490769, 19.23712171172143],
            [78.07909687597352, 19.25483432845412],
            [78.08914962520957, 19.23936818921701],
            [78.117038043648, 19.2486372725138],
            [78.14454691125307, 19.22940073203091],
            [78.17532099617263, 19.23757855011706],
            [78.1937388531441, 19.31488612571739],
            [78.17214822758821, 19.34929886510153],
            [78.18767298801095, 19.39459295033963],
            [78.17619001952583, 19.41226246576628],
            [78.19506524461524, 19.40675371697403],
            [78.27043943460365, 19.45615514385748],
            [78.30450801727396, 19.45651795715649],
            [78.29322965891413, 19.5422335902597],
            [78.27431076480089, 19.55397458732876],
            [78.3036889129454, 19.56932056141596],
            [78.3055669121005, 19.6070665374808],
            [78.29046249488106, 19.64600101202455],
            [78.26264904773795, 19.66506424239682],
            [78.27618587502462, 19.69241534619906],
            [78.31182129492707, 19.69105046353154],
            [78.3431341457777, 19.71325002014559],
            [78.36467465027448, 19.78123154485111],
            [78.35744171828566, 19.80543413041079],
            [78.3340245607073, 19.81459172085558],
            [78.33641446993398, 19.83792324188252],
            [78.28607513413799, 19.84793714252327],
            [78.30702790900727, 19.91429755898194],
            [78.25202089780238, 19.86570608551842],
            [78.24116776480571, 19.88395210435828],
            [78.25261092435592, 19.92403088217489],
            [78.19173812298494, 19.89612740465327],
            [78.14243006133408, 19.91054831861505],
            [78.09922457489625, 19.89080611745459],
            [78.06126024857245, 19.90967965765109]
          ]
        ]
      }
    },
    {
      id: '19',
      type: 'Feature',
      properties: {
        Name: 'NANDURBAR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'NANDURBAR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '486',
        Shape_Leng: 723808,
        Shape_Area: 5736400000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.44372464432278, 22.02261538363096],
            [74.38832695166246, 22.02075095813657],
            [74.35070190437385, 21.97812089988588],
            [74.300894924465, 21.96712876741156],
            [74.2811756588528, 21.93311214942231],
            [74.1930802917502, 21.92597112840376],
            [74.15743292678519, 21.95082209679747],
            [74.12822356086987, 21.94977830452418],
            [73.87160822633423, 21.84150748598391],
            [73.80731596087901, 21.83633293525281],
            [73.79594193356702, 21.82455128071912],
            [73.83809772687735, 21.78909094087217],
            [73.824864714876, 21.75955534508918],
            [73.88061281066892, 21.71559017422946],
            [73.89460203497252, 21.67626648145582],
            [73.88801486034407, 21.65324609619119],
            [73.78051493385868, 21.62859207177497],
            [73.81413059989286, 21.60109319637129],
            [73.85355659015522, 21.49746588956715],
            [73.90422763033605, 21.52450923097335],
            [73.95175415886645, 21.51269401280483],
            [73.9550755282461, 21.54083020169661],
            [73.98227009437409, 21.5225980382629],
            [73.97418615520502, 21.54327627370692],
            [73.99741860936153, 21.53901129941674],
            [74.00583847896702, 21.55275580401052],
            [74.13696351785165, 21.54686344109373],
            [74.16674144445541, 21.56904272588996],
            [74.19584492691185, 21.53206256000239],
            [74.22900773528005, 21.55446259358735],
            [74.23621739729589, 21.53970309876571],
            [74.26317714320713, 21.53984723317535],
            [74.2767209204795, 21.56225396439097],
            [74.30245845818921, 21.56635884744184],
            [74.30323892457149, 21.55223269653015],
            [74.33116030155766, 21.55242465868616],
            [74.32078812886304, 21.49849691618243],
            [74.25356113576157, 21.46774178612187],
            [74.21415740272431, 21.48168204004252],
            [74.1978242330709, 21.4587485427864],
            [74.12517870359528, 21.46665288033705],
            [74.10071375354534, 21.44763123246915],
            [74.06293158039509, 21.47454942239133],
            [74.04462436071431, 21.41919391148586],
            [74.00261829267329, 21.42141345661507],
            [73.95947419315233, 21.39542793820275],
            [73.93893230393383, 21.40501978937476],
            [73.94917589402638, 21.35116398394621],
            [73.93323930346115, 21.29121754776939],
            [73.87961311911019, 21.26595702099543],
            [73.8228734657824, 21.27085832083107],
            [73.81576154634563, 21.17396026178171],
            [73.7847007224489, 21.18398572752389],
            [73.77230552407605, 21.16463692026513],
            [73.740086881983, 21.17111658599766],
            [73.73180789125911, 21.1409690509861],
            [73.66749207241877, 21.15463164884065],
            [73.64335708721651, 21.13956640113663],
            [73.60779225600136, 21.15898102813109],
            [73.59959966585433, 21.18169534516888],
            [73.5774205935213, 21.17075309398157],
            [73.57851957873629, 21.15048125104128],
            [73.59879012023079, 21.15663163072163],
            [73.61763322181129, 21.1426970324959],
            [73.61846190664001, 21.11845530286167],
            [73.64638204216884, 21.12124917861006],
            [73.65189993165713, 21.1075965147736],
            [73.6889488344021, 21.10079423225539],
            [73.70314521992236, 21.11864886956226],
            [73.7296750168252, 21.09987038386835],
            [73.74375858227044, 21.11517920278693],
            [73.72993213111778, 21.08243400044105],
            [73.76021185520838, 21.0694006487974],
            [73.8077410375878, 21.08489308922697],
            [73.81090336505285, 21.05949164268116],
            [73.7955255628002, 21.04451920290348],
            [73.8512049018052, 20.99763493673601],
            [73.85449364445385, 21.0326501467156],
            [73.8821878424556, 21.02623053115546],
            [73.90718106257474, 21.04359743002885],
            [73.94818315545936, 21.03151813582138],
            [73.95634510710994, 21.10253965636939],
            [74.02009575484948, 21.14163517356663],
            [74.09724804632721, 21.11044262650454],
            [74.05718130681647, 21.1699773626799],
            [74.12070022073492, 21.21335689616011],
            [74.14603050521565, 21.20689820894158],
            [74.15788802767152, 21.23078445993856],
            [74.17918085557278, 21.20978570533033],
            [74.24601237832911, 21.24817166717646],
            [74.29906178426161, 21.23800704859927],
            [74.31779154521719, 21.24839733283654],
            [74.31716430486628, 21.2301452194471],
            [74.33786512737585, 21.2286168207172],
            [74.35669987683268, 21.2322781682197],
            [74.355665683196, 21.25220047748627],
            [74.40931870999306, 21.26662386784929],
            [74.43746952526651, 21.25492179139449],
            [74.43467207983693, 21.23711286326218],
            [74.48998898573973, 21.24249187695352],
            [74.50188868984074, 21.28000624750036],
            [74.47381520425934, 21.30566161604623],
            [74.47847334093144, 21.34923523509482],
            [74.50843476430906, 21.38900869483329],
            [74.49301240076954, 21.39129171991723],
            [74.49656909271538, 21.42557617699399],
            [74.5361873700861, 21.42606598710486],
            [74.5719277017272, 21.40257598060094],
            [74.59960926783728, 21.41542489609863],
            [74.68602636911405, 21.40355447385312],
            [74.69977066047068, 21.46899954899025],
            [74.75521697364945, 21.47756188978132],
            [74.76891566262445, 21.6160792459568],
            [74.58208162120546, 21.6649890498212],
            [74.57986850535345, 21.6833268013475],
            [74.55420471177801, 21.68136235789472],
            [74.5473673122696, 21.71960268586837],
            [74.50558819531302, 21.72630614467469],
            [74.51395220105758, 21.76568782237384],
            [74.4982106510004, 21.79008869511416],
            [74.52421040201195, 21.9105819997825],
            [74.48873036684338, 21.95616939506065],
            [74.4393896337976, 21.97672395230019],
            [74.43233060971302, 21.99940350939301],
            [74.45219043579539, 22.00422849129275],
            [74.44372464432278, 22.02261538363096]
          ]
        ]
      }
    },
    {
      id: '20',
      type: 'Feature',
      properties: {
        Name: 'NASHIK',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'NASHIK',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '487',
        Shape_Leng: 897468,
        Shape_Area: 14979900000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.12891043599532, 20.8647717043393],
            [74.09715014843489, 20.84102460056091],
            [74.06314956765921, 20.84893896628437],
            [74.0438840685804, 20.83471447304493],
            [74.01524353482802, 20.85381221908195],
            [74.00661946103504, 20.83621210123459],
            [73.96663691994738, 20.85443387967232],
            [73.94031846935779, 20.8394387545719],
            [73.93186149207028, 20.76062297607612],
            [73.94266122069699, 20.74208369414465],
            [73.91732663049001, 20.72484917748708],
            [73.87442112294734, 20.72953351570848],
            [73.85517076160808, 20.69225128205691],
            [73.81185203884921, 20.69203343569228],
            [73.83909090244181, 20.65877452289486],
            [73.8383943935891, 20.62046312320238],
            [73.77539284381307, 20.6002241069784],
            [73.74456137904559, 20.56491838081934],
            [73.69537703201219, 20.57837271240965],
            [73.65268255862884, 20.56487246745986],
            [73.62697518781019, 20.58503102013634],
            [73.61519417060772, 20.62481918464754],
            [73.55079944895391, 20.64855947739263],
            [73.52048953037583, 20.67884793718744],
            [73.48923489356959, 20.65573359499753],
            [73.47464810384224, 20.72038787380325],
            [73.44918133873774, 20.71718092936856],
            [73.43299493065136, 20.66683143925806],
            [73.3922435928719, 20.64928605715167],
            [73.40720769046187, 20.62397027183777],
            [73.42112018772436, 20.62586828149621],
            [73.42957612725218, 20.59520486092385],
            [73.47315309625967, 20.58463528714952],
            [73.47529831374361, 20.54332818666234],
            [73.49362424432057, 20.53806846661747],
            [73.46986591270604, 20.52030716935785],
            [73.41957410564846, 20.41306659524544],
            [73.37976798028379, 20.39350323547548],
            [73.38272696162386, 20.3730619505015],
            [73.40450690870125, 20.38609816878448],
            [73.41266720591535, 20.36088163986996],
            [73.4277004648143, 20.28011963942241],
            [73.41215024364676, 20.26551315022642],
            [73.42121134798673, 20.20658601574005],
            [73.38930254884782, 20.19262169275219],
            [73.38249714949018, 20.21172992928253],
            [73.36475366805145, 20.19558480806294],
            [73.35649961142798, 20.21300288282778],
            [73.34383558490185, 20.19938286029474],
            [73.29906433289011, 20.20916990996192],
            [73.28305019555343, 20.19805228547354],
            [73.27922546657801, 20.15014417309194],
            [73.24771946300598, 20.12266270197794],
            [73.27110678615648, 20.09533246533401],
            [73.31319245779422, 20.09144382827678],
            [73.3137263778389, 20.04909663316812],
            [73.35765341562349, 20.03991365914572],
            [73.3660588352941, 20.01932550577071],
            [73.41503312633341, 20.01217459988867],
            [73.43199564947359, 19.98210564703509],
            [73.45076899787159, 19.98478556017318],
            [73.45611233368736, 19.95935896605562],
            [73.43980294527928, 19.95593494660341],
            [73.42270669822652, 19.91664866873442],
            [73.43625520781804, 19.87241888085385],
            [73.41761924448413, 19.86768189116887],
            [73.420517862875, 19.8348039656449],
            [73.44186897374611, 19.82734337650434],
            [73.44924863656279, 19.76712417006491],
            [73.49779198639891, 19.76103852543632],
            [73.50365862976916, 19.73319131736225],
            [73.4859221223201, 19.72258776057931],
            [73.52854639498455, 19.69772812689152],
            [73.56328402174411, 19.61847845334681],
            [73.58120751762671, 19.61295411125291],
            [73.57492200616632, 19.60215782270646],
            [73.67535850993175, 19.586691307777],
            [73.70334442305195, 19.59418204499135],
            [73.7197514700926, 19.61993746837932],
            [73.77570403314672, 19.62849649977379],
            [73.7928271938818, 19.64158979800085],
            [73.78151713763357, 19.65977412015527],
            [73.80576641326043, 19.67696276031971],
            [73.7940445163095, 19.68823940484947],
            [73.80969579055798, 19.68209078105671],
            [73.83675672987259, 19.74045681007531],
            [73.88052115920414, 19.73851848091397],
            [73.88846432412463, 19.75195909057969],
            [73.907676935468, 19.68422624013824],
            [73.92551487012098, 19.67219221519234],
            [74.02105295611229, 19.67383968447897],
            [74.11972428216069, 19.64260746243178],
            [74.16638749313692, 19.72991379232132],
            [74.2465191624063, 19.74443990670156],
            [74.27468557711677, 19.77733047310199],
            [74.31684878799682, 19.76514043078019],
            [74.32683022000253, 19.79569830444098],
            [74.37424699039256, 19.80216047419504],
            [74.36314594142546, 19.87143740486745],
            [74.2745562369984, 19.9064362553904],
            [74.27274132644055, 19.93272023743426],
            [74.2477123951768, 19.93549339704309],
            [74.24783848914052, 19.9629781319958],
            [74.28108496130129, 19.95726921412616],
            [74.2853749836875, 19.98619095274901],
            [74.30308178119698, 19.96667224914138],
            [74.31607893565854, 19.98547623251018],
            [74.34727231572606, 19.98454806440848],
            [74.36277192959324, 19.96510865501364],
            [74.38242325932279, 19.98135535714523],
            [74.44224357060584, 19.97383285626199],
            [74.45768338545632, 19.99498297467323],
            [74.48061668316518, 19.99507701596774],
            [74.47922204510279, 19.96401634759929],
            [74.52289692542901, 19.97658159161904],
            [74.56864715878866, 19.95429833484949],
            [74.67081902397717, 19.94697398032149],
            [74.68932443769368, 20.01076706019164],
            [74.7179004420159, 20.01813239272363],
            [74.70954011650407, 20.07992455876184],
            [74.73646191785949, 20.08079082905897],
            [74.7303428431956, 20.11457601309921],
            [74.70378411334444, 20.11475596721155],
            [74.71912494194648, 20.19279175072349],
            [74.76010254128921, 20.18448847221485],
            [74.75862907885976, 20.20098997267068],
            [74.78287996964465, 20.20615938534984],
            [74.80000364241975, 20.23266903959046],
            [74.78179177371705, 20.2344810892278],
            [74.81838570575792, 20.25040506268004],
            [74.85537632256953, 20.23036214028296],
            [74.85462689577886, 20.17968416780987],
            [74.89567259448903, 20.18025938398392],
            [74.90677788392479, 20.15500114573477],
            [74.92798118167208, 20.15453537014124],
            [74.9285041593243, 20.21738299559767],
            [74.90779337495714, 20.21909695529756],
            [74.90488908554366, 20.24580946404772],
            [74.93290135146768, 20.25119045230322],
            [74.93493271682787, 20.27003263202062],
            [74.85170726672654, 20.28614722879476],
            [74.86481090758252, 20.33512187620997],
            [74.85154271992424, 20.38093564599398],
            [74.82421820350221, 20.39823031793726],
            [74.83623848064133, 20.41807920529008],
            [74.80227021570137, 20.44564643086832],
            [74.79301607435491, 20.47803178373567],
            [74.77071550438636, 20.47242690781025],
            [74.78388210604432, 20.49736909287645],
            [74.7602258244567, 20.53285376634028],
            [74.79795559843946, 20.54628826850262],
            [74.79279377325258, 20.57838651905652],
            [74.80976722507391, 20.58817513307446],
            [74.81264847825683, 20.61930581311858],
            [74.80190492777946, 20.65994281865308],
            [74.6497887324577, 20.69401577892752],
            [74.66449018192434, 20.7741585624935],
            [74.57284172974583, 20.8187799298926],
            [74.57261640691036, 20.83091312676929],
            [74.53627184566132, 20.83507154576523],
            [74.51186650440611, 20.80844330277387],
            [74.47885530559442, 20.83416209704542],
            [74.43982512901368, 20.79849802165668],
            [74.38826100354322, 20.83580567372278],
            [74.40290431197775, 20.83758265897956],
            [74.39624598235066, 20.86097280284281],
            [74.3826444361102, 20.84033290530796],
            [74.34901260858109, 20.85887277719383],
            [74.333028741683, 20.83652181888203],
            [74.29244381011962, 20.85543139180002],
            [74.15931074445183, 20.8621122736498],
            [74.14956525846819, 20.85033780507753],
            [74.12891043599532, 20.8647717043393]
          ],
          [
            [74.72854151961006, 20.08674937314555],
            [74.73120319044004, 20.08788904519376],
            [74.73124716353612, 20.08526994662674],
            [74.72854618066944, 20.08550876945317],
            [74.72854151961006, 20.08674937314555]
          ]
        ]
      }
    },
    {
      id: '21',
      type: 'Feature',
      properties: {
        Name: 'USMANABAD',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'USMANABAD',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '488',
        Shape_Leng: 812463,
        Shape_Area: 7358560000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [75.60291442931442, 18.14809322696142],
              [75.6024324807435, 18.15920812423938],
              [75.58837438467465, 18.15283954216064],
              [75.59357626504111, 18.14608787539741],
              [75.60291442931442, 18.14809322696142]
            ]
          ],
          [
            [
              [75.60830681786119, 18.16102096911947],
              [75.60461030263916, 18.1599131892743],
              [75.60716150478218, 18.14574844468727],
              [75.6144052903368, 18.15060498739742],
              [75.60830681786119, 18.16102096911947]
            ]
          ],
          [
            [
              [75.58439109670654, 18.69801293101965],
              [75.58128481540228, 18.68386805264798],
              [75.54441369538178, 18.68152642923816],
              [75.54008961200765, 18.63906006566113],
              [75.48820293068358, 18.62630254525321],
              [75.45238136611579, 18.59695306121136],
              [75.41483147432855, 18.53058982856101],
              [75.34267739993916, 18.56090256170254],
              [75.32972792179481, 18.52364472252969],
              [75.29636820657187, 18.49623261493818],
              [75.30121064397377, 18.43075835328233],
              [75.28572864335342, 18.40534870299147],
              [75.33344713819962, 18.38933410427429],
              [75.38697078375789, 18.32775462655548],
              [75.40325635033521, 18.32861696508451],
              [75.39440339967798, 18.26382815330239],
              [75.42931860602746, 18.26133214655798],
              [75.42885725422279, 18.17490548359938],
              [75.46186611728245, 18.15926087467052],
              [75.4865103375204, 18.17382423372278],
              [75.48751675205307, 18.15175347177789],
              [75.53111982582355, 18.13364382936331],
              [75.56847653113992, 18.23578985401755],
              [75.5875747638738, 18.25439293570062],
              [75.62723305255874, 18.2410731229172],
              [75.62969737556448, 18.26588758099298],
              [75.61381342759192, 18.27141182310785],
              [75.64799174409939, 18.33038037769576],
              [75.71804231079535, 18.33733684345232],
              [75.72518017542926, 18.38681158413672],
              [75.70644441311839, 18.39629392095479],
              [75.72365129554657, 18.43354207631301],
              [75.76799137786908, 18.45099263830576],
              [75.77078003110948, 18.40859441043328],
              [75.79728692658561, 18.38046439999473],
              [75.8952110036703, 18.35865620210797],
              [75.94340518153844, 18.24411540401],
              [75.92328023735375, 18.19321227624322],
              [75.95709202086994, 18.16101255389068],
              [75.93788479682257, 18.12656813055648],
              [75.9449713304785, 18.10712714378742],
              [75.95559003297939, 18.08578557263855],
              [75.98665970151968, 18.08833701583923],
              [75.9844397429594, 18.05379248785446],
              [76.01872428986077, 18.04215897517783],
              [75.97398734718756, 17.97111307618012],
              [75.9178100264411, 17.97578021566141],
              [75.90840250052732, 18.00357325784647],
              [75.85305595148952, 18.00930383902765],
              [75.83808582018347, 17.93236345366046],
              [75.85125667516871, 17.92211499374575],
              [75.84469821354645, 17.89160788874676],
              [75.87501445244635, 17.84642513255976],
              [75.92474119283825, 17.83314674825539],
              [75.9410867712552, 17.85201665198975],
              [75.96598177900468, 17.81815642787296],
              [75.98056403306992, 17.84379105105661],
              [76.01980163717081, 17.82838889476032],
              [76.00265227636395, 17.75034732522947],
              [76.08449801290931, 17.77781150469947],
              [76.12932571660961, 17.76774455644403],
              [76.14740122563977, 17.73412629713886],
              [76.17517068697511, 17.7297062936638],
              [76.14710603698397, 17.71648221445776],
              [76.14589340250446, 17.69981271906625],
              [76.18790404679937, 17.68321192555117],
              [76.24014546402258, 17.69737177268603],
              [76.26788571725142, 17.72954366067308],
              [76.29463009490426, 17.7297892652215],
              [76.32037641414196, 17.69596750855813],
              [76.37851547507887, 17.68666484139182],
              [76.37823101777867, 17.66081359373601],
              [76.44500467697306, 17.64095129007968],
              [76.4528602831108, 17.65579022002369],
              [76.48974872422627, 17.66049921027027],
              [76.4872276448901, 17.71476362138527],
              [76.52390216299926, 17.71515206735398],
              [76.52315752866491, 17.7597609410293],
              [76.57270774264545, 17.76053954374892],
              [76.57029543869781, 17.70540567912745],
              [76.58219995036357, 17.70527030111161],
              [76.61362926043795, 17.77085372216028],
              [76.66418880486343, 17.68756021683309],
              [76.69083990552247, 17.68100480003949],
              [76.69964593420384, 17.727249098819],
              [76.72827082433027, 17.73756074332271],
              [76.71409136008195, 17.78094002430517],
              [76.76203848097681, 17.78701702903224],
              [76.79039367437093, 17.82633410985402],
              [76.7674995316287, 17.8521273619418],
              [76.73848209813478, 17.85668160387529],
              [76.73786955647506, 17.90978987447797],
              [76.67346838602619, 17.91886924268083],
              [76.67306567404158, 17.96712045995389],
              [76.68923728523419, 17.9701955806684],
              [76.67841267198584, 17.99629861484796],
              [76.6037066386855, 18.00729132802964],
              [76.61092940823566, 18.03894194041325],
              [76.57890169154128, 18.03788975404022],
              [76.57592294624034, 18.02256625013882],
              [76.51119094467528, 18.02317053628598],
              [76.50866278102252, 18.05098563463154],
              [76.4886065491069, 18.02442602767076],
              [76.38366120390032, 18.04507671964423],
              [76.39858554394726, 18.06604498626097],
              [76.38032213442943, 18.08790557596704],
              [76.35292435240854, 18.08201778833488],
              [76.34050940530678, 18.06128015819566],
              [76.3271692041564, 18.09675461127103],
              [76.27936873654606, 18.11102793821884],
              [76.28004504069402, 18.18386837553917],
              [76.30139262256876, 18.23180946141163],
              [76.28578796019077, 18.23215172294838],
              [76.28381843228242, 18.24928049499056],
              [76.31453764778796, 18.28246355468195],
              [76.31683513299197, 18.32997148841157],
              [76.28415290178522, 18.34001230740226],
              [76.28851428581116, 18.38943900347474],
              [76.25768763419124, 18.36401990797783],
              [76.20348803162142, 18.39470865812542],
              [76.22569020391747, 18.43402404362719],
              [76.26695137927648, 18.42267735925095],
              [76.25296562991117, 18.52202357916066],
              [76.27596431154439, 18.55794434254383],
              [76.25467123128011, 18.57540193064587],
              [76.17741345185851, 18.5845016695772],
              [76.16033953478762, 18.55495116889442],
              [76.1559607046495, 18.57809736435171],
              [76.13476421475157, 18.58765930014614],
              [76.05351957917476, 18.57459504046544],
              [76.01224787920648, 18.60776845733336],
              [75.99533069432015, 18.58286779747547],
              [75.98257240494473, 18.59083405350171],
              [75.9939797830156, 18.61719957081054],
              [75.94808640514839, 18.60505945198072],
              [75.93745114173537, 18.64139093475686],
              [75.85564073982341, 18.64938306329424],
              [75.85748250233588, 18.65973772761921],
              [75.7997473312599, 18.67300218585624],
              [75.79340278351464, 18.65423368452268],
              [75.77689576992738, 18.6729664583584],
              [75.70119459073841, 18.68917237059789],
              [75.66970601692057, 18.6912582207379],
              [75.66657353043485, 18.65143857045627],
              [75.64758527378054, 18.64788935410618],
              [75.58439109670654, 18.69801293101965]
            ]
          ]
        ]
      }
    },
    {
      id: '22',
      type: 'Feature',
      properties: {
        Name: 'PALGHAR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'PALGHAR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '665',
        Shape_Leng: 473314,
        Shape_Area: 5094570000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [72.87329702956809, 20.22695687161747],
            [72.81603607031718, 20.18444440795037],
            [72.82446987721093, 20.14202171454398],
            [72.78862388746388, 20.14932377094512],
            [72.79411363328741, 20.12334056439558],
            [72.7376711419796, 20.1343357899112],
            [72.74658519423878, 20.11614161197679],
            [72.70788379712802, 20.07002549045601],
            [72.72197582684616, 19.97062377348851],
            [72.66421602373936, 19.93348883916096],
            [72.67880257181432, 19.92074214813723],
            [72.68027167763347, 19.86489624222675],
            [72.64805583425913, 19.87005468194457],
            [72.64199056980549, 19.84398236432614],
            [72.65398062751346, 19.8109376775847],
            [72.6676832288162, 19.80132425730143],
            [72.6713167462303, 19.81364307354356],
            [72.68284783872109, 19.79348851962884],
            [72.67552362003806, 19.71571327142211],
            [72.6970743666749, 19.71924471674136],
            [72.70814365730068, 19.70381072967889],
            [72.69913400971234, 19.66147880870987],
            [72.72534332214333, 19.60957140479688],
            [72.70890928815635, 19.59876418571928],
            [72.71109041686508, 19.540783503494],
            [72.71973195273335, 19.50076646628957],
            [72.74954767814273, 19.48926932877914],
            [72.75992691706466, 19.39270966680646],
            [72.74789038917079, 19.37023948282305],
            [72.80019067034698, 19.32384711666419],
            [72.8271000146662, 19.33571963592926],
            [72.87161007659442, 19.3220155114329],
            [72.90224346776357, 19.28968622694981],
            [72.93232006361838, 19.28719324338799],
            [72.9552144630178, 19.30033379356864],
            [72.94189512974688, 19.33223853168136],
            [72.95990085057697, 19.39877096519523],
            [72.97697177281292, 19.39867552791575],
            [73.02045285675705, 19.44684792740794],
            [72.99393392673473, 19.46676114662811],
            [72.98845645801121, 19.48985090570851],
            [73.0035808236047, 19.50362668782015],
            [73.05708606416715, 19.47898008265806],
            [73.13310630785361, 19.50116807303495],
            [73.13337522602778, 19.51667879120868],
            [73.16801198268645, 19.52247107190344],
            [73.20790182228363, 19.55649958376542],
            [73.1944831490806, 19.60001730021229],
            [73.24730755846929, 19.61027809611938],
            [73.2561097135083, 19.63179607004715],
            [73.28366313292885, 19.62626649056969],
            [73.26747094374925, 19.65190156316049],
            [73.28373760675147, 19.69108658592741],
            [73.31932513690307, 19.67355375612818],
            [73.33081428471955, 19.69513810792015],
            [73.41485310961501, 19.69744492727541],
            [73.41464765201759, 19.70872603112216],
            [73.42985158479287, 19.70214491778559],
            [73.50279627495661, 19.73258314382168],
            [73.50379737502372, 19.74790213485169],
            [73.49594827056997, 19.76201990103695],
            [73.44761611930568, 19.76879776768788],
            [73.44186897374611, 19.82734337650434],
            [73.420517862875, 19.8348039656449],
            [73.41761924448413, 19.86768189116887],
            [73.43625520781804, 19.87241888085385],
            [73.42270669822652, 19.91664866873442],
            [73.43980294527928, 19.95593494660341],
            [73.45611233368736, 19.95935896605562],
            [73.45076899787159, 19.98478556017318],
            [73.43199564947359, 19.98210564703509],
            [73.41503312633341, 20.01217459988867],
            [73.3660588352941, 20.01932550577071],
            [73.35765341562349, 20.03991365914572],
            [73.3137263778389, 20.04909663316812],
            [73.31319245779422, 20.09144382827678],
            [73.27110678615648, 20.09533246533401],
            [73.24507499206567, 20.12783677962803],
            [73.22425586395786, 20.1243818672008],
            [73.22488376835423, 20.14019696310995],
            [73.20842635939813, 20.12006153804833],
            [73.20952362916034, 20.08499953417083],
            [73.18852901258295, 20.07810315393092],
            [73.19092213539388, 20.04959252712929],
            [73.13638508566454, 20.08636710080241],
            [73.11198308521166, 20.07117483812773],
            [73.10226259026062, 20.09123696124939],
            [73.0636928880546, 20.09958665194584],
            [73.04316962338376, 20.0651916986326],
            [73.00073802052259, 20.11230345922745],
            [73.01093644516634, 20.1346017575713],
            [72.99750427307869, 20.14276256894565],
            [72.97735547199159, 20.11278003069298],
            [72.96358397303395, 20.12603720808709],
            [72.97687886395771, 20.17864998935312],
            [72.96193714711863, 20.18346001780406],
            [72.96198416094698, 20.21004644654188],
            [72.87329702956809, 20.22695687161747]
          ]
        ]
      }
    },
    {
      id: '23',
      type: 'Feature',
      properties: {
        Name: 'PARBHANI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'PARBHANI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '489',
        Shape_Leng: 595317,
        Shape_Area: 6105210000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [76.59600265896428, 19.82719322780279],
            [76.56326321347319, 19.81532940797046],
            [76.5127704659331, 19.82413252155842],
            [76.5114465212527, 19.79896971027812],
            [76.48404480999858, 19.79974966253134],
            [76.48665989237865, 19.77924867612249],
            [76.51258390623673, 19.7705096169993],
            [76.48827725292882, 19.76372130071253],
            [76.48366527759731, 19.74485871134424],
            [76.45954337950377, 19.74725334486883],
            [76.45938861362741, 19.72519158014867],
            [76.48390041506276, 19.72143587966346],
            [76.48793823279438, 19.68418473787925],
            [76.44940222757936, 19.65967808642226],
            [76.45087527343105, 19.61428401094664],
            [76.43236935146501, 19.60215515403634],
            [76.44793727757269, 19.58474079658859],
            [76.4421423804764, 19.54156433506728],
            [76.37572311649991, 19.53695266878771],
            [76.36421727247745, 19.47080028473582],
            [76.34282695523291, 19.47285427834197],
            [76.33593020609392, 19.45365163564926],
            [76.31322988860121, 19.46670010358489],
            [76.30140125489122, 19.43178150937409],
            [76.28883532751193, 19.43307415165167],
            [76.28279940056056, 19.36561781317111],
            [76.25742141898492, 19.35664448613177],
            [76.27548508008987, 19.34437981359324],
            [76.23948189411647, 19.336554524725],
            [76.23020854094091, 19.31346906443032],
            [76.21117835151391, 19.31899738402706],
            [76.20741715045646, 19.27676309949518],
            [76.22465229544106, 19.24307599494103],
            [76.25012209182906, 19.24119126575571],
            [76.2845641671366, 19.26589940679823],
            [76.35919645260367, 19.24083832693406],
            [76.36062742768034, 19.15598629956857],
            [76.32204189938317, 19.10731544185503],
            [76.34848394525513, 19.09979087760091],
            [76.37869856549982, 19.13080444204796],
            [76.41159587190992, 19.09133679185373],
            [76.43209653901619, 19.09592480503359],
            [76.4516949150324, 19.0508647968587],
            [76.43830495796084, 19.0423695510156],
            [76.45602929825861, 19.00832136298801],
            [76.47975170110152, 19.00117177487614],
            [76.4686550427653, 18.98331493690034],
            [76.47799250467519, 18.95333763245986],
            [76.50259931235884, 18.9493804086021],
            [76.52052565587452, 18.91821875220543],
            [76.5356312556376, 18.91790149025296],
            [76.53685646325836, 18.94902871374238],
            [76.5832188768012, 18.94277865487077],
            [76.58183422526537, 18.87248389731251],
            [76.62071703807327, 18.86793021172379],
            [76.62845385234966, 18.84679129487743],
            [76.64217696403057, 18.84795869987425],
            [76.64286778176923, 18.82190916620992],
            [76.67119925535883, 18.8135070619939],
            [76.67462755904268, 18.75610190017275],
            [76.72905295939182, 18.74993235608622],
            [76.74282094967883, 18.77569590882322],
            [76.77734687838245, 18.77608201714362],
            [76.78340113994416, 18.79679016358683],
            [76.82841810382384, 18.81214208691729],
            [76.85351731445076, 18.80697210020595],
            [76.86694149112547, 18.83019257078981],
            [76.99009973644081, 18.82868579356274],
            [77.01953555807513, 18.84367134689154],
            [77.01494202283875, 18.87982618952857],
            [76.95243975705455, 18.87393728011098],
            [76.95435839669283, 18.89202793394982],
            [76.92964709648845, 18.90138722679551],
            [76.95581496498984, 18.93377708205084],
            [76.97797878276945, 18.91243059457991],
            [76.98867260695901, 18.93576879995141],
            [77.02277926289149, 18.93247106575613],
            [77.05644275471595, 18.98849906350829],
            [77.04325806602812, 19.03129401913641],
            [77.064373931935, 19.03175631425784],
            [77.06218378624608, 19.06928049411044],
            [77.08397825331615, 19.1095068328662],
            [77.1037306336742, 19.09977616068547],
            [77.08638065383383, 19.08597428491999],
            [77.08982906210484, 19.06888908350436],
            [77.14278234121196, 19.07225568507831],
            [77.1641498503692, 19.12048653493506],
            [77.19157727694575, 19.13653203116031],
            [77.19177660492811, 19.16387297512323],
            [77.17703816896017, 19.16756398816508],
            [77.1788837645733, 19.22626596966375],
            [77.09830703568537, 19.23579495193751],
            [77.07835435574323, 19.25730263040999],
            [77.02462842479581, 19.24766386940748],
            [77.00975191937914, 19.2698629278687],
            [77.02208861447623, 19.28518677838504],
            [76.995226437656, 19.27510302414647],
            [76.98022237087815, 19.31970192701793],
            [76.9229049031055, 19.31024948725094],
            [76.9227058916298, 19.29830407221585],
            [76.89116108213788, 19.30802975001944],
            [76.88929490398232, 19.32273027806638],
            [76.9160567183402, 19.33858704099896],
            [76.88950826943585, 19.3501947030141],
            [76.89214505361313, 19.37912698652671],
            [76.92524538655918, 19.43739580191608],
            [76.865055328072, 19.43901390122038],
            [76.88759887910334, 19.46205973303288],
            [76.86606495937532, 19.46823409466721],
            [76.85571758186751, 19.52373660773893],
            [76.85699293956571, 19.53549309764959],
            [76.8826318147153, 19.53374833710999],
            [76.89269200932718, 19.58252897927917],
            [76.92466032224287, 19.5982313210327],
            [76.91414600903818, 19.63947871260064],
            [76.86713539652165, 19.62404247208811],
            [76.87031623834258, 19.64658963518089],
            [76.85032652269298, 19.65106824224973],
            [76.86357369173743, 19.67614011404034],
            [76.84963659948694, 19.70673216398484],
            [76.81922208941376, 19.70685046691533],
            [76.823195838272, 19.67263098597029],
            [76.80716133227496, 19.68302230827548],
            [76.79104781030219, 19.6704410302763],
            [76.78135408542079, 19.73284599914819],
            [76.76069115253348, 19.68541665520688],
            [76.73234964533869, 19.71424130773613],
            [76.7388960660072, 19.72944306559996],
            [76.71992626165877, 19.74110231255246],
            [76.71687820130079, 19.76888004341107],
            [76.69118194841332, 19.75504371476949],
            [76.66931719473375, 19.77548455245181],
            [76.64199110653749, 19.77369763968858],
            [76.62737439992958, 19.80405713103487],
            [76.62731162972803, 19.78401238962839],
            [76.59631500634201, 19.77715467441434],
            [76.6099833975404, 19.79181612312668],
            [76.59600265896428, 19.82719322780279]
          ]
        ]
      }
    },
    {
      id: '24',
      type: 'Feature',
      properties: {
        Name: 'PUNE',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'PUNE',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '490',
        Shape_Leng: 1021910,
        Shape_Area: 15181800000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.8076804282798, 19.39303536453621],
            [73.77798186856342, 19.38724185943307],
            [73.79325106009378, 19.33378710391168],
            [73.77170814856119, 19.34237560052394],
            [73.74715701758349, 19.31814770610872],
            [73.7468667428747, 19.33723382003748],
            [73.66926445825874, 19.30516741513888],
            [73.69501207236097, 19.25818233383474],
            [73.68539283480379, 19.24232239236181],
            [73.65834242741444, 19.23933488215738],
            [73.6299734030768, 19.20571210614828],
            [73.60865335415235, 19.21060889368506],
            [73.60637404121044, 19.19049584241531],
            [73.53653421569042, 19.17884103596305],
            [73.54243596028805, 19.12025554900556],
            [73.52193303402532, 19.12206907142128],
            [73.51461935876259, 19.04767699313779],
            [73.539529430641, 19.04833510320519],
            [73.53901672626525, 19.015729676568],
            [73.55477763210165, 19.00985506113061],
            [73.50959091810529, 18.9677438746408],
            [73.48475742247645, 18.98064428007389],
            [73.45911726253316, 18.96407008130298],
            [73.4621014664383, 18.92723544379383],
            [73.43162477573475, 18.91551176370771],
            [73.42494139523153, 18.86110142338],
            [73.4016161031653, 18.84215928743957],
            [73.3890459590473, 18.85344908318844],
            [73.3785140497796, 18.79289935142278],
            [73.35090077243132, 18.75763383524635],
            [73.35461789803145, 18.7213380617447],
            [73.32955048983358, 18.70125683152126],
            [73.34712422548563, 18.69303680197631],
            [73.35831690648138, 18.7134326189966],
            [73.3578743988287, 18.69964394548985],
            [73.38564124137935, 18.69460510540491],
            [73.38628059576045, 18.65520083489654],
            [73.33451181239903, 18.6099583113514],
            [73.32352960006598, 18.55687631827832],
            [73.3568192254689, 18.55772894887445],
            [73.3430288630609, 18.53257652873098],
            [73.39732635451124, 18.50546418698753],
            [73.3752402517322, 18.49409283592444],
            [73.37877678539171, 18.48201473041978],
            [73.36143507371771, 18.48616558897094],
            [73.36130427771353, 18.47224886123681],
            [73.37429830531444, 18.46453118041871],
            [73.40840678317804, 18.49953345891229],
            [73.39876747512464, 18.40061625283141],
            [73.42048054207615, 18.40323501374412],
            [73.42262236448094, 18.37306595840428],
            [73.44061680874835, 18.35793142306251],
            [73.42191074517966, 18.32842806275605],
            [73.42532572149459, 18.29923931737505],
            [73.47582732080356, 18.29999801973191],
            [73.47765899582845, 18.27382672910362],
            [73.49898363546212, 18.28219683642443],
            [73.51489979170906, 18.2719936351976],
            [73.50076506689722, 18.25684464969284],
            [73.5447703312584, 18.24880702007857],
            [73.52050726713425, 18.18772060992529],
            [73.54237420315587, 18.20609182766548],
            [73.5574127989967, 18.19822533091808],
            [73.55961383658357, 18.21456649729941],
            [73.58225359473033, 18.1781567345807],
            [73.59739197181938, 18.18884191710005],
            [73.66606813459323, 18.16022946950478],
            [73.63369866709643, 18.14690825806217],
            [73.62679243327297, 18.12302554875801],
            [73.60749418905024, 18.12252984882251],
            [73.61001227470275, 18.13345533915735],
            [73.60922395723861, 18.14093639444719],
            [73.60643291022866, 18.13887632025328],
            [73.5951107920274, 18.10825328597767],
            [73.60939304140531, 18.0967843976161],
            [73.60269818817645, 18.08100177749066],
            [73.6209077413114, 18.07711918844351],
            [73.61375437034435, 18.05860359228107],
            [73.66613750327747, 18.02472255605201],
            [73.7022907845718, 18.04434511268301],
            [73.79264731932943, 18.02057144968968],
            [73.81336097120868, 18.03798704904308],
            [73.85761451976691, 18.03061878999937],
            [73.88015572650585, 18.08655188793473],
            [73.86076848717424, 18.11959349622492],
            [73.90154508557616, 18.12880042733303],
            [73.87320927380499, 18.17466768367099],
            [73.89463095885996, 18.18231464719995],
            [73.90488133304565, 18.15915362471109],
            [73.94518912743246, 18.17905263636889],
            [73.9813400402124, 18.15149076386236],
            [74.00577870456117, 18.16039792086792],
            [74.02813073493739, 18.132277683344],
            [74.05311847225525, 18.14162250199054],
            [74.08033619591424, 18.12082210818309],
            [74.11799948933692, 18.13332087831053],
            [74.30228773781732, 18.06724868758802],
            [74.3550392810892, 18.09698123760146],
            [74.37245454864818, 18.07412720505443],
            [74.436259696726, 18.0647720248863],
            [74.45984116332977, 18.04641225583715],
            [74.55774865425035, 18.07016403124446],
            [74.58248525919122, 18.04602464298177],
            [74.62949275717001, 18.05691969255118],
            [74.64105154522399, 18.04416430067988],
            [74.66472193047629, 18.06990728752218],
            [74.70795564416721, 18.03050863586364],
            [74.76810227571526, 18.02331809175307],
            [74.80262389870917, 17.99666413483795],
            [74.81809546506604, 18.01533876028806],
            [74.83223691247024, 17.99317718739928],
            [74.86208728418806, 17.99253797314695],
            [74.84587633064676, 17.94585076306365],
            [74.93710448667295, 17.94157385850862],
            [74.9412022887192, 17.92426179324564],
            [75.01899200412454, 17.90899010967095],
            [75.02403301895542, 17.89503706351123],
            [75.05410520058393, 17.90504053044863],
            [75.051001261417, 17.92726649276076],
            [75.07397993717574, 17.91730251159133],
            [75.08785809078209, 17.92685558538527],
            [75.08192247270277, 17.94081187327487],
            [75.11205552354522, 17.93840692257213],
            [75.12955041675632, 17.95644837317084],
            [75.1160481884972, 17.97097636914743],
            [75.1360599152547, 17.97189915753837],
            [75.11882155124398, 18.00107372316312],
            [75.10035909501087, 17.97605791252028],
            [75.0689458550563, 17.9796132351931],
            [75.05312563047802, 17.95210381900877],
            [75.0201415023039, 17.96669504222021],
            [75.09472531575425, 18.06963060250133],
            [75.1287263344892, 18.0745721535227],
            [75.1623625745387, 18.10853810090204],
            [75.15205255479525, 18.12191890974794],
            [75.09215630533545, 18.1228157559803],
            [75.10611423803682, 18.21999437543125],
            [75.02316963645254, 18.18963030290884],
            [75.00843036226972, 18.20932522288389],
            [75.04182193759739, 18.26234111018503],
            [74.99137098452233, 18.24057111071163],
            [74.94876780895153, 18.26646050603271],
            [74.84248332347478, 18.24533438008272],
            [74.80027719043383, 18.27656435612993],
            [74.80068907165507, 18.30142145935816],
            [74.84337106493685, 18.29967032265712],
            [74.83419429790881, 18.3407276679692],
            [74.79805710538311, 18.35333590307884],
            [74.8095811418954, 18.38369950251668],
            [74.7933946048987, 18.40198189614192],
            [74.73075724454064, 18.40131149874093],
            [74.71608708545959, 18.43209969658208],
            [74.72571006935436, 18.48596652215383],
            [74.70263781074664, 18.5065732449237],
            [74.66151058981957, 18.49125647332385],
            [74.65604156007078, 18.47332269086946],
            [74.67469476948973, 18.46277608077533],
            [74.64285279603718, 18.45024041341003],
            [74.55557298068375, 18.49522616432889],
            [74.54757270480718, 18.50897759413643],
            [74.57695000625853, 18.54972850356549],
            [74.54141034221293, 18.58099742517843],
            [74.54883017964731, 18.6128226671167],
            [74.50910191293997, 18.61342199070865],
            [74.47136445578825, 18.64173120606759],
            [74.50962393772664, 18.66879505784148],
            [74.47597793488, 18.68687039576126],
            [74.47742751534723, 18.72036592340439],
            [74.44008858723453, 18.72217225863319],
            [74.42514404550589, 18.74664534358428],
            [74.39802396220749, 18.74215481826197],
            [74.38438726332362, 18.80494830739222],
            [74.3972882278279, 18.82834848745933],
            [74.34709128600845, 18.84565060478532],
            [74.3278992509009, 18.83696052366958],
            [74.30849810697246, 18.85296277398162],
            [74.29475851340139, 18.90351196696564],
            [74.22223972543078, 18.97055144288273],
            [74.21273085848325, 19.00877052156046],
            [74.17394094646046, 19.03142677489344],
            [74.21159448990606, 19.12878179739423],
            [74.23466607312429, 19.12274130210211],
            [74.26438792452102, 19.17941776077428],
            [74.31616295458907, 19.20783705884189],
            [74.26034872585387, 19.22646319385724],
            [74.21986144548556, 19.20286519451305],
            [74.16847451241324, 19.22415041037004],
            [74.15712014012422, 19.20422931998475],
            [74.15129641174731, 19.22572960599731],
            [74.08372222622319, 19.23906909563947],
            [74.08925779263731, 19.22820876988381],
            [74.04963910328395, 19.24355330081213],
            [74.0449479905148, 19.26192306718893],
            [74.03083722286233, 19.24973397583415],
            [74.02981988254027, 19.28290760588287],
            [74.00564752786366, 19.29359673071953],
            [74.02528000734145, 19.31200898138689],
            [73.99941876966663, 19.35943714245696],
            [73.92686729947457, 19.3387126047456],
            [73.91280999086614, 19.36236999684671],
            [73.88549665140606, 19.37362078198232],
            [73.85347731675857, 19.35555161216421],
            [73.8076804282798, 19.39303536453621]
          ],
          [
            [73.8489397016448, 18.16776814081059],
            [73.85126467368457, 18.17776624916757],
            [73.86673295473753, 18.17546521971747],
            [73.85837786880121, 18.1626287607507],
            [73.8489397016448, 18.16776814081059]
          ]
        ]
      }
    },
    {
      id: '25',
      type: 'Feature',
      properties: {
        Name: 'RAYGAD',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'RAYGAD',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '491',
        Shape_Leng: 712808,
        Shape_Area: 6772380000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.14476633293599, 19.12621187931062],
            [73.13034687533172, 19.10866918425029],
            [73.08397112925482, 19.11569278737092],
            [73.04752583032233, 19.099818127062],
            [73.04369348487974, 19.00739385639919],
            [72.99814830362212, 18.98700069509571],
            [72.94714877031986, 18.98677321481657],
            [72.9591713045401, 18.9571622627624],
            [72.94081060009876, 18.94448968247421],
            [72.93706077814345, 18.90933196376038],
            [72.90407301254943, 18.90443519439658],
            [72.90218574115032, 18.88288419765309],
            [72.93483967753752, 18.84404927401238],
            [72.96387760996555, 18.8418392312539],
            [72.97340941657137, 18.86280082344587],
            [72.99538658566259, 18.87151067145253],
            [72.97508759728964, 18.83950144956027],
            [72.99929189499862, 18.80920050982598],
            [72.97827223920957, 18.80759590914893],
            [72.9940018810596, 18.78711269306546],
            [72.99594317606903, 18.77301780961962],
            [72.95713253487405, 18.79923021823473],
            [72.94515162789658, 18.82638246990198],
            [72.91448933548303, 18.80032464629851],
            [72.87036772666049, 18.81134195573642],
            [72.86079911365975, 18.79176253184463],
            [72.86062486186671, 18.63110970714804],
            [72.87813915040365, 18.63081433418143],
            [72.92173935297703, 18.54717728384093],
            [72.90531621009403, 18.53855597855726],
            [72.91109224507717, 18.50255914818642],
            [72.89373245314125, 18.47179121095438],
            [72.90703551862693, 18.40298927014633],
            [72.92594592995569, 18.38343851532954],
            [72.91191961442473, 18.36544771360768],
            [72.95386708573709, 18.33496367312067],
            [72.98648136649904, 18.2822788124408],
            [72.97302078567962, 18.26616420245271],
            [72.93804808099463, 18.28372208041797],
            [72.93177840615746, 18.22042031599683],
            [72.95639543553689, 18.2196363985067],
            [72.98093260752985, 18.19628601534087],
            [72.98865887015434, 18.15789998338023],
            [72.97102844421218, 18.13288962210926],
            [72.99683319829991, 18.08421386162541],
            [72.9903756169425, 18.05576622907761],
            [73.0212949946083, 18.02745331667675],
            [73.00520613971064, 18.02118902161835],
            [73.0193886787835, 17.98983819324],
            [73.11441814313325, 17.97950157593446],
            [73.17413022846213, 18.05976422702003],
            [73.2868573831007, 18.07130298725425],
            [73.30056550962631, 18.02426890138189],
            [73.32675921539139, 18.02524494768096],
            [73.33430307951117, 18.01159077404665],
            [73.345400841402, 18.02619765548737],
            [73.35863875380538, 18.00729653999714],
            [73.34077541227832, 17.97230364622408],
            [73.37398179752354, 17.92527155147759],
            [73.3708297111408, 17.88788798417638],
            [73.40500279820122, 17.88281453816588],
            [73.42621163054675, 17.9091727370843],
            [73.44468116223626, 17.85062087005808],
            [73.46119262904148, 17.86701423726627],
            [73.51025082463663, 17.85220080654927],
            [73.53311088767556, 17.88311301032291],
            [73.55397229296223, 17.86539226430397],
            [73.56999506780359, 17.88040485757629],
            [73.53250643844713, 17.89948083285628],
            [73.5792204962544, 17.94703482491674],
            [73.59762275882217, 17.94034074579828],
            [73.6385661056436, 17.97170098207214],
            [73.62737131278065, 17.98868434316136],
            [73.65754157488594, 18.01259519169598],
            [73.65954592771173, 18.03274500097574],
            [73.61375437034435, 18.05860359228107],
            [73.6209077413114, 18.07711918844351],
            [73.60269818817645, 18.08100177749066],
            [73.59588655340406, 18.1119914325235],
            [73.60823904744929, 18.14124864258462],
            [73.60749418905024, 18.12252984882251],
            [73.62679243327297, 18.12302554875801],
            [73.63369866709643, 18.14690825806217],
            [73.66606813459323, 18.16022946950478],
            [73.59739197181938, 18.18884191710005],
            [73.58225359473033, 18.1781567345807],
            [73.55961383658357, 18.21456649729941],
            [73.5574127989967, 18.19822533091808],
            [73.54237420315587, 18.20609182766548],
            [73.52050726713425, 18.18772060992529],
            [73.5447703312584, 18.24880702007857],
            [73.50076506689722, 18.25684464969284],
            [73.51489979170906, 18.2719936351976],
            [73.49898363546212, 18.28219683642443],
            [73.47765899582845, 18.27382672910362],
            [73.47582732080356, 18.29999801973191],
            [73.42532572149459, 18.29923931737505],
            [73.42191074517966, 18.32842806275605],
            [73.44061680874835, 18.35793142306251],
            [73.42262236448094, 18.37306595840428],
            [73.42048054207615, 18.40323501374412],
            [73.39876747512464, 18.40061625283141],
            [73.40840678317804, 18.49953345891229],
            [73.37429830531444, 18.46453118041871],
            [73.36130427771353, 18.47224886123681],
            [73.36143507371771, 18.48616558897094],
            [73.37877678539171, 18.48201473041978],
            [73.3752402517322, 18.49409283592444],
            [73.39732635451124, 18.50546418698753],
            [73.3430288630609, 18.53257652873098],
            [73.3568192254689, 18.55772894887445],
            [73.33572317432804, 18.55032678379521],
            [73.32283864512176, 18.57213213051138],
            [73.33451181239903, 18.6099583113514],
            [73.38628059576045, 18.65520083489654],
            [73.38564124137935, 18.69460510540491],
            [73.3578743988287, 18.69964394548985],
            [73.35831690648138, 18.7134326189966],
            [73.34712422548563, 18.69303680197631],
            [73.32955048983358, 18.70125683152126],
            [73.35461789803145, 18.7213380617447],
            [73.35090077243132, 18.75763383524635],
            [73.3785140497796, 18.79289935142278],
            [73.3890459590473, 18.85344908318844],
            [73.4016161031653, 18.84215928743957],
            [73.43025302114852, 18.86909449007596],
            [73.43162477573475, 18.91551176370771],
            [73.4621014664383, 18.92723544379383],
            [73.46209460130125, 18.96714739147534],
            [73.48475742247645, 18.98064428007389],
            [73.50959091810529, 18.9677438746408],
            [73.55477763210165, 19.00985506113061],
            [73.53901672626525, 19.015729676568],
            [73.539529430641, 19.04833510320519],
            [73.51530964666175, 19.04597174807016],
            [73.51461935876259, 19.04767699313779],
            [73.52501766697223, 19.12985893297029],
            [73.34859112093966, 19.12869380854307],
            [73.30742831700405, 19.10693411618395],
            [73.31878936929391, 19.08009539712818],
            [73.29763001574166, 19.07231805966925],
            [73.27937885785458, 19.08677532547644],
            [73.25073923682973, 19.06177257560858],
            [73.19407776392747, 19.12745579338748],
            [73.1821459019065, 19.10582435626811],
            [73.14476633293599, 19.12621187931062]
          ]
        ]
      }
    },
    {
      id: '26',
      type: 'Feature',
      properties: {
        Name: 'RATNAGIRI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'RATNAGIRI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '492',
        Shape_Leng: 733804,
        Shape_Area: 8081760000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [73.69303031662913, 16.58636865342357],
              [73.68803354684724, 16.59254470628594],
              [73.67846354774393, 16.58395719862824],
              [73.70615607888391, 16.58121143954487],
              [73.69303031662913, 16.58636865342357]
            ]
          ],
          [
            [
              [73.28558813725583, 16.98947586876486],
              [73.28548236009208, 16.98950573354651],
              [73.28542621098636, 16.98935323704296],
              [73.28554276389868, 16.9893246050121],
              [73.28558813725583, 16.98947586876486]
            ]
          ],
          [
            [
              [73.11993944707349, 17.76644297242326],
              [73.11922153261149, 17.76598536665187],
              [73.11947519048408, 17.76552037107307],
              [73.12016890541715, 17.76655021557303],
              [73.11993944707349, 17.76644297242326]
            ]
          ],
          [
            [
              [73.10127211947888, 17.8047131436041],
              [73.10136224748113, 17.80405647635472],
              [73.10156849811179, 17.80411700994646],
              [73.10127211947888, 17.8047131436041]
            ]
          ],
          [
            [
              [73.21060863464172, 18.06342959944045],
              [73.17245706169724, 18.05836739379514],
              [73.11462133624762, 17.97959386924138],
              [73.04137198529413, 17.98598576141741],
              [73.02885051225634, 17.94955503806595],
              [73.07500240440203, 17.88252567976584],
              [73.08935798019381, 17.81234051931661],
              [73.12591516796665, 17.75274514749346],
              [73.13515102782803, 17.7086456391359],
              [73.11427790962831, 17.68573302948191],
              [73.1527331389769, 17.5987093312699],
              [73.13710165945217, 17.55589098155216],
              [73.17392559260315, 17.51690726926592],
              [73.19218043706513, 17.46995737362091],
              [73.18452756789692, 17.44313818122691],
              [73.19698114714195, 17.44196036867278],
              [73.19865129035936, 17.43908560312789],
              [73.16769643293624, 17.40305270929639],
              [73.18333128689218, 17.38407669620948],
              [73.20558113156187, 17.3873302904858],
              [73.22944738200152, 17.33516118273985],
              [73.21890237105445, 17.32855015309373],
              [73.23876281028755, 17.31704147143482],
              [73.23555637841618, 17.28810799742579],
              [73.25877070709026, 17.28603013372981],
              [73.22924747933395, 17.28247770391505],
              [73.22265123036743, 17.30632511672497],
              [73.190638505181, 17.29930888316319],
              [73.24469052681155, 17.22238972937984],
              [73.24663998538524, 17.20430693264022],
              [73.23162620474136, 17.19914380197089],
              [73.25344647300592, 17.18830807422786],
              [73.28905186477023, 17.07440969364475],
              [73.27914133901746, 17.03755982658639],
              [73.25821254838992, 17.04877497806354],
              [73.25536795360064, 17.02771270089922],
              [73.28405330033583, 17.01109622819267],
              [73.27123598944303, 16.98509218373813],
              [73.2997179355707, 16.9818840144959],
              [73.27857608472884, 16.89303671669096],
              [73.30300254990065, 16.89141053276653],
              [73.28743007909397, 16.88089591783515],
              [73.28913856723288, 16.84429213612249],
              [73.31913811243568, 16.79533838908763],
              [73.30444198882236, 16.76587181860619],
              [73.30538960092478, 16.73027712945515],
              [73.32971591035306, 16.68739489128028],
              [73.3230183228152, 16.63861668302737],
              [73.33910631705177, 16.63780543834578],
              [73.3304505496706, 16.61985885186974],
              [73.35519457553595, 16.61895063052194],
              [73.32069450835623, 16.60687085532813],
              [73.31864768560526, 16.59302345340769],
              [73.35556057374014, 16.56594835028711],
              [73.34422577155021, 16.54876767468024],
              [73.35875103598885, 16.52370712067914],
              [73.46659585893462, 16.49368013947843],
              [73.4979770062848, 16.52038967392976],
              [73.540345867559, 16.51422199132903],
              [73.5787566377167, 16.54540270582636],
              [73.60056168236102, 16.5444611616897],
              [73.622076800678, 16.58312077491619],
              [73.63234590912651, 16.55919263816047],
              [73.64600338742696, 16.56195316982773],
              [73.69056901052217, 16.62386503226896],
              [73.70945586201042, 16.60311205455221],
              [73.7676917064016, 16.60326334294267],
              [73.75354207641664, 16.64179602958807],
              [73.77175956501975, 16.66521214096342],
              [73.856470878172, 16.65590026261325],
              [73.85958179408452, 16.68117613863852],
              [73.81087639693904, 16.70823062495867],
              [73.8375891490493, 16.73648973309417],
              [73.82872257431215, 16.75400295657219],
              [73.7797968279934, 16.77940962257155],
              [73.76083977253012, 16.77001340447664],
              [73.76045040185686, 16.80253800561138],
              [73.71141988209742, 16.82791973688522],
              [73.73782324455362, 16.8450938177186],
              [73.76492528056991, 16.8290245312923],
              [73.76714252037, 16.86592900716669],
              [73.73652507054074, 16.91472358087983],
              [73.7883747688993, 16.90689397700591],
              [73.79515996351667, 16.92991727945818],
              [73.76216500994576, 16.96173689476901],
              [73.78596211259976, 16.99306556398945],
              [73.83121712827882, 16.98948714796727],
              [73.8339650901727, 17.05351631094025],
              [73.80360231741231, 17.0625217865978],
              [73.80711046873243, 17.08622185188357],
              [73.74980593226142, 17.12949278263049],
              [73.73648608225737, 17.12143898490112],
              [73.68931498061737, 17.14180941049849],
              [73.71518844267354, 17.20921786770563],
              [73.69281910183368, 17.23064690935881],
              [73.67814294195382, 17.29477743446004],
              [73.68569372116742, 17.34519297616653],
              [73.6738481399425, 17.34766625585526],
              [73.69136175901853, 17.35937737717992],
              [73.6407817175551, 17.39119626771146],
              [73.66836323070076, 17.39334453611024],
              [73.7040759202108, 17.42343902972728],
              [73.6937387866905, 17.48743171977254],
              [73.74652577642695, 17.55688603141374],
              [73.71547662550833, 17.57355675623237],
              [73.72776180915355, 17.58899339304833],
              [73.71275631155447, 17.60757486407734],
              [73.72069807216434, 17.61785230831147],
              [73.69046666864983, 17.62867024559384],
              [73.70138027563684, 17.65894314331758],
              [73.68683140515928, 17.68573072003475],
              [73.65106404303428, 17.70856719132417],
              [73.59333440320007, 17.70172726860619],
              [73.56594211815006, 17.72418508956061],
              [73.59185376330879, 17.77295554339149],
              [73.58183921208533, 17.78919438236635],
              [73.60204910717829, 17.79503414167092],
              [73.58444252033051, 17.83383551203696],
              [73.59726320338154, 17.85007052448165],
              [73.57724058378098, 17.87607689167599],
              [73.54976147710367, 17.86533397703536],
              [73.53311088767556, 17.88311301032291],
              [73.51025082463663, 17.85220080654927],
              [73.46119262904148, 17.86701423726627],
              [73.44468116223626, 17.85062087005808],
              [73.42621163054675, 17.9091727370843],
              [73.40500279820122, 17.88281453816588],
              [73.38049954327253, 17.88230484645736],
              [73.36133993568903, 17.95442714353586],
              [73.34077541227832, 17.97230364622408],
              [73.35921827497927, 18.00547374452798],
              [73.34589556514032, 18.02583195532505],
              [73.33430307951117, 18.01159077404665],
              [73.32675921539139, 18.02524494768096],
              [73.30056550962631, 18.02426890138189],
              [73.2868573831007, 18.07130298725425],
              [73.21060863464172, 18.06342959944045]
            ]
          ]
        ]
      }
    },
    {
      id: '27',
      type: 'Feature',
      properties: {
        Name: 'SANGLI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'SANGLI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '493',
        Shape_Leng: 947268,
        Shape_Area: 8391930000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.90837973713187, 17.6219437431309],
            [74.8905527931107, 17.61767325790233],
            [74.87635307646674, 17.56990133975374],
            [74.85654764389913, 17.5597512498333],
            [74.86040416071887, 17.51162126701548],
            [74.80693513690657, 17.45282651921445],
            [74.68467703070077, 17.48786450866183],
            [74.69603579959659, 17.43882276304458],
            [74.68086052591995, 17.39261810442415],
            [74.62249069698902, 17.39935084615704],
            [74.59508444542057, 17.44908540050007],
            [74.58370719469612, 17.41363886874895],
            [74.52749210469818, 17.41918050767693],
            [74.49795460337198, 17.38344212847508],
            [74.34431419339525, 17.4197192834122],
            [74.283933793996, 17.41939511006491],
            [74.25428818846878, 17.36334440082082],
            [74.28812277899364, 17.35545603980067],
            [74.27902505184424, 17.33655075714147],
            [74.29378643196328, 17.31277222077455],
            [74.25622330147608, 17.29339037869503],
            [74.26522409483245, 17.25745348904142],
            [74.28781593040274, 17.24744112614321],
            [74.26606013732096, 17.2223071197589],
            [74.28712019660605, 17.19778716830865],
            [74.27795660016304, 17.17869519841642],
            [74.24794712232652, 17.18293516692291],
            [74.2472510126039, 17.16045725999933],
            [74.2327522495117, 17.15583397737412],
            [74.24690593423082, 17.14153940741799],
            [74.17740093288815, 17.14917296353569],
            [74.1420621221634, 17.11931207115068],
            [74.11115943665887, 17.12394130555221],
            [74.0963459529487, 17.10188934532183],
            [74.05127000961033, 17.1051912366374],
            [74.03042015654437, 17.0903800322502],
            [73.97938838027653, 17.13194015295868],
            [73.88399864570965, 17.15529584110249],
            [73.83467433327124, 17.22603301533501],
            [73.76560767155514, 17.25096338711274],
            [73.74535553945522, 17.27856242311564],
            [73.69468563681697, 17.26161622111974],
            [73.69281910183368, 17.23064690935881],
            [73.71518844267354, 17.20921786770563],
            [73.69338530616137, 17.18024966135627],
            [73.742571736979, 17.17647975270649],
            [73.74723572647834, 17.15508547686131],
            [73.77318791972874, 17.14962895185048],
            [73.77587389004715, 17.18207753494731],
            [73.84650450023783, 17.15422550456801],
            [73.91381549452791, 17.07143328931983],
            [73.93043910069848, 17.07481589767433],
            [73.97819443850398, 17.03644806997854],
            [73.9750469212806, 16.98861823032779],
            [74.0233538706637, 16.98515173546376],
            [74.02296192158099, 16.94230437726907],
            [74.06570684437675, 16.90237983371757],
            [74.09147443164478, 16.91826092596784],
            [74.12073139211468, 16.91317732790037],
            [74.14558992181749, 16.88273144165689],
            [74.17519633362843, 16.90253657411699],
            [74.20973385708253, 16.89301942103942],
            [74.22316543869114, 16.91368654726109],
            [74.24695325383574, 16.88641952941644],
            [74.28181621767578, 16.9185158406458],
            [74.29554820813924, 16.89464114236001],
            [74.35419965320523, 16.8727763357051],
            [74.36202953901606, 16.85344226167614],
            [74.4015289708148, 16.88300721276184],
            [74.41567646379436, 16.87767462531039],
            [74.40405545827535, 16.85138455303326],
            [74.41464015496497, 16.84395120454688],
            [74.47255667985529, 16.86847744986068],
            [74.49503355935519, 16.85781431955235],
            [74.50057313306654, 16.82963054118188],
            [74.51694370210926, 16.85813793388628],
            [74.56059510324417, 16.8062186433126],
            [74.62943318240225, 16.78795126735199],
            [74.64583311569884, 16.75236300135309],
            [74.69856928253834, 16.73717161533064],
            [74.69223379388241, 16.71533331230207],
            [74.73209174467388, 16.7183240170317],
            [74.7719695844538, 16.75068225527342],
            [74.84982043477298, 16.77275560312271],
            [74.92014360852947, 16.77249920213703],
            [74.90151566246006, 16.86255021584564],
            [74.96036076715126, 16.88094723355526],
            [74.9635785539934, 16.90971132708238],
            [74.92177566053026, 16.92986165984611],
            [74.93170715757083, 16.94475520892337],
            [74.96454438231217, 16.92677634697424],
            [74.9643550635116, 16.94763323410934],
            [74.9929089277756, 16.95207042980893],
            [75.02658570255244, 16.94413629779898],
            [75.0252348396784, 16.92800233721301],
            [75.08933369997565, 16.95158216015618],
            [75.0963085852149, 16.91374326481215],
            [75.11748241444221, 16.91344466911222],
            [75.1364832118611, 16.87448789752549],
            [75.18898739984246, 16.87528025723942],
            [75.18184748936585, 16.84340231732588],
            [75.21420223843337, 16.84169921604924],
            [75.23766094201221, 16.86794085127336],
            [75.26471971792044, 16.86279981486357],
            [75.28202992495274, 16.88029047648766],
            [75.27960265609991, 16.9565563585008],
            [75.35005086461483, 16.95781647280878],
            [75.39213506510164, 16.9800906682932],
            [75.42787797625367, 16.96649455259024],
            [75.46555223206785, 16.98836500989821],
            [75.48907765897383, 16.94442272265134],
            [75.52931415993646, 16.96939982867331],
            [75.56765208586155, 16.96574587286474],
            [75.57309716202592, 17.00960646015865],
            [75.60688752270023, 17.00456581533879],
            [75.60786302980078, 16.97099707593652],
            [75.63393196771592, 16.97025916245292],
            [75.6420577310074, 16.95455112857617],
            [75.67513395657608, 16.96554578020062],
            [75.66969398973224, 17.03816027881245],
            [75.64099845053465, 17.03758144737451],
            [75.67671537207127, 17.06541586599709],
            [75.67228865061016, 17.11599583882961],
            [75.6503469434203, 17.1156923352503],
            [75.62537655371712, 17.17400031904775],
            [75.66191164739165, 17.21457757510652],
            [75.65771605219102, 17.26320772958284],
            [75.60383885486142, 17.30538821887619],
            [75.54236750849977, 17.27693488902175],
            [75.51544714648902, 17.24036287346855],
            [75.42091149942314, 17.26588386424375],
            [75.4067588295067, 17.18472420752761],
            [75.36995009539343, 17.19050255094828],
            [75.36564933583843, 17.23619382166628],
            [75.3347782204927, 17.23955083514956],
            [75.33024403876149, 17.21810311620023],
            [75.28718157450793, 17.21565757802334],
            [75.28282860740224, 17.1958751587064],
            [75.304592785676, 17.1693702464093],
            [75.2962253484688, 17.14598091914124],
            [75.27027415836947, 17.14837521994782],
            [75.26825062253626, 17.18333714622612],
            [75.22223697271232, 17.183646149806],
            [75.21684381391525, 17.20467285278956],
            [75.2401863375232, 17.21823358201202],
            [75.24729448735529, 17.25545920879368],
            [75.20450596202795, 17.27036365354675],
            [75.17973206020504, 17.23569888046854],
            [75.09378072209012, 17.25160908232228],
            [75.07959686110327, 17.24760014098678],
            [75.07770558786825, 17.22159192318689],
            [75.01616904304488, 17.22470485073087],
            [74.97671495461593, 17.19286369767426],
            [74.94362969189503, 17.20469962049945],
            [74.94097698695116, 17.16904877984213],
            [74.88653389737654, 17.18126192504945],
            [74.89454459100592, 17.19526834805759],
            [74.87127016597324, 17.19017001519779],
            [74.86882414409939, 17.21008827939071],
            [74.84833021126319, 17.20370024219126],
            [74.8852248083247, 17.22080333251749],
            [74.90902449017574, 17.27597354719224],
            [74.95977433199543, 17.29308698017608],
            [74.96797484954764, 17.34142013865544],
            [75.00831956458765, 17.36820512563719],
            [74.99776951401319, 17.40663933742456],
            [75.03514191951538, 17.41808337141437],
            [75.03807369424041, 17.48896371227788],
            [74.97340443892371, 17.46613075107716],
            [74.93679439466848, 17.51031533310659],
            [74.98512081514104, 17.54489336014753],
            [74.96246856230208, 17.56207449529975],
            [74.96186059426213, 17.59146401560272],
            [74.91543996361024, 17.58003484504044],
            [74.9237162949708, 17.61928176227467],
            [74.90837973713187, 17.6219437431309]
          ]
        ]
      }
    },
    {
      id: '28',
      type: 'Feature',
      properties: {
        Name: 'SATARA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'SATARA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '494',
        Shape_Leng: 725489,
        Shape_Area: 10194700000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [73.85271068725905, 18.17815945723688],
              [73.84704101325089, 18.16880062342807],
              [73.85837786880121, 18.1626287607507],
              [73.86673295473753, 18.17546521971747],
              [73.85271068725905, 18.17815945723688]
            ]
          ],
          [
            [
              [73.89664154618835, 18.18004403286815],
              [73.87320927380499, 18.17466768367099],
              [73.90154508557616, 18.12880042733303],
              [73.86076848717424, 18.11959349622492],
              [73.88015572650585, 18.08655188793473],
              [73.85868644254454, 18.03115291378737],
              [73.81336097120868, 18.03798704904308],
              [73.79264731932943, 18.02057144968968],
              [73.7022907845718, 18.04434511268301],
              [73.65848124712844, 18.02904698630825],
              [73.62737131278065, 17.98868434316136],
              [73.6385661056436, 17.97170098207214],
              [73.59762275882217, 17.94034074579828],
              [73.5792204962544, 17.94703482491674],
              [73.53250643844713, 17.89948083285628],
              [73.5616770444992, 17.89300783956655],
              [73.59726320338154, 17.85007052448165],
              [73.58444252033051, 17.83383551203696],
              [73.60204910717829, 17.79503414167092],
              [73.58183921208533, 17.78919438236635],
              [73.59185376330879, 17.77295554339149],
              [73.56594211815006, 17.72418508956061],
              [73.59333440320007, 17.70172726860619],
              [73.65106404303428, 17.70856719132417],
              [73.68683140515928, 17.68573072003475],
              [73.70138027563684, 17.65894314331758],
              [73.69046666864983, 17.62867024559384],
              [73.72069807216434, 17.61785230831147],
              [73.71275631155447, 17.60757486407734],
              [73.72776180915355, 17.58899339304833],
              [73.71547662550833, 17.57355675623237],
              [73.74652577642695, 17.55688603141374],
              [73.6937387866905, 17.48743171977254],
              [73.7040759202108, 17.42343902972728],
              [73.66836323070076, 17.39334453611024],
              [73.6407817175551, 17.39119626771146],
              [73.69136175901853, 17.35937737717992],
              [73.6738481399425, 17.34766625585526],
              [73.68569372116742, 17.34519297616653],
              [73.67814294195382, 17.29477743446004],
              [73.69464066080114, 17.26051764097165],
              [73.74535553945522, 17.27856242311564],
              [73.76560767155514, 17.25096338711274],
              [73.83467433327124, 17.22603301533501],
              [73.88411810794044, 17.15522489181321],
              [73.97938838027653, 17.13194015295868],
              [74.03042015654437, 17.0903800322502],
              [74.05127000961033, 17.1051912366374],
              [74.0939705380183, 17.10094496676639],
              [74.11007681692428, 17.12335037906742],
              [74.1420621221634, 17.11931207115068],
              [74.17740093288815, 17.14917296353569],
              [74.24690593423082, 17.14153940741799],
              [74.2327522495117, 17.15583397737412],
              [74.2472510126039, 17.16045725999933],
              [74.24794712232652, 17.18293516692291],
              [74.27795660016304, 17.17869519841642],
              [74.28534865432174, 17.20590346977068],
              [74.26606013732096, 17.2223071197589],
              [74.28781593040274, 17.24744112614321],
              [74.26522409483245, 17.25745348904142],
              [74.25622330147608, 17.29339037869503],
              [74.29378643196328, 17.31277222077455],
              [74.27902505184424, 17.33655075714147],
              [74.28666104397861, 17.35860792454831],
              [74.26066891540731, 17.35492553651493],
              [74.25428818846878, 17.36334440082082],
              [74.2923333016584, 17.42502029945372],
              [74.49795460337198, 17.38344212847508],
              [74.52749210469818, 17.41918050767693],
              [74.58370719469612, 17.41363886874895],
              [74.59508444542057, 17.44908540050007],
              [74.62249069698902, 17.39935084615704],
              [74.66972968449323, 17.38951115189734],
              [74.69245738138476, 17.40164089741087],
              [74.68467703070077, 17.48786450866183],
              [74.80693513690657, 17.45282651921445],
              [74.86040416071887, 17.51162126701548],
              [74.85654764389913, 17.5597512498333],
              [74.87635307646674, 17.56990133975374],
              [74.87962246183986, 17.60427550622174],
              [74.90610814986226, 17.62928217196266],
              [74.88573890803613, 17.68270486928467],
              [74.86410144036391, 17.69419720942656],
              [74.871837493281, 17.72702239764233],
              [74.83852410525746, 17.72720462276876],
              [74.77916958917602, 17.77649986516389],
              [74.76432380958302, 17.76102906709782],
              [74.73761431599121, 17.767381807685],
              [74.75070571484218, 17.78636652138222],
              [74.75613689776266, 17.77422543763713],
              [74.74838717151101, 17.79155086868176],
              [74.69940509152141, 17.79016560672861],
              [74.70387223091352, 17.81057621023506],
              [74.6845366432503, 17.81276680918425],
              [74.69471638606707, 17.82141888728266],
              [74.66548769639661, 17.86422320429309],
              [74.63651949191643, 17.84111283643541],
              [74.64314788215279, 17.83097124720724],
              [74.62931362374735, 17.84009284716728],
              [74.61887429107632, 17.82914278610116],
              [74.62114725772953, 17.84520425268676],
              [74.60706300319701, 17.84523649948899],
              [74.6360720271928, 17.87354463342822],
              [74.63224371182548, 17.8943879079028],
              [74.65543308055345, 17.92559281333115],
              [74.66232705705164, 18.00384895977927],
              [74.71123830283302, 18.02929941105312],
              [74.68408753455455, 18.06009495529076],
              [74.6579578907423, 18.06953552792847],
              [74.6418042477674, 18.04430102060986],
              [74.62949275717001, 18.05691969255118],
              [74.58248525919122, 18.04602464298177],
              [74.55774865425035, 18.07016403124446],
              [74.45984116332977, 18.04641225583715],
              [74.436259696726, 18.0647720248863],
              [74.37245454864818, 18.07412720505443],
              [74.3550392810892, 18.09698123760146],
              [74.30228773781732, 18.06724868758802],
              [74.11799948933692, 18.13332087831053],
              [74.08033619591424, 18.12082210818309],
              [74.05311847225525, 18.14162250199054],
              [74.02813073493739, 18.132277683344],
              [74.00577870456117, 18.16039792086792],
              [73.9813400402124, 18.15149076386236],
              [73.94518912743246, 18.17905263636889],
              [73.90197370877182, 18.15958486277895],
              [73.89664154618835, 18.18004403286815]
            ]
          ]
        ]
      }
    },
    {
      id: '29',
      type: 'Feature',
      properties: {
        Name: 'SINDHUDURG',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'SINDHUDURG',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '495',
        Shape_Leng: 607458,
        Shape_Area: 5000890000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.77524272055028, 16.66308298169173],
            [73.75354207641664, 16.64179602958807],
            [73.7676917064016, 16.60326334294267],
            [73.70945586201042, 16.60311205455221],
            [73.69056901052217, 16.62386503226896],
            [73.6476940850961, 16.56315264091366],
            [73.63234590912651, 16.55919263816047],
            [73.622076800678, 16.58312077491619],
            [73.60056168236102, 16.5444611616897],
            [73.5787566377167, 16.54540270582636],
            [73.54415447825318, 16.51539454163077],
            [73.4979770062848, 16.52038967392976],
            [73.46659585893462, 16.49368013947843],
            [73.39447054135401, 16.51043596863212],
            [73.35111593510372, 16.52929223001208],
            [73.35643640121104, 16.5634422252415],
            [73.3446740074148, 16.56965134102263],
            [73.31087063590195, 16.54143945757478],
            [73.31694639788499, 16.51418431284882],
            [73.35866967020658, 16.44166044876559],
            [73.36892009237545, 16.36292564186875],
            [73.38668038271028, 16.35842362156999],
            [73.43964352884815, 16.19133349640173],
            [73.46492054987691, 16.08693699015637],
            [73.4564278498293, 16.05267926480773],
            [73.48436094422634, 16.03371254569648],
            [73.51010881932143, 15.94045978743971],
            [73.58696672627038, 15.91061436411522],
            [73.62608567153431, 15.85176766408742],
            [73.65625801808358, 15.79576040333278],
            [73.66435422291046, 15.75310185455551],
            [73.64986204595286, 15.74489996311725],
            [73.6768790295739, 15.72589232791938],
            [73.74283615900369, 15.73657493210673],
            [73.78497403973559, 15.7261252495918],
            [73.82661530061002, 15.74336112383737],
            [73.86339590250378, 15.79878981487912],
            [73.88008883658335, 15.77432094772546],
            [73.87569505273376, 15.75128305155211],
            [73.93872529327605, 15.74333225980561],
            [73.95233054886582, 15.71440194658133],
            [73.94369516825448, 15.69693647327576],
            [73.96376046616314, 15.69232178471332],
            [73.9678577993107, 15.6305772273229],
            [74.02079718889009, 15.60608518447959],
            [74.03115607815306, 15.62261132912982],
            [74.11388550584545, 15.64612743037619],
            [74.08809647005297, 15.67247290087341],
            [74.1257708955671, 15.68096717386612],
            [74.12216561793002, 15.72073114622991],
            [74.16155659535112, 15.75129445990145],
            [74.20143337107548, 15.75862070733656],
            [74.20892486542859, 15.7811259758296],
            [74.17249527729129, 15.77381013923132],
            [74.15362507417883, 15.78682019298695],
            [74.15848834842068, 15.82272424357313],
            [74.1409558443265, 15.82338864048749],
            [74.14572189400178, 15.83288416560305],
            [74.10894653716453, 15.82268357057912],
            [74.10288149538474, 15.84086121260169],
            [74.03453380202937, 15.80269906153139],
            [74.03036704591295, 15.83464082899336],
            [74.0929691077376, 15.87307603442387],
            [74.07306047666754, 15.94877925013442],
            [74.05965966206766, 15.94182441257157],
            [74.0455815516649, 15.95711541215805],
            [74.09088689419745, 16.0076927974667],
            [74.06004476259176, 16.05107681687342],
            [74.04401473230723, 16.03116386731399],
            [74.00072703203152, 16.04128380022325],
            [73.99706260978287, 16.05963124704313],
            [74.01137425286687, 16.0666321763518],
            [73.99101034347235, 16.07942244801383],
            [73.9959524271763, 16.09273402560193],
            [73.90524809622195, 16.10090048923298],
            [73.89590251480494, 16.08894861389787],
            [73.86291817832317, 16.10716957800312],
            [73.84377668795082, 16.09390868773437],
            [73.85995211382571, 16.06994479030483],
            [73.83393684382555, 16.09395587163748],
            [73.85363098769064, 16.13471596674423],
            [73.84486828645053, 16.15309643524186],
            [73.90605994404225, 16.13578436950202],
            [73.91465334667761, 16.17184109858373],
            [73.94272875196584, 16.17450893918848],
            [73.95621042282669, 16.20856526364016],
            [73.9226348330926, 16.20211515329792],
            [73.91779543581362, 16.21819845379401],
            [73.94286387826372, 16.24378821803574],
            [73.88937527219512, 16.22904543669313],
            [73.91749987368739, 16.2456537705602],
            [73.88180175127121, 16.278831884509],
            [73.902195529114, 16.32863114421191],
            [73.86381290555052, 16.30853670901036],
            [73.85640433338145, 16.31727163418073],
            [73.84589115448013, 16.30037240888292],
            [73.83888467341232, 16.31643638852081],
            [73.84811471820495, 16.32445273232306],
            [73.83213055921316, 16.34500255112328],
            [73.86327624205647, 16.3727861457508],
            [73.83404462019475, 16.40148375243968],
            [73.88754316532383, 16.46339493186911],
            [73.8516145717014, 16.48763025394609],
            [73.84717750890479, 16.52623175539239],
            [73.81481516607695, 16.54424011657058],
            [73.83096267394335, 16.5496649982682],
            [73.86237922102505, 16.61403644624839],
            [73.84905665266099, 16.65006015908468],
            [73.77524272055028, 16.66308298169173]
          ],
          [
            [73.68505469878234, 16.59097522804537],
            [73.70542623867864, 16.58747199355427],
            [73.70615607888391, 16.58121143954487],
            [73.67846354774393, 16.58395719862824],
            [73.68505469878234, 16.59097522804537]
          ]
        ]
      }
    },
    {
      id: '30',
      type: 'Feature',
      properties: {
        Name: 'SOLAPUR',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'SOLAPUR',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '496',
        Shape_Leng: 1286710,
        Shape_Area: 14450300000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [75.22840739630196, 18.54093884347236],
            [75.21349938879568, 18.55407124019983],
            [75.20162734719213, 18.53131846115227],
            [75.1329848733625, 18.52583078749302],
            [75.0794427168165, 18.42341407712182],
            [75.01544428103243, 18.43671426496065],
            [75.00538723297598, 18.4033396808617],
            [74.9146828034844, 18.37862510833958],
            [74.90805217433207, 18.3567776244304],
            [74.83340436332382, 18.33502900657116],
            [74.84206540687593, 18.29849044801389],
            [74.79635058815491, 18.29459564442525],
            [74.84248332347478, 18.24533438008272],
            [74.94876780895153, 18.26646050603271],
            [74.99137098452233, 18.24057111071163],
            [75.04182193759739, 18.26234111018503],
            [75.00843036226972, 18.20932522288389],
            [75.02274536569504, 18.18971991771866],
            [75.10611423803682, 18.21999437543125],
            [75.09215630533545, 18.1228157559803],
            [75.15205255479525, 18.12191890974794],
            [75.1623625745387, 18.10853810090204],
            [75.1287263344892, 18.0745721535227],
            [75.09472531575425, 18.06963060250133],
            [75.0201415023039, 17.96669504222021],
            [75.05312563047802, 17.95210381900877],
            [75.0689458550563, 17.9796132351931],
            [75.10035909501087, 17.97605791252028],
            [75.1172823805805, 18.0013637719551],
            [75.1360599152547, 17.97189915753837],
            [75.11574385431196, 17.97038475107674],
            [75.12715914423104, 17.95238114123423],
            [75.10991883414302, 17.93761197061231],
            [75.08192247270277, 17.94081187327487],
            [75.08785809078209, 17.92685558538527],
            [75.07397993717574, 17.91730251159133],
            [75.051001261417, 17.92726649276076],
            [75.05410520058393, 17.90504053044863],
            [75.02403301895542, 17.89503706351123],
            [75.01899200412454, 17.90899010967095],
            [74.9412022887192, 17.92426179324564],
            [74.93710448667295, 17.94157385850862],
            [74.84587633064676, 17.94585076306365],
            [74.86208728418806, 17.99253797314695],
            [74.83223691247024, 17.99317718739928],
            [74.81882933924003, 18.0151040322291],
            [74.80262389870917, 17.99666413483795],
            [74.76810227571526, 18.02331809175307],
            [74.71123830283302, 18.02929941105312],
            [74.66232705705164, 18.00384895977927],
            [74.6531977011806, 17.91943685221333],
            [74.63224371182548, 17.8943879079028],
            [74.6360720271928, 17.87354463342822],
            [74.6085399046886, 17.85842807090825],
            [74.60706300319701, 17.84523649948899],
            [74.62114725772953, 17.84520425268676],
            [74.61270193556051, 17.83320771688817],
            [74.63562562487238, 17.82955714073584],
            [74.66548769639661, 17.86422320429309],
            [74.69471638606707, 17.82141888728266],
            [74.6845366432503, 17.81276680918425],
            [74.70387223091352, 17.81057621023506],
            [74.69940509152141, 17.79016560672861],
            [74.74838717151101, 17.79155086868176],
            [74.75613689776266, 17.77422543763713],
            [74.75070571484218, 17.78636652138222],
            [74.73761431599121, 17.767381807685],
            [74.76432380958302, 17.76102906709782],
            [74.77916958917602, 17.77649986516389],
            [74.83852410525746, 17.72720462276876],
            [74.8675120454865, 17.73105995317675],
            [74.86410144036391, 17.69419720942656],
            [74.88573890803613, 17.68270486928467],
            [74.90903434289926, 17.62089865867772],
            [74.9237162949708, 17.61928176227467],
            [74.91543996361024, 17.58003484504044],
            [74.96186059426213, 17.59146401560272],
            [74.96246856230208, 17.56207449529975],
            [74.98512081514104, 17.54489336014753],
            [74.93708982781975, 17.50930145005436],
            [74.97340443892371, 17.46613075107716],
            [75.02711965043291, 17.49525919950812],
            [75.03904542438752, 17.48658287531682],
            [75.03514191951538, 17.41808337141437],
            [74.99776951401319, 17.40663933742456],
            [75.00831956458765, 17.36820512563719],
            [74.96797484954764, 17.34142013865544],
            [74.95977433199543, 17.29308698017608],
            [74.90902449017574, 17.27597354719224],
            [74.8852248083247, 17.22080333251749],
            [74.85734429283336, 17.21541776179335],
            [74.84833021126319, 17.20370024219126],
            [74.86882414409939, 17.21008827939071],
            [74.87127016597324, 17.19017001519779],
            [74.89454459100592, 17.19526834805759],
            [74.88653389737654, 17.18126192504945],
            [74.94097698695116, 17.16904877984213],
            [74.94362969189503, 17.20469962049945],
            [74.97671495461593, 17.19286369767426],
            [75.01616904304488, 17.22470485073087],
            [75.07770558786825, 17.22159192318689],
            [75.07959686110327, 17.24760014098678],
            [75.09378072209012, 17.25160908232228],
            [75.17973206020504, 17.23569888046854],
            [75.20450596202795, 17.27036365354675],
            [75.24729448735529, 17.25545920879368],
            [75.2401863375232, 17.21823358201202],
            [75.21684381391525, 17.20467285278956],
            [75.22223697271232, 17.183646149806],
            [75.26825062253626, 17.18333714622612],
            [75.27027415836947, 17.14837521994782],
            [75.2962253484688, 17.14598091914124],
            [75.304592785676, 17.1693702464093],
            [75.28282860740224, 17.1958751587064],
            [75.28718157450793, 17.21565757802334],
            [75.33024403876149, 17.21810311620023],
            [75.3347782204927, 17.23955083514956],
            [75.36564933583843, 17.23619382166628],
            [75.36995009539343, 17.19050255094828],
            [75.4067588295067, 17.18472420752761],
            [75.42091149942314, 17.26588386424375],
            [75.51544714648902, 17.24036287346855],
            [75.54236750849977, 17.27693488902175],
            [75.60345942859762, 17.30466772709343],
            [75.6100251683202, 17.345040312423],
            [75.58084537066244, 17.35122300841793],
            [75.57414260690422, 17.38329915096861],
            [75.61351630783919, 17.39191513848457],
            [75.60660106888821, 17.42037238215884],
            [75.63297968032822, 17.47721442482073],
            [75.67587588916683, 17.45594314893184],
            [75.6907294189067, 17.40947357949504],
            [75.73359475575023, 17.42009301229864],
            [75.79294053266608, 17.36969740531458],
            [75.81366013568534, 17.3727599955221],
            [75.8214406600516, 17.42122263343727],
            [75.85108406334659, 17.41052526948542],
            [75.86087813531839, 17.38559497529765],
            [75.88418844284885, 17.41795958222727],
            [75.89058185686457, 17.35652229906567],
            [75.93081941756223, 17.3225727515681],
            [76.01433236419838, 17.35353328405905],
            [76.06053521607386, 17.35530774175271],
            [76.07913002648559, 17.33160242849008],
            [76.11895334555385, 17.3705042906807],
            [76.16261784682769, 17.34522010011038],
            [76.17631499092647, 17.30078745854983],
            [76.17031474878424, 17.35262421074778],
            [76.24208711709265, 17.37883711644342],
            [76.25072752541041, 17.36043277979558],
            [76.2720091361697, 17.36059186765779],
            [76.27636043556949, 17.33457417625399],
            [76.3176634271726, 17.3323756636557],
            [76.3143441324106, 17.34838984758903],
            [76.34529924235325, 17.35444812310972],
            [76.35401167796324, 17.3143164585821],
            [76.38315992367302, 17.3145257175331],
            [76.41218865804058, 17.3510677438114],
            [76.40912054159355, 17.37138775574608],
            [76.36342654465055, 17.37766806477187],
            [76.37151040095762, 17.43642362392074],
            [76.33326247131215, 17.43390101851721],
            [76.33068729928182, 17.47019357876416],
            [76.37551612686411, 17.49021988013094],
            [76.3457645765577, 17.49252983969752],
            [76.34657184981877, 17.51257942023825],
            [76.36715757354351, 17.51989559980734],
            [76.36274038135038, 17.53737259625175],
            [76.34069251565006, 17.542474571834],
            [76.33111482498765, 17.59621878152055],
            [76.41968493161419, 17.60371007162483],
            [76.42913158597953, 17.64455625416597],
            [76.37823101777867, 17.66081359373601],
            [76.37851547507887, 17.68666484139182],
            [76.35625406334367, 17.69785230797746],
            [76.31635980815827, 17.69812029004172],
            [76.29463009490426, 17.7297892652215],
            [76.26788571725142, 17.72954366067308],
            [76.24014546402258, 17.69737177268603],
            [76.18790404679937, 17.68321192555117],
            [76.14589340250446, 17.69981271906625],
            [76.14710603698397, 17.71648221445776],
            [76.17517068697511, 17.7297062936638],
            [76.14740122563977, 17.73412629713886],
            [76.12932571660961, 17.76774455644403],
            [76.08449801290931, 17.77781150469947],
            [76.00265227636395, 17.75034732522947],
            [76.01980163717081, 17.82838889476032],
            [75.98056403306992, 17.84379105105661],
            [75.96598177900468, 17.81815642787296],
            [75.93932707992923, 17.85243624057695],
            [75.91098450170078, 17.83279834078591],
            [75.87501445244635, 17.84642513255976],
            [75.84469821354645, 17.89160788874676],
            [75.85125667516871, 17.92211499374575],
            [75.83702346354126, 17.94814456559133],
            [75.85305595148952, 18.00930383902765],
            [75.90840250052732, 18.00357325784647],
            [75.9178100264411, 17.97578021566141],
            [75.97398734718756, 17.97111307618012],
            [76.01872428986077, 18.04215897517783],
            [75.9844397429594, 18.05379248785446],
            [75.98665970151968, 18.08833701583923],
            [75.95559003297939, 18.08578557263855],
            [75.9449713304785, 18.10712714378742],
            [75.93788479682257, 18.12656813055648],
            [75.95709202086994, 18.16101255389068],
            [75.92328023735375, 18.19321227624322],
            [75.94340518153844, 18.24411540401],
            [75.8952110036703, 18.35865620210797],
            [75.79728692658561, 18.38046439999473],
            [75.77078003110948, 18.40859441043328],
            [75.76799137786908, 18.45099263830576],
            [75.72365129554657, 18.43354207631301],
            [75.70644441311839, 18.39629392095479],
            [75.72518017542926, 18.38681158413672],
            [75.71804231079535, 18.33733684345232],
            [75.64727643159691, 18.32968109333914],
            [75.61381342759192, 18.27141182310785],
            [75.62969737556448, 18.26588758099298],
            [75.62858687124337, 18.24288453206304],
            [75.5875747638738, 18.25439293570062],
            [75.56847653113992, 18.23578985401755],
            [75.52540634925386, 18.13090902526097],
            [75.50260033196912, 18.15583958089592],
            [75.48598139335361, 18.15322067341256],
            [75.4865103375204, 18.17382423372278],
            [75.46186611728245, 18.15926087467052],
            [75.42885725422279, 18.17490548359938],
            [75.42931860602746, 18.26133214655798],
            [75.39440339967798, 18.26382815330239],
            [75.40325635033521, 18.32861696508451],
            [75.38697078375789, 18.32775462655548],
            [75.33344713819962, 18.38933410427429],
            [75.28572864335342, 18.40534870299147],
            [75.30121064397377, 18.43075835328233],
            [75.29636820657187, 18.49623261493818],
            [75.31297865526248, 18.51984981284052],
            [75.25890204654372, 18.50829349996444],
            [75.22840739630196, 18.54093884347236]
          ],
          [
            [75.60743420295239, 18.15465695642253],
            [75.61176723171694, 18.16101751294796],
            [75.6144052903368, 18.15060498739742],
            [75.60716150478218, 18.14574844468727],
            [75.60743420295239, 18.15465695642253]
          ]
        ]
      }
    },
    {
      id: '31',
      type: 'Feature',
      properties: {
        Name: 'SUB URBAN MUMBAI',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'SUB URBAN MUMBAI',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '483',
        Shape_Leng: 118691,
        Shape_Area: 418052000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [72.8491802818006, 19.26960960893187],
            [72.82401561457682, 19.24596156225835],
            [72.78383948876454, 19.26506934484014],
            [72.77557590453513, 19.22719089206545],
            [72.78172597150474, 19.19433371785811],
            [72.79544022709393, 19.19533152622281],
            [72.78607302247572, 19.13352079562727],
            [72.80684568187783, 19.15145069078709],
            [72.82869673747292, 19.11661992889383],
            [72.81701339796932, 19.04147410080322],
            [72.83178053983261, 19.05324633521447],
            [72.87922580558357, 19.04764125772816],
            [72.88932127235189, 18.97942586906377],
            [72.95604843110634, 18.98779251527789],
            [72.976460866947, 19.03862321142972],
            [72.96570005926682, 19.09992661894428],
            [72.98112936269217, 19.15560793753802],
            [72.9340625610333, 19.19113203237042],
            [72.93790028292239, 19.21108668103043],
            [72.92030118974309, 19.21349281347072],
            [72.90587978928978, 19.24665312822209],
            [72.8491802818006, 19.26960960893187]
          ]
        ]
      }
    },
    {
      id: '32',
      type: 'Feature',
      properties: {
        Name: 'THANE',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'THANE',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '497',
        Shape_Leng: 438859,
        Shape_Area: 4136100000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.48046770133942, 19.7272757900929],
            [73.37644954579308, 19.68839309674412],
            [73.33081428471955, 19.69513810792015],
            [73.31932513690307, 19.67355375612818],
            [73.28373760675147, 19.69108658592741],
            [73.26747094374925, 19.65190156316049],
            [73.28366313292885, 19.62626649056969],
            [73.2561097135083, 19.63179607004715],
            [73.24730755846929, 19.61027809611938],
            [73.1944831490806, 19.60001730021229],
            [73.20790182228363, 19.55649958376542],
            [73.16801198268645, 19.52247107190344],
            [73.13337522602778, 19.51667879120868],
            [73.13310630785361, 19.50116807303495],
            [73.05708606416715, 19.47898008265806],
            [73.0035808236047, 19.50362668782015],
            [72.98845645801121, 19.48985090570851],
            [72.99393392673473, 19.46676114662811],
            [73.02045285675705, 19.44684792740794],
            [72.94927230740603, 19.379270457619],
            [72.94189512974688, 19.33223853168136],
            [72.9552144630178, 19.30033379356864],
            [72.93714216412823, 19.28932527342706],
            [72.90224346776357, 19.28968622694981],
            [72.86028827650385, 19.32616237670024],
            [72.78585910872373, 19.30637996894285],
            [72.78383948876454, 19.26506934484014],
            [72.82401561457682, 19.24596156225835],
            [72.85780981965566, 19.2688750806874],
            [72.90587978928978, 19.24665312822209],
            [72.92030118974309, 19.21349281347072],
            [72.93790028292239, 19.21108668103043],
            [72.9340625610333, 19.19113203237042],
            [72.98112936269217, 19.15560793753802],
            [72.96570005926682, 19.09992661894428],
            [72.976460866947, 19.03862321142972],
            [72.95604843110634, 18.98779251527789],
            [73.04369348487974, 19.00739385639919],
            [73.04752583032233, 19.099818127062],
            [73.07744798120426, 19.11436658658733],
            [73.13034687533172, 19.10866918425029],
            [73.14341129234039, 19.12744922487379],
            [73.1821459019065, 19.10582435626811],
            [73.19407776392747, 19.12745579338748],
            [73.25073923682973, 19.06177257560858],
            [73.28164312082558, 19.0873650015345],
            [73.3139552795535, 19.0769047988221],
            [73.32200667030592, 19.08698904481314],
            [73.30742831700405, 19.10693411618395],
            [73.35838565690774, 19.13077235585769],
            [73.46744477758617, 19.13548263459563],
            [73.54243596028805, 19.12025554900556],
            [73.53284118022746, 19.15354976386173],
            [73.54582911072879, 19.18709298264494],
            [73.60637404121044, 19.19049584241531],
            [73.60865335415235, 19.21060889368506],
            [73.6299734030768, 19.20571210614828],
            [73.65834242741444, 19.23933488215738],
            [73.69326731473035, 19.25146960281813],
            [73.66926445825874, 19.30516741513888],
            [73.7468667428747, 19.33723382003748],
            [73.74715701758349, 19.31814770610872],
            [73.77170814856119, 19.34237560052394],
            [73.79325106009378, 19.33378710391168],
            [73.77798211804789, 19.38724114091083],
            [73.7359210454597, 19.40754271902648],
            [73.73071695765813, 19.4302312656583],
            [73.68460197152693, 19.44480228098449],
            [73.70798859265736, 19.49605415055542],
            [73.68628628898807, 19.50014619693977],
            [73.67962101320785, 19.51875738674885],
            [73.66456673909863, 19.51211551846784],
            [73.65692716630893, 19.53683673822368],
            [73.62260878398264, 19.54207897425602],
            [73.61400096145144, 19.59548214575224],
            [73.57492200616632, 19.60215782270646],
            [73.58120751762671, 19.61295411125291],
            [73.56328402174411, 19.61847845334681],
            [73.52854639498455, 19.69772812689152],
            [73.48046770133942, 19.7272757900929]
          ]
        ]
      }
    },
    {
      id: '33',
      type: 'Feature',
      properties: {
        Name: 'WARDHA',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'WARDHA',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '498',
        Shape_Leng: 494888,
        Shape_Area: 6083170000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [78.09428021755183, 21.35466719472108],
            [78.07424951832405, 21.35378553476044],
            [78.06889621646441, 21.29836707713373],
            [78.08046364575443, 21.28158568582728],
            [78.0615772019757, 21.27745025920766],
            [78.05252307270274, 21.25485389223415],
            [78.09677726515963, 21.19887159913013],
            [78.09156363918089, 21.17951413077805],
            [78.14350091768144, 21.13987646466724],
            [78.12834453793646, 21.11444666143159],
            [78.1504899861733, 21.07555740365005],
            [78.136203523432, 21.03817979554139],
            [78.14280534831177, 20.95297143576292],
            [78.16823732585124, 20.94187471007255],
            [78.18293902604388, 20.90373590901741],
            [78.21320082761918, 20.90859830530522],
            [78.25747680571772, 20.8868107351396],
            [78.29238019078677, 20.82791666126764],
            [78.31176414374544, 20.83374145095382],
            [78.3172209122439, 20.8203593975384],
            [78.29349594322757, 20.79997531022087],
            [78.3116875519628, 20.73802407610863],
            [78.29979873373395, 20.70235613286089],
            [78.27721488246328, 20.69858781542396],
            [78.24866599018027, 20.64549487909702],
            [78.27998565733678, 20.56023958113805],
            [78.40992550111434, 20.51194359164534],
            [78.50854785441037, 20.52314847516928],
            [78.56377230222843, 20.43959649906555],
            [78.64832290368336, 20.43446961694978],
            [78.64547922741586, 20.42022437524762],
            [78.70824694144265, 20.34981432990692],
            [78.70614416268086, 20.31225209914809],
            [78.73825629832345, 20.2937896687739],
            [78.7987735772905, 20.29956198372457],
            [78.83053213516517, 20.32154542701263],
            [78.81638260607205, 20.39141689305805],
            [78.852042044592, 20.41540212742821],
            [78.83425449058224, 20.42555589641238],
            [78.84232017498796, 20.43428290334489],
            [78.85705874521143, 20.42107455789351],
            [78.89883950358853, 20.4375999822269],
            [78.95318959638189, 20.42878989687081],
            [78.96686838876599, 20.46049631235867],
            [78.98734605431555, 20.46575077951326],
            [79.00039650431442, 20.45083949451554],
            [79.02295049774226, 20.4833396499718],
            [79.11975353681356, 20.45126648804775],
            [79.21763802972727, 20.55261135349993],
            [79.2197802153819, 20.59070736810749],
            [79.18889830609174, 20.59915677051926],
            [79.14276243320178, 20.6790487539708],
            [79.10521423671973, 20.68794028008459],
            [79.10336595544338, 20.71568530448658],
            [78.9424316526188, 20.76665752156015],
            [78.94538549451072, 20.79373746823281],
            [78.91186129588347, 20.80849550191796],
            [78.91285250470469, 20.83599187267911],
            [78.88360550548838, 20.84360177203558],
            [78.87400640214243, 20.82992706495057],
            [78.8606443696878, 20.84162170729105],
            [78.85096802301081, 20.88624052491213],
            [78.78563431320435, 20.89010128390862],
            [78.77302433716999, 20.90409006972074],
            [78.78228723533029, 20.91124076993673],
            [78.7332085377189, 20.9463042829158],
            [78.72657313490485, 21.00416861654288],
            [78.60704343488688, 21.06961697560294],
            [78.59932673361753, 21.10806854785179],
            [78.55495195397589, 21.11677270648588],
            [78.47713005150702, 21.21974451202799],
            [78.33139521118615, 21.25000768220192],
            [78.32778508735807, 21.27126687212482],
            [78.30344994694558, 21.27549500629225],
            [78.31264580187407, 21.2945772552941],
            [78.29416173514988, 21.29313133621147],
            [78.25728459308702, 21.32996109373972],
            [78.15583346310531, 21.33161996292809],
            [78.09428021755183, 21.35466719472108]
          ]
        ]
      }
    },
    {
      id: '34',
      type: 'Feature',
      properties: {
        Name: 'WASH|M',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'WASH|M',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '499',
        Shape_Leng: 600302,
        Shape_Area: 4955810000
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [77.58058546231057, 20.72677692189203],
              [77.57304488021403, 20.70537242355159],
              [77.52623823241812, 20.70118423048559],
              [77.54324386397406, 20.67827624918406],
              [77.51385314328559, 20.68169151924858],
              [77.51084220971696, 20.66441169855881],
              [77.48101205242914, 20.68204503201484],
              [77.47859125536776, 20.65515441295469],
              [77.43088686476857, 20.66225770503426],
              [77.46707129687012, 20.61091101280033],
              [77.41086833496263, 20.60691994050108],
              [77.40925933484785, 20.58707381410257],
              [77.36567017272927, 20.58338308254987],
              [77.36208347565848, 20.56763557386966],
              [77.33944297287165, 20.57526447498373],
              [77.33633718638335, 20.525784021623],
              [77.39566618102306, 20.52544052483838],
              [77.38898102200926, 20.50169668946033],
              [77.36792845410065, 20.48002513817434],
              [77.36805266068711, 20.49652987356852],
              [77.32747645441135, 20.49797421149171],
              [77.34342695142635, 20.47163592444888],
              [77.29803433624669, 20.44586694740168],
              [77.29379042435102, 20.42070929973591],
              [77.27770751650245, 20.42363412872067],
              [77.26630209886275, 20.45860359261634],
              [77.22957177059938, 20.4733945911866],
              [77.22517184375378, 20.4474121286802],
              [77.18555062828814, 20.44738454654691],
              [77.19724420754096, 20.42222002434836],
              [77.18506664355458, 20.39840851373158],
              [77.15151996687452, 20.39913853967116],
              [77.14205681330496, 20.38015195253921],
              [77.12021150329291, 20.41110111425395],
              [77.07961146024344, 20.423857964134],
              [77.0811526326567, 20.38894528949407],
              [77.06245792940138, 20.38135734288455],
              [77.04533422308623, 20.38655067429498],
              [77.05902415461702, 20.44537180108073],
              [77.02231423285365, 20.44991912054898],
              [77.014481175431, 20.41271495094612],
              [76.99357978833183, 20.40904138428825],
              [76.97798508573963, 20.37034845777727],
              [76.93617240460259, 20.37061206621399],
              [76.90477787315895, 20.3444825476736],
              [76.8915487909073, 20.31702096621313],
              [76.90883310245151, 20.31311142843162],
              [76.88020888441487, 20.27970471574604],
              [76.85825001428594, 20.29937097425125],
              [76.83775791091564, 20.29604661285477],
              [76.8201117830114, 20.27988635264488],
              [76.81092649399204, 20.21932995815808],
              [76.78470331128072, 20.20321692618631],
              [76.74678205497696, 20.20672403981466],
              [76.7574201445942, 20.13111174051671],
              [76.66892833372476, 20.1261085115011],
              [76.64845809541038, 20.06956368148763],
              [76.6304610836785, 20.0822080833676],
              [76.62402883392222, 20.05125249488526],
              [76.66309972060213, 20.04755912050505],
              [76.6455003778169, 19.98466053431547],
              [76.6608133805347, 19.9765881495155],
              [76.63450988616198, 19.95638167727382],
              [76.62838952411265, 19.92548900165744],
              [76.60674038098738, 19.92479738660649],
              [76.61098102492747, 19.89309373561178],
              [76.65438679901719, 19.90050801350542],
              [76.64712834795911, 19.86700135451328],
              [76.6812030667556, 19.84699121563253],
              [76.69294865597196, 19.8740006273452],
              [76.74026621017852, 19.87331115622772],
              [76.74714844205259, 19.91230625835822],
              [76.76540139121194, 19.90440575895941],
              [76.7722891200375, 19.93577546331059],
              [76.82135870950366, 19.92919911305107],
              [76.83728473131686, 19.96390865124513],
              [76.89538096399734, 19.94913345526356],
              [76.92234719969177, 19.97586668504514],
              [76.98834823992378, 19.99806629984777],
              [76.99495494556847, 20.01762948448022],
              [77.06162820042869, 19.99388755311353],
              [77.10229567071974, 19.93146748808672],
              [77.20294242142283, 19.99019143325443],
              [77.21488698535597, 19.97331946943102],
              [77.20549206079538, 19.94211400601701],
              [77.23822152329831, 19.93453085036052],
              [77.23908052074768, 19.88968755542176],
              [77.26628918004498, 19.89763879261494],
              [77.27115676949917, 19.91957834948698],
              [77.2835542638436, 19.91269978045253],
              [77.30380553320653, 19.9653321566339],
              [77.32193593221149, 19.95924951148969],
              [77.33720907091656, 19.9746386668992],
              [77.34083489907208, 20.00840864009298],
              [77.3725972898726, 20.04688605351619],
              [77.35243417201366, 20.06431524858982],
              [77.36484397953406, 20.09833141654845],
              [77.45947848558556, 20.0693629511462],
              [77.52482343183931, 20.09808834775688],
              [77.58067230332962, 20.028832014207],
              [77.62998724499904, 20.04529237165999],
              [77.66894397080296, 20.10193563150255],
              [77.67946502212247, 20.16668799525091],
              [77.64425278884397, 20.18694802529525],
              [77.66543392847656, 20.24739883632891],
              [77.61033269586362, 20.26408513261858],
              [77.58435709741104, 20.32696111841832],
              [77.56747130042721, 20.32962930330299],
              [77.5719316224686, 20.38787452064444],
              [77.58142007251763, 20.4152671015397],
              [77.59576039747526, 20.41233946032092],
              [77.59627257319305, 20.44819040561422],
              [77.61357828847605, 20.46102809419764],
              [77.64285909167445, 20.45033563826774],
              [77.65338063713574, 20.49788688870942],
              [77.69071192567219, 20.53400796707023],
              [77.64293329331105, 20.53169276424514],
              [77.65040434758409, 20.56398282922471],
              [77.62807275772673, 20.56660306234746],
              [77.65971581378689, 20.64619184594873],
              [77.65399173951236, 20.66187088241533],
              [77.63466580279267, 20.65822896943785],
              [77.63401841951143, 20.71288486297968],
              [77.58058546231057, 20.72677692189203]
            ]
          ],
          [
            [
              [77.63384675359312, 20.75441379322116],
              [77.61981715655769, 20.7570333990732],
              [77.61212904950986, 20.73074968726346],
              [77.63146686348789, 20.73807119291505],
              [77.63384675359312, 20.75441379322116]
            ]
          ]
        ]
      }
    },
    {
      id: '35',
      type: 'Feature',
      properties: {
        Name: 'YAVATMAL',
        description: null,
        timestamp: null,
        begin: null,
        end: null,
        altitudeMode: null,
        tessellate: -1,
        extrude: 0,
        visibility: -1,
        drawOrder: null,
        icon: null,
        District: 'YAVATMAL',
        STATE: 'MAHARASHTRA',
        REMARKS: '',
        State_LGD: '27',
        DISTRICT_L: '500',
        Shape_Leng: 928990,
        Shape_Area: 13121600000
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [78.27491288777885, 20.69638970572214],
            [78.25889566203011, 20.69799089638668],
            [78.25521700663114, 20.68359855897279],
            [78.21167333773747, 20.6923223089886],
            [78.20590108556775, 20.67446092643617],
            [78.18220813684867, 20.67799933603801],
            [78.15689816192737, 20.65676840416481],
            [78.12718318923298, 20.66309251257304],
            [78.12938864206666, 20.64744940358176],
            [78.11067496127447, 20.64020467092521],
            [78.09330664311615, 20.64150407329859],
            [78.08866775489912, 20.67205073477971],
            [78.03658214053837, 20.66590050470005],
            [78.02111239787291, 20.62675552812961],
            [77.9954314360708, 20.62460526416277],
            [77.97449635384874, 20.58906471683344],
            [77.93315304212861, 20.57769182983869],
            [77.92470183953759, 20.55913477061534],
            [77.91158912839693, 20.56735529689455],
            [77.91753958039806, 20.60749995761338],
            [77.89480286295874, 20.62582896310311],
            [77.84620202596527, 20.58800975539915],
            [77.83960242321785, 20.56493584566515],
            [77.81071807454147, 20.58475116397734],
            [77.78009868894566, 20.53812566680598],
            [77.6661735759342, 20.57972737269908],
            [77.64293329331105, 20.53169276424514],
            [77.66879412208732, 20.53998409491214],
            [77.68965357198034, 20.52412503220324],
            [77.65338063713574, 20.49788688870942],
            [77.64285909167445, 20.45033563826774],
            [77.61357828847605, 20.46102809419764],
            [77.59627257319305, 20.44819040561422],
            [77.6036987846655, 20.43561736493012],
            [77.57386551115962, 20.40066989035042],
            [77.56733518204608, 20.3451803100064],
            [77.61033269586362, 20.26408513261858],
            [77.66543392847656, 20.24739883632891],
            [77.64425278884397, 20.18694802529525],
            [77.67946502212247, 20.16668799525091],
            [77.66894397080296, 20.10193563150255],
            [77.62998724499904, 20.04529237165999],
            [77.58067230332962, 20.028832014207],
            [77.52482343183931, 20.09808834775688],
            [77.45947848558556, 20.0693629511462],
            [77.36484397953406, 20.09833141654845],
            [77.35243417201366, 20.06431524858982],
            [77.3725972898726, 20.04688605351619],
            [77.34083489907208, 20.00840864009298],
            [77.33720907091656, 19.9746386668992],
            [77.32193593221149, 19.95924951148969],
            [77.30380553320653, 19.9653321566339],
            [77.28439774535208, 19.93708297209467],
            [77.28394747919953, 19.90586834815061],
            [77.31292034454934, 19.91414264462868],
            [77.29528156421425, 19.88432812732464],
            [77.32545310547216, 19.88736109018174],
            [77.36403328637948, 19.858893589792],
            [77.34403047830563, 19.82536154708169],
            [77.38768849896275, 19.82314009151236],
            [77.37764674612981, 19.78684922647734],
            [77.40456674381706, 19.77460292330333],
            [77.38318383398774, 19.76609302855186],
            [77.38439972635986, 19.72581535860604],
            [77.41030352349252, 19.74549645016192],
            [77.4601032764923, 19.68163591649814],
            [77.60639842447686, 19.64861930494339],
            [77.62747960301114, 19.60644590953576],
            [77.6438354125478, 19.60765414995739],
            [77.6487065296231, 19.55817708075501],
            [77.63117405839228, 19.55365015217893],
            [77.69777476342942, 19.53895387318134],
            [77.70576250359373, 19.52214247377366],
            [77.74513814812347, 19.52570681244666],
            [77.7395337702413, 19.48443839212183],
            [77.71192374564241, 19.47791738676294],
            [77.69633410500875, 19.43965905803564],
            [77.75084192470895, 19.43089705665071],
            [77.80680093215905, 19.46453834922913],
            [77.83121821014481, 19.43904122430034],
            [77.84638812744377, 19.45310464968126],
            [77.82484088820492, 19.47759577120099],
            [77.84200943085627, 19.48785578058844],
            [77.8424653991675, 19.51095838679628],
            [77.85936003114954, 19.52242858319837],
            [77.88066171268878, 19.50207809006608],
            [77.90643279501893, 19.5342844668918],
            [77.93897422075122, 19.49743831749173],
            [77.97260987110036, 19.50738759559843],
            [77.9936780202163, 19.45419720160224],
            [78.01501852700635, 19.45578327220293],
            [78.02372568816655, 19.48971028282821],
            [78.0675389775026, 19.45858889086101],
            [78.11092366245369, 19.4818611739149],
            [78.13451570911046, 19.51864969768206],
            [78.12309588742492, 19.55003470851316],
            [78.18816789297124, 19.55834655087363],
            [78.19649480530573, 19.61573114699423],
            [78.17847129685691, 19.65015860191024],
            [78.13031090285212, 19.66450672899841],
            [78.08733841025007, 19.63699129759084],
            [78.05586384103499, 19.66261239249167],
            [78.04867169549594, 19.6900683480898],
            [77.98984911179252, 19.67316631757154],
            [77.94728090154024, 19.73001866923088],
            [77.88984682156975, 19.72591452171664],
            [77.85922707900572, 19.74664367154429],
            [77.84825729086039, 19.79806301500054],
            [77.87409215310517, 19.84633956020415],
            [77.95238418426477, 19.90887756542857],
            [78.05481964435319, 19.92341652066774],
            [78.0749557385215, 19.8957067993638],
            [78.10657376144017, 19.8908083440569],
            [78.14243006133408, 19.91054831861505],
            [78.20428823166276, 19.89842436867342],
            [78.25067100967287, 19.92434895984885],
            [78.2563197126326, 19.90355993316756],
            [78.24116776480571, 19.88395210435828],
            [78.25202089780238, 19.86570608551842],
            [78.27568737860604, 19.87536090833517],
            [78.28320453736882, 19.90573117163682],
            [78.32635677336116, 19.91659068890253],
            [78.32876211929762, 19.88715480357907],
            [78.38067127785756, 19.88043619704263],
            [78.40028218942241, 19.83402765135285],
            [78.43167862561141, 19.8148763493679],
            [78.472459038635, 19.81733826870741],
            [78.49023814945382, 19.79268445633246],
            [78.51526534199787, 19.81902140331586],
            [78.6035658571724, 19.8183650277994],
            [78.69895497437403, 19.7885574074726],
            [78.71970982472192, 19.76653994538316],
            [78.7388695768744, 19.78317759093642],
            [78.78236598459871, 19.77840969923045],
            [78.80435173924768, 19.75625286626613],
            [78.87833845792797, 19.76721019702834],
            [78.87984799742377, 19.7482636918155],
            [78.90067734587662, 19.73734012535369],
            [78.949040132125, 19.75050488285785],
            [78.93764377351329, 19.77873133951242],
            [78.95499084651497, 19.80089775687294],
            [79.0237348129711, 19.80044684821613],
            [79.04329525870848, 19.82205365453909],
            [79.07194387380997, 19.81793270944157],
            [79.1490746267544, 19.89487874404329],
            [79.09111313991663, 19.91764451296842],
            [79.08902488341523, 19.94824313329257],
            [79.10897830034732, 19.97060478562555],
            [79.0920307994139, 19.98231060561316],
            [79.11175110595376, 19.99093104824876],
            [79.10761963958178, 20.0086806558519],
            [79.0820450439352, 20.02484773943122],
            [79.06790271284295, 20.07023996961373],
            [79.04521446985609, 20.06859405841531],
            [79.04749561221358, 20.08702423021429],
            [78.99980421488436, 20.12660390753921],
            [78.97020273302434, 20.12755174734545],
            [78.98120304231368, 20.14997223526836],
            [78.95369424699406, 20.17223089539418],
            [78.96231491021977, 20.20786214506586],
            [78.91997549355528, 20.2542915634208],
            [78.81795686464535, 20.25061518262653],
            [78.81944123687457, 20.27847963570754],
            [78.79974967466478, 20.29934763934368],
            [78.73682432525436, 20.29383532200402],
            [78.70767447770305, 20.31114079565714],
            [78.70824694144265, 20.34981432990692],
            [78.64547922741586, 20.42022437524762],
            [78.64832290368336, 20.43446961694978],
            [78.56377230222843, 20.43959649906555],
            [78.50854785441037, 20.52314847516928],
            [78.40992550111434, 20.51194359164534],
            [78.27998565733678, 20.56023958113805],
            [78.24871675226473, 20.64408920178807],
            [78.27491288777885, 20.69638970572214]
          ]
        ]
      }
    }
  ]
};
